"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[769],{

/***/ 22736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NK": function() { return /* binding */ BelowProductGoogleShopping_PDPContentQuery; },
/* harmony export */   "Pl": function() { return /* binding */ AboveProductStory_PDPContentQuery; },
/* harmony export */   "lD": function() { return /* binding */ ExtendedData_PDPContentQuery; },
/* harmony export */   "lJ": function() { return /* binding */ ProductStoryAdditionalContentSlot_PDPContentQuery; },
/* harmony export */   "v1": function() { return /* binding */ BelowProductStory_PDPContentQuery; }
/* harmony export */ });
/* harmony import */ var groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18273);
/* harmony import */ var groq_documents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96723);
/* harmony import */ var groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28008);



var AboveProductStory_PDPContentQuery = '\n  *[_type == "ProductDetailsPage" && country == upper($country) && product match "*" + $productId][0] {\n    _id,\n    _type,\n    aboveProductStory[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  }\n");
var ProductStoryAdditionalContentSlot_PDPContentQuery = '\n  *[_type == "ProductDetailsPage" && country == upper($country) && product match "*" + $productId][0] {\n    _id,\n    _type,\n    ProductStoryAdditionalContentSlot[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  }\n");
var BelowProductStory_PDPContentQuery = '\n  *[_type == "ProductDetailsPage" && country == upper($country) && product match "*" + $productId][0] {\n    _id,\n    _type,\n    belowProductStory[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  }\n");
var BelowProductGoogleShopping_PDPContentQuery = '\n  *[_type == "ProductDetailsPage" && country == upper($country) && product match "*" + $productId][0] {\n    _id,\n    _type,\n    belowProductGoogleShopping[] '.concat((0,groq_ContentSlots__WEBPACK_IMPORTED_MODULE_0__/* .SlotsGroqQuery */ .e6)(), ",\n  }\n");
var ExtendedData_PDPContentQuery = '\n  *[_type == "ProductDetailsPage" && country == upper($country) && product match "*" + $productId][0] {\n    _id,\n    _type,\n    '.concat((0,groq_objects_CallToActionObject__WEBPACK_IMPORTED_MODULE_2__/* .CallToActionObject */ .U)("ctaAboveSpecialMessage[]"), ",\n    soldOutRecommender[] -> {\n      ").concat((0,groq_documents__WEBPACK_IMPORTED_MODULE_1__/* .ProductRecommenderDocument */ .Qy)('_type == "ProductRecommender" =>'), ",\n      ").concat((0,groq_documents__WEBPACK_IMPORTED_MODULE_1__/* .ProductCarouselDocument */ .en)('_type == "ProductCarousel" =>'), ",\n    },\n    ").concat((0,groq_documents__WEBPACK_IMPORTED_MODULE_1__/* .SignUpFormDocument */ .z1)("comingSoonSignUpForm ->"), ",\n  }\n");


/***/ }),

/***/ 46660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k8": function() { return /* binding */ firePreviousAndCurrentGA4ScrollEvents; },
  "F": function() { return /* binding */ useGA4ScrollEvents; }
});

// UNUSED EXPORTS: checkAndFireGA4ScrollEvent

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useOnRouterChangeStart.ts
var useOnRouterChangeStart = __webpack_require__(97491);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var esm = __webpack_require__(68138);
;// CONCATENATED MODULE: ./hooks/useWindowScroll.ts
// source -> https://github.com/uidotdev/usehooks/blob/dfa6623fcc2dcad3b466def4e0495b3f38af962b/index.js#L1310
// docs -> https://usehooks.com/usewindowscroll


var useWindowScroll = function() {
    var ref = (0,react.useState)({
        x: null,
        y: null
    }), state = ref[0], setState = ref[1];
    var scrollTo = (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (typeof args[0] === "object") {
            window.scrollTo(args[0]);
        } else if (typeof args[0] === "number" && typeof args[1] === "number") {
            window.scrollTo(args[0], args[1]);
        }
    }, []);
    (0,esm/* useIsomorphicLayoutEffect */.LI)(function() {
        var handleScroll = function() {
            setState({
                x: window.scrollX,
                y: window.scrollY
            });
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return [
        state,
        scrollTo
    ];
}; // usage: `const [{ x, y }, scrollTo] = useWindowScroll();`

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(45746);
;// CONCATENATED MODULE: ./hooks/useScrollPagePercentage.ts




var getScrollOnPagePercentage = function(param) {
    var windowHeight = param.windowHeight, scrollY = param.scrollY;
    var documentHeight = document.body.scrollHeight;
    var scrollPercentage = scrollY / (documentHeight - windowHeight) * 100;
    return Math.min(Math.max(Math.round(scrollPercentage), 0), 100);
};
var useScrollPagePercentage = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(useWindowScroll(), 1), ref1 = ref[0], scrollY = ref1.y;
    var ref2 = (0,useWindowSize/* useWindowSize */.i)(), windowHeight = ref2.height;
    var ref3 = (0,react.useState)(0), scrollPagePercentage = ref3[0], setScrollPagePercentage = ref3[1];
    (0,react.useEffect)(function() {
        if (scrollY !== null && windowHeight !== null) {
            setScrollPagePercentage(getScrollOnPagePercentage({
                windowHeight: windowHeight,
                scrollY: scrollY
            }));
        }
    }, [
        scrollY,
        windowHeight
    ]);
    return scrollPagePercentage;
}; // usage: `const scrollPagePercentage = useScrollPagePercentage();`

;// CONCATENATED MODULE: ./hooks/useGA4ScrollEvents.tsx








var useGA4ScrollEvents = function() {
    var scrollPagePercentage = useScrollPagePercentage();
    var ref = (0,usePageEventsContext/* usePageEventsContext */.qN)(), pageviewEventHasFired = ref.pageviewEventHasFired, eventHasFired = ref.eventHasFired, setEventFired = ref.setEventFired;
    var ref1 = (0,react.useState)(undefined), currentPercentage = ref1[0], setCurrentPercentage = ref1[1];
    (0,useOnRouterChangeStart/* useOnRouterChangeStart */.k)((0,react.useCallback)(function() {
        if (pageviewEventHasFired) {
            // when page start to change -> reset current percentage
            // this avoid problems of fire again the events previously cleaned on pageEventContext
            setCurrentPercentage(undefined);
        }
    }, [
        pageviewEventHasFired
    ]));
    (0,react.useEffect)(function() {
        if (pageviewEventHasFired) {
            // get the "current" percentage from the percentages (25, 50, 75, 100)
            var percentageToFire = (0,_to_consumable_array/* default */.Z)(constants/* SCROLL_GA4_EVENT_PERCENTAGES */.Zp).reverse().find(function(percentage) {
                return scrollPagePercentage >= parseInt(percentage) ? percentage : null;
            });
            setCurrentPercentage(percentageToFire);
        }
    }, [
        scrollPagePercentage,
        pageviewEventHasFired
    ]);
    (0,react.useEffect)(function() {
        if (pageviewEventHasFired) {
            // only call function when the current percentage changes (undefined, 25, 50, 75, 100)
            if (currentPercentage) {
                firePreviousAndCurrentGA4ScrollEvents({
                    percentage: currentPercentage,
                    eventHasFired: eventHasFired,
                    setEventFired: setEventFired
                });
            }
        }
    }, [
        currentPercentage,
        eventHasFired,
        setEventFired,
        pageviewEventHasFired
    ]);
};
// declare here to allow to be used from another files - ex. load-more-button
var firePreviousAndCurrentGA4ScrollEvents = function(param) {
    var percentage = param.percentage, eventHasFired = param.eventHasFired, setEventFired = param.setEventFired;
    var ctxFunctions = {
        setEventFired: setEventFired,
        eventHasFired: eventHasFired
    };
    switch(percentage){
        case "25":
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "25"
            }, ctxFunctions));
            break;
        case "50":
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "25"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "50"
            }, ctxFunctions));
            break;
        case "75":
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "25"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "50"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "75"
            }, ctxFunctions));
            break;
        case "100":
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "25"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "50"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "75"
            }, ctxFunctions));
            checkAndFireGA4ScrollEvent((0,_object_spread/* default */.Z)({
                percentage: "100"
            }, ctxFunctions));
            break;
    }
};
var checkAndFireGA4ScrollEvent = function(param) {
    var eventHasFired = param.eventHasFired, setEventFired = param.setEventFired, percentage = param.percentage;
    if (!eventHasFired(constants/* SCROLL_GA4_EVENT_PERCENTAGE_STRING */.F[percentage])) {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.SCROLL */._q.SCROLL,
            event_params: {
                percent_scrolled: percentage
            }
        });
        setEventFired(constants/* SCROLL_GA4_EVENT_PERCENTAGE_STRING */.F[percentage]);
    }
};


/***/ }),

/***/ 16666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useGetRecommenderLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79302);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);




var useGetRecommenderLocation = function() {
    var locale = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)().locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var recommenderPath = (0,utils_locale__WEBPACK_IMPORTED_MODULE_2__/* .removeLocalePrefix */ .g5)(router.asPath, locale);
        var pdpMatcher = /^\/pd\/.*/;
        if (recommenderPath === "") return "home";
        if (pdpMatcher.test(recommenderPath)) return "pdp";
        return recommenderPath;
    }, [
        locale,
        router.asPath
    ]);
};


/***/ }),

/***/ 42833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useHorizontalScroll; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _useResizeObserver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13765);



var useHorizontalScroll = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _infinite = ref.infinite, infinite = _infinite === void 0 ? true : _infinite;
    var ref1 = (0,_useResizeObserver__WEBPACK_IMPORTED_MODULE_1__/* .useResizeObserver */ .y)(), ref2 = ref1.ref, width = ref1.width;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        hasPrev: !!infinite,
        hasNext: !!infinite,
        overflowing: false
    }), state = ref3[0], setState = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var scroller = ref2.current;
        var update = function() {
            return setState({
                hasPrev: infinite || scroller.scrollLeft != 0,
                hasNext: infinite || Math.ceil(scroller.scrollLeft) + scroller.offsetWidth + 1 < scroller.scrollWidth,
                overflowing: scroller.scrollWidth > scroller.clientWidth
            });
        };
        if (ref2.current) {
            update();
            scroller.addEventListener("scroll", update);
        }
    }, [
        ref2,
        width,
        infinite
    ]);
    var next = function() {
        var scroller = ref2.current;
        var scrollByAmount = scroller.offsetWidth;
        if (Math.ceil(scroller.scrollLeft) + scrollByAmount + 1 < scroller.scrollWidth) {
            scroller.scrollBy({
                left: scroller.offsetWidth,
                top: 0,
                behavior: "smooth"
            });
        } else if (infinite) scroller.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth"
        });
    };
    var prev = function() {
        var scroller = ref2.current;
        var scrollByAmount = scroller.offsetWidth;
        if (scroller.scrollLeft != 0) {
            scroller.scrollBy({
                left: -scrollByAmount,
                top: 0,
                behavior: "smooth"
            });
        } else if (infinite) scroller.scrollTo({
            left: scroller.scrollWidth,
            top: 0,
            behavior: "smooth"
        });
    };
    var scrollToSelected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(whereToScroll) {
        var scroller = ref2.current;
        var scrollByAmount = scroller === null || scroller === void 0 ? void 0 : scroller.offsetWidth;
        scroller === null || scroller === void 0 ? void 0 : scroller.scrollTo({
            left: scrollByAmount * whereToScroll,
            top: 0,
            behavior: "auto"
        });
    }, [
        ref2
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        ref: ref2,
        next: next,
        prev: prev,
        scrollToSelected: scrollToSelected
    }, state);
};


/***/ }),

/***/ 50641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useInView; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64724);
/* harmony import */ var _useIntersectionObserver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69340);



var useInView = function() {
    var isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_1__/* .useIsServer */ .w)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isServer), inView = ref[0], setInView = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_2__/* .useIntersectionObserver */ .S)(ref1, function() {
        return setInView(true);
    }, true, {
        threshold: 0.01,
        rootMargin: "0px 0px 20% 0px"
    });
    return [
        ref1,
        inView
    ];
};


/***/ }),

/***/ 35538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useItemListViewEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83168);
/* harmony import */ var utils_deepEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48604);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43308);




var useItemListViewEvent = function(param) {
    var itemListId = param.itemListId, itemListName = param.itemListName, itemIdEp = param.itemIdEp, itemNameEp = param.itemNameEp, items = param.items;
    var previousItemsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_2__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var alreadyExecuted = (0,utils_deepEqual__WEBPACK_IMPORTED_MODULE_3__/* .areDeepEqual */ .A)(previousItemsRef.current, items);
        if (!itemListId || !itemListName || !(items === null || items === void 0 ? void 0 : items.length) || alreadyExecuted || !pageviewEventHasFired) {
            return;
        }
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .AnalyticsEvents.GA4EC_ItemListView */ ._q.GA4EC_ItemListView, {
            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .AnalyticsEvents.VIEW_ITEM_LIST */ ._q.VIEW_ITEM_LIST,
            ecommerce: {
                item_list_id: itemListId,
                item_list_name: itemListName,
                item_id_ep: itemIdEp,
                item_name_ep: itemNameEp,
                items: items
            }
        });
        previousItemsRef.current = items;
    }, [
        itemListId,
        itemListName,
        itemIdEp,
        itemNameEp,
        items,
        pageviewEventHasFired, 
    ]);
};


/***/ }),

/***/ 8623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5341);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83168);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37678);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72507);
/* harmony import */ var _useCart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69771);
/* harmony import */ var _useFeature__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53625);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43308);
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20368);










/**
 * Used to register a pageview analytic event for the current page.
 * @param fetching Set to false (default) if the document title does not rely on dynamic data
 */ var usePageview = function() {
    var fetching = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, pageTypeOverride = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__/* .usePageEventsContext */ .qN)(), setPageviewEventHasFired = ref4.setPageviewEventHasFired, pageviewEventHasFired = ref4.pageviewEventHasFired, userConsent = ref4.userConsent, cartEventFired = ref4.cartEventFired, setCartEventFired = ref4.setCartEventFired;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevPath = ref5[0], setPrevPath = ref5[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref6 = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)(), countryCode = ref6.countryCode, language = ref6.language, oneTrustApiKey = ref6.env.oneTrustApiKey;
    var ref7 = (0,_useAuth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), customerId = ref7.customerId, guest = ref7.guest;
    var cart = (0,_useCart__WEBPACK_IMPORTED_MODULE_5__/* .useCart */ .j)().cart;
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useMeQuery */ .UEB)({
        pause: guest
    }), 1), meResult = ref8[0];
    var showCookieConsentLayer = (0,_useFeature__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .S)("SHOW_COOKIE_CONSENT_LAYER");
    var triggerCartTotalEvent = (0,_useFeature__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .S)("TRIGGER_CART_TOTAL_EVENT");
    var _cookieConsentApiKey = oneTrustApiKey !== null && oneTrustApiKey !== void 0 ? oneTrustApiKey : "";
    // We should validate the user consent to if we have OT api key and show the banner
    var validateWithUserConsent = !(!_cookieConsentApiKey || !showCookieConsentLayer);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        var splittedPath = router.asPath.split("?")[0];
        var path = router.asPath.includes("&") ? splittedPath : router.asPath;
        var customerEmail = (ref = meResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.email;
        var customerNum = (ref2 = meResult.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.me) === null || ref3 === void 0 ? void 0 : ref3.customerNo;
        var analyticsData = {
            pageTitle: document.title,
            searchQuery: router.query.searchQuery,
            country: countryCode,
            language: language,
            customerId: customerId !== null && customerId !== void 0 ? customerId : "",
            customerAuth: !guest,
            customerEmail: customerEmail || undefined,
            customerNo: customerNum || undefined,
            cart: (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .toAnalyticsCart */ .Ry)(cart),
            currentURL: document.URL
        };
        if (!fetching && (cart || cart === null) && !cartEventFired && triggerCartTotalEvent && pageviewEventHasFired) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .sessionCartTotalEvent */ .kF)(cart === null || cart === void 0 ? void 0 : cart.subTotal);
            setCartEventFired(true);
        }
        // Ensure the pageview does not get registered twice by comparing the current path to the pageview path
        if (!guest && !customerEmail) return;
        if (validateWithUserConsent) {
            if (!fetching && path !== prevPath && customerId && userConsent) {
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .pageview */ .LV)(router.asPath, analyticsData, pageTypeOverride);
                setPageviewEventHasFired(true);
                setPrevPath(path);
            }
        } else if (!fetching && path !== prevPath && customerId) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .pageview */ .LV)(router.asPath, analyticsData, pageTypeOverride);
            setPageviewEventHasFired(true);
            setPrevPath(path);
        }
    }, [
        cart,
        countryCode,
        customerId,
        fetching,
        guest,
        language,
        pageTypeOverride,
        prevPath,
        router.asPath,
        router.query.searchQuery,
        setPageviewEventHasFired,
        userConsent,
        validateWithUserConsent,
        cartEventFired,
        setCartEventFired,
        triggerCartTotalEvent,
        (ref = meResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.email,
        (ref2 = meResult.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.me) === null || ref3 === void 0 ? void 0 : ref3.customerNo,
        pageviewEventHasFired, 
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageview);


/***/ }),

/***/ 41316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ PdpProvider; },
  "Y": function() { return /* binding */ usePdp; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./groq/pages/ProductDetailsPage.ts
var ProductDetailsPage = __webpack_require__(22736);
// EXTERNAL MODULE: ./groq/pages/ProductDetailsPageTemplate.ts
var ProductDetailsPageTemplate = __webpack_require__(55723);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
;// CONCATENATED MODULE: ./utils/filterProductComparison.ts
// This function processes a given content slot and ensures that only one
//  product comparison remains. Additionally, it verifies that the retained
// product comparison includes more than one visible product.
var hasMultipleVisibleProducts = function(products) {
    return ((products === null || products === void 0 ? void 0 : products.filter(function(product) {
        return product === null || product === void 0 ? void 0 : product.visible;
    }).length) || 0) >= 2;
};
var filterProductComparison = function(data) {
    var comparisonTypes = new Set([
        "ProductComparison",
        "AutomatedProductComparison", 
    ]);
    var hasAddedComparison = false;
    var filteredStory = data === null || data === void 0 ? void 0 : data.filter(function(slot) {
        var ref;
        var componentType = (ref = slot.component) === null || ref === void 0 ? void 0 : ref._type;
        var isComparisonType = comparisonTypes.has(componentType);
        if (!isComparisonType) return true; // Keep non-comparison components
        var component = slot.component;
        if (!hasAddedComparison && hasMultipleVisibleProducts(component.products)) {
            hasAddedComparison = true;
            return true;
        }
        return false;
    });
    return filteredStory;
};

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./hooks/useEmarsysWebExtend.tsx + 2 modules
var useEmarsysWebExtend = __webpack_require__(78108);
// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
;// CONCATENATED MODULE: ./hooks/usePdp.tsx
















var isGoogleShoppingLink = function(url) {
    return url.includes("gclid");
};
var PdpContext = /*#__PURE__*/ (0,react.createContext)(null);
var PdpProvider = function(param) {
    var children = param.children;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var hasSentAnalytics = (0,react.useRef)(false);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useTrackProductViewMutation */.OKS)(), 2), trackProductView = ref4[1];
    var reviewsEnabled = (0,useFeature/* useFeature */.S)("RATINGS_AND_REVIEWS");
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var ref5 = (0,react.useState)(), addToCartError = ref5[0], setAddToCartError = ref5[1];
    var ref6 = (0,react.useState)(), addToCartReturnCode = ref6[0], setAddToCartReturnCode = ref6[1];
    var ref7 = (0,react.useState)(1), quantity = ref7[0], setQuantity = ref7[1];
    var ref8 = (0,react.useState)(false), sizeHasChanged = ref8[0], setSizeHasChanged = ref8[1];
    var desiredProductId = router.query.id;
    var desiredModel = router.query.model;
    var viewAt = router.query.viewAt;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,graphql/* usePixleeConfigQuery */.QW$)(), 1), pixleeConfigResponse = ref9[0];
    var pixleeConfig = (ref = pixleeConfigResponse.data) === null || ref === void 0 ? void 0 : ref.pixleeConfig;
    var trackPdp = (0,useEmarsysWebExtend/* useEmarsysWebExtend */._)().trackPdp;
    /**
   * We use requestPolicy: cache-first to not trigger this query duplicated in SSR, because we've added in Pdp.getInitialProps as well to be able to parallelized.
   * urql or useQuery internally adds a getInitialProps fc every time we call it, so this was the only manner to parallelized this query without duplicate it.
   */ var ref10 = (0,_sliced_to_array/* default */.Z)((0,graphql/* usePdpQuery */.zMd)({
        variables: {
            id: desiredProductId,
            viewAt: viewAt
        },
        pause: !desiredProductId,
        requestPolicy: "cache-first"
    }), 2), productQuery = ref10[0], refetch = ref10[1];
    /**
   * This query is the result of splitting the original PDP query, aiming to reduce its latency, requesting only what is necessary for the initial render.
   * Only must be executed on SSR if the user is a crawler.
   * On this we request Variations data: description, sizeGroups and productStory.
   * We use requestPolicy: 'cache-and-network' to display the data quickly while keeping up-to-date.
   */ var ref11 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useLazyPdpQuery */.l6q)({
        variables: {
            id: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler || !isCrawler && (productQuery.fetching || typeof productQuery.fetching === "undefined" || !((ref1 = productQuery.data) === null || ref1 === void 0 ? void 0 : ref1.product)),
        requestPolicy: "cache-and-network"
    }), 1), lazyProductQuery = ref11[0];
    /**
   * We refetch the pdp query on CSR with requestPolicy:'cache-and-network' to keep the Product Information up-to-date.
   */ (0,react.useEffect)(function() {
        // We've inferred that PDP query is being blocked in CSR as in Google Search Console returns a 404 not found page.
        // To prevent trying to update 'masterProduct', we refetch pdp only when user is not a Crawler, since they do not need the updated content.
        if (!isCrawler) {
            refetch({
                requestPolicy: "cache-and-network"
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var masterProduct = (ref2 = productQuery.data) === null || ref2 === void 0 ? void 0 : ref2.product;
    var isFetching = productQuery.fetching;
    var isQueryStale = productQuery.stale;
    if (lazyProductQuery.data && !lazyProductQuery.fetching) {
        masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.forEach(function(variation) {
            var ref, ref1;
            var lazyProductData = (ref = lazyProductQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.variations.find(function(lazyVariation) {
                return variation.id === lazyVariation.id;
            });
            if (lazyProductData) {
                variation["description"] = lazyProductData.description;
                variation["productStory"] = lazyProductData.productStory;
                variation["sizeGroups"] = lazyProductData.sizeGroups;
            }
        });
    }
    var desiredSwatch = router.query.swatch || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations[0].colorValue);
    var hasDesiredProductIdAndSwatch = Boolean(desiredProductId && desiredSwatch);
    // Updates the variation when desiredSwatch changes
    var variation = (0,react.useMemo)(function() {
        if (isFetching && !isQueryStale) return undefined;
        var variations = (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations) || [];
        if (!masterProduct || variations.length === 0) {
            if (hasDesiredProductIdAndSwatch) (0,ga4Items/* removeGa4ItemFromMap */.EI)("".concat(desiredProductId, "_").concat(desiredSwatch));
            return undefined;
        }
        // return the requested swatch, if available
        if (desiredSwatch) {
            var variation = variations.find(function(x) {
                return x.colorValue === desiredSwatch;
            });
            if (variation) return variation;
        }
        // if no swatch was requested (url params) or found, try to return the first orderable swatch
        // if no orderable swatches return the first swatch
        var foundVariation = variations.find(function(v) {
            return v.orderable;
        }) || variations[0];
        if (foundVariation) {
            var oldGa4Item = hasDesiredProductIdAndSwatch && (0,ga4Items/* getGa4Item */.Vr)("".concat(desiredProductId, "_").concat(desiredSwatch));
            if (oldGa4Item) (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(desiredProductId, "_").concat(foundVariation.colorValue), {
                lid: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.lid,
                lname: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.lname,
                idx: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.idx,
                cname: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.cname,
                cslot: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.cslot,
                pid: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.pid,
                pname: oldGa4Item === null || oldGa4Item === void 0 ? void 0 : oldGa4Item.pname
            });
        }
        if (hasDesiredProductIdAndSwatch) (0,ga4Items/* removeGa4ItemFromMap */.EI)("".concat(desiredProductId, "_").concat(desiredSwatch));
        return foundVariation;
    }, [
        isQueryStale,
        isFetching,
        desiredProductId,
        desiredSwatch,
        masterProduct,
        hasDesiredProductIdAndSwatch, 
    ]);
    var desiredSize = router.query.size;
    // Feature flag to allow simplified view for urls with Google Shopping indicator
    // in them ('&gclid=someValue')
    var enableGoogleShopping = (0,useFeature/* useFeature */.S)("SHOW_SIMPLIFIED_PDP_FOR_GOOGLE_SHOPPING");
    var pageLayout = (0,react.useMemo)(function() {
        var ref;
        if (enableGoogleShopping && isGoogleShoppingLink(router.asPath)) {
            return "simplified";
        }
        if (masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.soldoutWithRecommender) {
            return "soldoutWithRecommender";
        }
        if (!variation) return "noVariant";
        return "full";
    }, [
        variation,
        masterProduct,
        enableGoogleShopping,
        router.asPath
    ]);
    var referrerCategoryId = (0,react.useRef)();
    if (!constants/* isServer */.sk) {
        var ref12;
        referrerCategoryId.current = (ref12 = window.localStorage.getItem(constants/* REFERRER_CATEGORY */.qh)) !== null && ref12 !== void 0 ? ref12 : undefined;
    }
    // Content PDP Template Queries
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "AboveProductStory_PDPTemplate",
        query: ProductDetailsPageTemplate/* AboveProductStory_PDPTemplateQuery */.gx
    }), 1), aboveProductStoryTemplateContent = ref13[0];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "BelowProductStory_PDPTemplate",
        query: ProductDetailsPageTemplate/* BelowProductStory_PDPTemplateQuery */.Iz
    }), 1), belowProductStoryTemplateContent = ref14[0];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "BelowProductGoogleShopping_PDPTemplate",
        query: ProductDetailsPageTemplate/* BelowProductGoogleShopping_PDPTemplateQuery */.kN
    }), 1), belowProductGoogleShoppingTemplateContent = ref15[0];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "StickyAddToCart_PDPTemplate",
        query: ProductDetailsPageTemplate/* StickyAddToCart_PDPTemplateQuery */.MH
    }), 1), stickyAddToCartTemplateContent = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "ExtendedData_PDPTemplate",
        query: ProductDetailsPageTemplate/* ExtendedData_PDPTemplateQuery */.PZ
    }), 1), extendedDataTemplateContent = ref17[0];
    // Content PDP Queries
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PDP_AboveProductStory",
        query: ProductDetailsPage/* AboveProductStory_PDPContentQuery */.Pl,
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler
    }), 1), aboveProductStoryContent = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PDP_ProductStoryAdditionalContentSlot",
        query: ProductDetailsPage/* ProductStoryAdditionalContentSlot_PDPContentQuery */.lJ,
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler
    }), 1), productStoryAdditionalContentSlotContent = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PDP_BelowProductStory",
        query: ProductDetailsPage/* BelowProductStory_PDPContentQuery */.v1,
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler
    }), 1), belowProductStoryContent = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PDP_BelowProductGoogleShopping",
        query: ProductDetailsPage/* BelowProductGoogleShopping_PDPContentQuery */.NK,
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler
    }), 1), belowProductGoogleShoppingContent = ref21[0];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "PDP_ExtendedData",
        query: ProductDetailsPage/* ExtendedData_PDPContentQuery */.lD,
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId || constants/* isServer */.sk && !isCrawler
    }), 1), extendedDataContent = ref22[0];
    var content = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var fetchingStates = [
            aboveProductStoryTemplateContent.fetching,
            belowProductStoryTemplateContent.fetching,
            belowProductGoogleShoppingTemplateContent.fetching,
            stickyAddToCartTemplateContent.fetching,
            extendedDataTemplateContent.fetching,
            aboveProductStoryContent.fetching,
            productStoryAdditionalContentSlotContent.fetching,
            belowProductStoryContent.fetching,
            belowProductGoogleShoppingContent.fetching,
            extendedDataContent.fetching, 
        ];
        if (fetchingStates.some(function(state) {
            return state;
        })) {
            return undefined;
        }
        // Content PDP Template Queries Constants
        var aboveProductStoryTemplate = ((ref = aboveProductStoryTemplateContent.data) === null || ref === void 0 ? void 0 : ref.content) || {};
        var belowProductStoryTemplate = ((ref1 = belowProductStoryTemplateContent.data) === null || ref1 === void 0 ? void 0 : ref1.content) || {};
        var belowProductGoogleShoppingTemplate = ((ref2 = belowProductGoogleShoppingTemplateContent.data) === null || ref2 === void 0 ? void 0 : ref2.content) || {};
        var stickyAddToCartTemplate = ((ref3 = stickyAddToCartTemplateContent.data) === null || ref3 === void 0 ? void 0 : ref3.content) || {};
        var extendedDataTemplate = ((ref4 = extendedDataTemplateContent.data) === null || ref4 === void 0 ? void 0 : ref4.content) || {};
        // Content PDP Queries Constants
        var aboveProductStory = ((ref5 = aboveProductStoryContent.data) === null || ref5 === void 0 ? void 0 : ref5.content) || {};
        var productStoryAdditionalContentSlot = ((ref6 = productStoryAdditionalContentSlotContent.data) === null || ref6 === void 0 ? void 0 : ref6.content) || {};
        var belowProductStoryContentData = (ref7 = belowProductStoryContent.data) === null || ref7 === void 0 ? void 0 : ref7.content;
        var pageBelowProductStory = filterProductComparison(belowProductStoryContentData === null || belowProductStoryContentData === void 0 ? void 0 : belowProductStoryContentData.belowProductStory);
        var belowProductGoogleShopping = ((ref8 = belowProductGoogleShoppingContent.data) === null || ref8 === void 0 ? void 0 : ref8.content) || {};
        var extendedData = ((ref9 = extendedDataContent.data) === null || ref9 === void 0 ? void 0 : ref9.content) || {};
        var belowProductStory = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, belowProductStoryTemplate), {
            belowProductStory: (pageBelowProductStory === null || pageBelowProductStory === void 0 ? void 0 : pageBelowProductStory.length) ? pageBelowProductStory : (belowProductStoryTemplate === null || belowProductStoryTemplate === void 0 ? void 0 : belowProductStoryTemplate.belowProductStory) || []
        });
        return (0,_object_spread/* default */.Z)({}, aboveProductStoryTemplate, belowProductStoryTemplate, belowProductGoogleShoppingTemplate, stickyAddToCartTemplate, extendedDataTemplate, aboveProductStory, productStoryAdditionalContentSlot, belowProductStory, belowProductGoogleShopping, extendedData);
    }, [
        // Content PDP Dependencies
        aboveProductStoryContent,
        productStoryAdditionalContentSlotContent,
        belowProductStoryContent,
        belowProductGoogleShoppingContent,
        extendedDataContent,
        // Content PDP Template Dependencies
        aboveProductStoryTemplateContent,
        belowProductStoryTemplateContent,
        belowProductGoogleShoppingTemplateContent,
        stickyAddToCartTemplateContent,
        extendedDataTemplateContent, 
    ]);
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useProductScoreQuery */.PjV)({
        variables: {
            id: desiredProductId,
            includeReviews: true
        },
        pause: !desiredProductId || !reviewsEnabled || pageLayout !== "full"
    }), 1), productScoreQuery = ref23[0];
    (0,react.useEffect)(function() {
        var ref;
        // After query has successfully retrieved product data, fire view product
        // tracking event for the newly fetched product.
        if (!productQuery.fetching && ((ref = productQuery.data) === null || ref === void 0 ? void 0 : ref.product) && !hasSentAnalytics.current) {
            var product = productQuery.data.product;
            trackProductView({
                masterId: product.id
            });
            trackPdp("".concat(desiredProductId, "_").concat(desiredSwatch));
            hasSentAnalytics.current = true;
        }
    }, [
        productQuery.fetching,
        desiredProductId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        hasSentAnalytics.current = false;
    }, [
        desiredProductId
    ]);
    // Gets pixlee user generated content associated with the product for display.
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUserGeneratedContentQuery */.lCm)({
        variables: {
            productId: desiredProductId
        },
        pause: !desiredProductId
    }), 1), ugcResponse = ref24[0];
    var userGeneratedContent = (ref3 = ugcResponse.data) === null || ref3 === void 0 ? void 0 : ref3.userGeneratedContentForWeb;
    var pixleeImgs = (0,react.useMemo)(function() {
        if (!(pixleeConfig === null || pixleeConfig === void 0 ? void 0 : pixleeConfig.enablePDPGallery) || !userGeneratedContent) return [];
        return userGeneratedContent.filter(function(content) {
            var ref;
            return content && ((ref = content.pixleeCdnPhotos) === null || ref === void 0 ? void 0 : ref.squareMediumUrl);
        }).map(function(content) {
            return {
                __typename: "PixleeImg",
                source: content.source,
                alt: content.altText || "",
                href: content.pixleeCdnPhotos.squareMediumUrl
            };
        });
    }, [
        pixleeConfig,
        userGeneratedContent
    ]);
    // Product is orderable if it has a price and is not soldout, comingsoon or
    // outOfStock
    var productIsOrderable = (0,react.useMemo)(function() {
        var displayOutOfStock = variation === null || variation === void 0 ? void 0 : variation.displayOutOfStock;
        var ref = displayOutOfStock !== null && displayOutOfStock !== void 0 ? displayOutOfStock : {}, comingsoon = ref.comingsoon, soldout = ref.soldout, soldoutWithRecommender = ref.soldoutWithRecommender;
        // 'soldout' is set manually, 'outOfStock' is based on stock levels
        var outOfStock = !(variation === null || variation === void 0 ? void 0 : variation.orderable);
        return Boolean((variation === null || variation === void 0 ? void 0 : variation.price) && !(soldout || soldoutWithRecommender || comingsoon || outOfStock));
    }, [
        variation === null || variation === void 0 ? void 0 : variation.displayOutOfStock,
        variation === null || variation === void 0 ? void 0 : variation.price,
        variation === null || variation === void 0 ? void 0 : variation.orderable
    ]);
    var isAppOnly = !!(variation === null || variation === void 0 ? void 0 : variation.isAppExclusive);
    var productDivision = (0,react.useMemo)(function() {
        return (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productDivision) === "Footwear" ? "Footwear" : "Other";
    }, [
        masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productDivision
    ]);
    var providerValue = (0,react.useMemo)(function() {
        var ref;
        return {
            addToCartError: addToCartError,
            addToCartReturnCode: addToCartReturnCode,
            desiredProductId: desiredProductId,
            desiredModel: desiredModel,
            desiredSize: desiredSize,
            desiredSwatch: desiredSwatch,
            hasLoaded: !productQuery.fetching && !productQuery.stale,
            isAppOnly: isAppOnly,
            isFetching: isFetching,
            isFullLayout: pageLayout === "full",
            isQueryStale: isQueryStale,
            isSimplifiedLayout: pageLayout !== "full",
            masterProduct: masterProduct,
            pageLayout: pageLayout,
            pixleeImgs: pixleeImgs,
            productIsOrderable: productIsOrderable,
            productDivision: productDivision,
            productQuery: productQuery,
            lazyProductQuery: lazyProductQuery,
            quantity: quantity,
            referrerCategoryId: referrerCategoryId.current,
            setAddToCartError: setAddToCartError,
            setAddToCartReturnCode: setAddToCartReturnCode,
            setQuantity: setQuantity,
            variation: variation,
            content: content,
            productScore: (ref = productScoreQuery.data) === null || ref === void 0 ? void 0 : ref.productScore,
            sizeHasChanged: sizeHasChanged,
            setSizeHasChanged: setSizeHasChanged,
            // Content PDP Data
            aboveProductStoryContent: aboveProductStoryContent,
            productStoryAdditionalContentSlotContent: productStoryAdditionalContentSlotContent,
            belowProductStoryContent: belowProductStoryContent,
            belowProductGoogleShoppingContent: belowProductGoogleShoppingContent,
            extendedDataContent: extendedDataContent,
            // Content PDP Template Data
            aboveProductStoryTemplateContent: aboveProductStoryTemplateContent,
            belowProductStoryTemplateContent: belowProductStoryTemplateContent,
            belowProductGoogleShoppingTemplateContent: belowProductGoogleShoppingTemplateContent,
            stickyAddToCartTemplateContent: stickyAddToCartTemplateContent,
            extendedDataTemplateContent: extendedDataTemplateContent
        };
    }, [
        addToCartError,
        addToCartReturnCode,
        desiredProductId,
        desiredModel,
        desiredSize,
        desiredSwatch,
        isAppOnly,
        isFetching,
        isQueryStale,
        masterProduct,
        pageLayout,
        pixleeImgs,
        productIsOrderable,
        productDivision,
        productQuery,
        lazyProductQuery,
        quantity,
        referrerCategoryId,
        setAddToCartError,
        setAddToCartReturnCode,
        setQuantity,
        variation,
        content,
        productScoreQuery,
        sizeHasChanged,
        setSizeHasChanged,
        // Content PDP Dependencies
        aboveProductStoryContent,
        productStoryAdditionalContentSlotContent,
        belowProductStoryContent,
        belowProductGoogleShoppingContent,
        extendedDataContent,
        // Content PDP Template Dependencies
        aboveProductStoryTemplateContent,
        belowProductStoryTemplateContent,
        belowProductGoogleShoppingTemplateContent,
        stickyAddToCartTemplateContent,
        extendedDataTemplateContent, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpContext.Provider, {
        value: providerValue,
        children: children
    });
};
// For Product Details Pages
var usePdp = function() {
    return (0,react.useContext)(PdpContext);
};


/***/ }),

/***/ 7362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useProductClickHandling; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _useGA4Events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89113);


// This hook is designed to trigger a GA4 event when a user clicks on a product
var useProductClickHandling = function(itemId) {
    var ref = (0,_useGA4Events__WEBPACK_IMPORTED_MODULE_1__/* .useGA4Events */ .tL)(), fireSelectItemEvent = ref.fireSelectItemEvent, product = ref.product;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isProductClicked = ref1[0], setIsProductClicked = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (product && isProductClicked) {
            fireSelectItemEvent(itemId);
            setIsProductClicked(false);
        }
    }, [
        product,
        isProductClicked,
        itemId,
        fireSelectItemEvent
    ]);
    return setIsProductClicked;
};


/***/ }),

/***/ 70282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60074);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93968);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9294);
/* harmony import */ var ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20769);
/* harmony import */ var ui_content_ProductRecommender__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30664);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53625);
/* harmony import */ var ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93512);











var ErrorPage = function(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .captureException */ .Tb(err);
    }
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var showSearchFormOnError = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .S)("SHOW_SEARCH_FORM_ON_ERROR");
    var showProductRecommenderOnError = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .S)("SHOW_PRODUCT_RECOMMENDER_ON_ERROR");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_3__/* .PageHead */ .y, {
                title: t("pageTitleReduced", {
                    title: statusCode ? "".concat(statusCode) : ""
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col items-center justify-center mx-auto max-w-4xl xl:max-w-6xl mobile:p-4 tablet:p-6 desktop:p-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "font-display flex flex-col items-center justify-center mobile:space-y-4 tablet:space-y-6 desktop:space-y-8 py-24 w-full",
                    "data-test-id": "not-found-error-msg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_7__/* .ManagedHeading */ .P, {
                            className: "font-bold text-4xl lg:text-5xl text-center",
                            id: "not-found-oops",
                            tag: "h1",
                            children: t("notFoundOops")
                        }),
                        showSearchFormOnError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_4__/* .SearchForm */ .UI, {}),
                        showProductRecommenderOnError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_content_ProductRecommender__WEBPACK_IMPORTED_MODULE_5__/* .ProductRecommender */ .S, {
                            type: "search-no-results-viewed-recently"
                        })
                    ]
                })
            })
        ]
    });
};
ErrorPage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
        var err, asPath, initialProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    err = param.err, asPath = param.asPath;
                    _tmp = {};
                    initialProps = (_tmp.// Workaround for https://github.com/vercel/next.js/issues/8592
                    hasGetInitialPropsRun = true, _tmp);
                    if (err) {
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .captureException */ .Tb(err);
                        return [
                            2,
                            initialProps
                        ];
                    }
                    // If this point is reached, getInitialProps was called without any
                    // information about what the error might be. This is unexpected and may
                    // indicate a bug introduced in Next.js, so record it in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .captureException */ .Tb(new Error("_error.tsx getInitialProps missing data at path: ".concat(asPath)));
                    return [
                        4,
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_11__/* .flush */ .yl(2000)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        initialProps
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 24393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);






var ChevronButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function ChevronButton(_param, ref) {
    var direction = _param.direction, testId = _param.testId, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "direction",
        "testId"
    ]);
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var defaultTestId = "chevron-button-".concat(direction);
    var directionProps = direction === "left" ? {
        label: t("previous"),
        icon: "chevron-left"
    } : {
        label: t("next"),
        icon: "chevron-right"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .ButtonIcon */ .Eik, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        dataTestId: testId !== null && testId !== void 0 ? testId : defaultTestId,
        mode: "icon",
        size: "sm",
        variant: "primary",
        ref: ref
    }, directionProps, buttonProps));
});
/* harmony default export */ __webpack_exports__["Z"] = (ChevronButton);


/***/ }),

/***/ 54969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ CustomerSupportBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1809);
/* harmony import */ var hooks_useLiveChat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57998);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95967);






function useContentQuery() {
    return (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_3__/* .useGroqQuery */ .Mo)({
        operationName: "CustomerSupportBanner",
        query: '\n      *[_type == "CustomerSupport" && country == $country][0] {\n        '.concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_4__/* .LocaleString */ .E)("title"), ",\n        email,\n        phone,\n        phoneHours,\n        chatHours,\n      }\n    ")
    });
}
var CustomerSupportBanner = function() {
    var ref = (0,hooks_useLiveChat__WEBPACK_IMPORTED_MODULE_1__/* .useLiveChat */ .b)(), liveChatEnabled = ref.liveChatEnabled, LiveChatScript = ref.LiveChatScript, LiveChatToggleWrapper = ref.LiveChatToggleWrapper, openLiveChatWindow = ref.openLiveChatWindow;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(useContentQuery(), 1), contentQuery = ref1[0];
    if (contentQuery.fetching || contentQuery.error || !contentQuery.data || !Object.values(contentQuery.data.content || {}).some(function(x) {
        return x;
    })) {
        return null;
    }
    var _content = contentQuery.data.content, title = _content.title, email = _content.email, phone = _content.phone, phoneHours = _content.phoneHours, chatHours = _content.chatHours;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LiveChatScript, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "p-8 sm:p-12 bg-puma-black-800 lg:flex-row mb-6! sm:mb-8! lg:mb-12! grid grid-cols-1 lg:grid-cols-2 w-full col-span-full",
                "data-test-id": "customer-support-banner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "w-full text-2xl lg:text-3xl font-bold pb-6 lg:pb-0",
                        "data-test-id": "customer-support-banner-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "\n          grid gap-2\n          children:(\n            grid grid-cols-1 md:grid-cols-3 pb-4 md:pb-0 items-center\n            children:(\n              first-child:(\n                pb-2 md:pb-0\n              )\n              last-child:(\n                col-span-2\n              )\n            )\n          )\n        ",
                        children: [
                            email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                "data-test-id": "customer-support-banner-email",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            t("email"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "font-bold uppercase px-0 text-sm link-underline",
                                        href: "mailto:".concat(email),
                                        children: email
                                    })
                                ]
                            }),
                            phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                "data-test-id": "customer-support-banner-phone",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            t("phone"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "relative font-bold uppercase px-0 text-sm link-underline",
                                                href: "tel:".concat(phone),
                                                children: phone
                                            }),
                                            phoneHours && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-xs uppercase pl-0 md:pl-2 pt-2 md:pt-0 block md:inline",
                                                children: phoneHours
                                            })
                                        ]
                                    })
                                ]
                            }),
                            liveChatEnabled && chatHours && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LiveChatToggleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            t("liveChat"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                type: "button",
                                                "data-test-id": "live-chat-button",
                                                className: "relative font-bold uppercase px-0 text-sm link-underline",
                                                onClick: function() {
                                                    return openLiveChatWindow();
                                                },
                                                children: t("startChat")
                                            }),
                                            chatHours && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-xs uppercase pl-0 md:pl-2 pt-2 md:pt-0 block md:inline",
                                                children: chatHours
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 53579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34209);






var Img = function(_param) {
    var src = _param.src, width = _param.width, _ratio = _param.ratio, ratio = _ratio === void 0 ? "1 / 1" : _ratio, className = _param.className, _loading = _param.loading, loading = _loading === void 0 ? "lazy" : _loading, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "ratio",
        "className",
        "loading"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ratio.split(" / ").map(Number), 2), horizontalRatio = ref[0], verticalRatio = ref[1];
    var decimalAspectRatio = verticalRatio / horizontalRatio;
    var height = width && width * decimalAspectRatio;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)("w-full bg-puma-black-800", "aspect-".concat(horizontalRatio, "-").concat(verticalRatio), className),
        src: src,
        width: width,
        height: height,
        loading: loading
    }, rest));
};


/***/ }),

/***/ 20769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dq": function() { return /* binding */ NoAnalyticsNoSearchResults; },
  "qx": function() { return /* binding */ NoSearchResults; },
  "UI": function() { return /* binding */ SearchForm; }
});

// UNUSED EXPORTS: RawNoSearchResults

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/suggestions.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Suggestions($searchTerm: String!, $preview: PreviewInput) {\n    suggestions(searchTerm: $searchTerm, preview: $preview) {\n      suggestedProductsSummaries {\n        id\n        masterId\n        colorValue\n        name\n        header\n        subHeader\n        images {\n          href\n          alt\n        }\n        price\n        salePrice\n        isSalePriceElapsed\n      }\n      suggestedTerms {\n        suggestion\n        original\n      }\n      suggestedPhrases {\n        suggestion\n      }\n      suggestedRedirect\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SUGGESTIONS_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./groq/ContentSlots.ts
var ContentSlots = __webpack_require__(18273);
// EXTERNAL MODULE: ./groq/shared/LocaleSeo.ts + 1 modules
var LocaleSeo = __webpack_require__(16138);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
;// CONCATENATED MODULE: ./groq/pages/NotFoundPage.ts



var NotFoundPageQuery = '\n  *[_type == "Error404" && country == $country][0] {\n    _id,\n    _type,\n    '.concat((0,LocaleSeo/* LocaleSeo */.U)("seo"), ",\n    ").concat((0,LocaleString/* LocaleString */.E)("heading"), ",\n    content[] ").concat((0,ContentSlots/* SlotsGroqQuery */.e6)(), ",\n  }\n");

// EXTERNAL MODULE: ./hooks/usePageview.ts
var usePageview = __webpack_require__(8623);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/getPreviewInput.ts
var getPreviewInput = __webpack_require__(14106);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 53 modules
var SanityContentSlot = __webpack_require__(2232);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/components/CustomerSupportBanner.tsx
var CustomerSupportBanner = __webpack_require__(54969);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
;// CONCATENATED MODULE: ./ui/components/NoSearchResults.tsx





















var SearchForm = function() {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), localizeUrlPath = ref1.localizeUrlPath, searchSymbolsMinValue = ref1.searchSymbolsMinValue, charactersNeededToSubmitSearch = ref1.charactersNeededToSubmitSearch;
    var showSearchTipsOnError = (0,useFeature/* useFeature */.S)("SHOW_SEARCH_TIPS_ON_ERROR");
    var ref2 = (0,react.useState)((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.q) || ""), input = ref2[0], setInput = ref2[1];
    var ref3 = (0,react.useState)(false), submitted = ref3[0], setSubmitted = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: SUGGESTIONS_QUERY,
        pause: input.length < searchSymbolsMinValue,
        variables: {
            searchTerm: input.trim(),
            preview: (0,getPreviewInput/* getPreviewInput */.T)(router.query)
        }
    }), 1), searchQuery = ref4[0];
    (0,react.useEffect)(function() {
        if (submitted && !searchQuery.fetching) {
            var ref, ref1;
            window.sessionStorage.setItem("search_type", analytics/* SearchType.noResults */.Sc.noResults);
            window.sessionStorage.setItem("suggested_section_click", "enter/search button");
            window.sessionStorage.setItem("search_term", input);
            var redirect = (ref = searchQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.suggestions) === null || ref1 === void 0 ? void 0 : ref1.suggestedRedirect;
            if (redirect) {
                window.sessionStorage.setItem("user_action", "redirect");
                (0,analytics/* searchAnalyticsEvent */.dr)("0");
                if (redirect.startsWith("https")) {
                    window.location.href = redirect;
                } else {
                    router.replace(localizeUrlPath(redirect));
                }
            } else if (input.length >= charactersNeededToSubmitSearch) {
                window.sessionStorage.setItem("user_action", "noredirect");
                router.push(localizeUrlPath("/search?q=".concat(input)));
            }
            setSubmitted(false);
        }
    }, [
        submitted,
        searchQuery
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
        size: "sm",
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
            children: [
                showSearchTipsOnError && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                    asChild: true,
                    size: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("searchTipsTitle")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SearchForm */.UIq, {
                    name: "noResultSearch",
                    label: t("searchPuma"),
                    placeholder: t("searchPuma"),
                    value: input,
                    dataTestId: "search-box-noresults",
                    onChange: function(value) {
                        return setInput(value);
                    },
                    onSubmit: function(e) {
                        e.preventDefault();
                        setSubmitted(true);
                    }
                }),
                showSearchTipsOnError && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                    asChild: true,
                    size: "base",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("searchTips", undefined, {
                            supportHTMLTags: true
                        })
                    })
                })
            ]
        })
    });
};
var NoSearchResults = function(param) {
    var message = param.message;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "NotFoundPage",
        query: NotFoundPageQuery
    }), 1), pageContent = ref[0];
    (0,usePageview/* default */.Z)(pageContent.fetching);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RawNoSearchResults, {
        message: message,
        pageContent: pageContent
    });
};
var NoAnalyticsNoSearchResults = function(param) {
    var message = param.message;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "NotFoundPage",
        query: NotFoundPageQuery
    }), 1), pageContent = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RawNoSearchResults, {
        message: message,
        pageContent: pageContent
    });
};
var RawNoSearchResults = function(param) {
    var message = param.message, pageContent = param.pageContent;
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var ref3;
    var ref4 = (ref3 = (ref = pageContent.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.seo) !== null && ref3 !== void 0 ? ref3 : {}, pageTitle = ref4.pageTitle, pageDescription = ref4.pageDescription;
    var ref5;
    var ref6 = (ref5 = (ref2 = pageContent.data) === null || ref2 === void 0 ? void 0 : ref2.content) !== null && ref5 !== void 0 ? ref5 : {}, heading = ref6.heading, content = ref6.content;
    var title = message ? message : heading;
    if (heading && !pageContent.fetching) {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.SEARCH_OPEN */._q.SEARCH_OPEN,
            event_params: {
                search_type: analytics/* SearchType.noResults */.Sc.noResults
            }
        });
    }
    if (pageContent.fetching) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageLoadingSpinner */.v, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: t("pageTitleReduced", {
                    title: pageTitle || t("notFoundOops")
                }),
                description: pageDescription,
                noIndex: true,
                noIndexFollow: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
                size: "page",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    gap: "xl",
                    className: " mt-12! md:mt-8! lg:mt-8!",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                            gap: "base",
                            className: countryCode === constants/* SUPPORTED_COUNTRY.IN.toLocaleLowerCase */.bM.IN.toLocaleLowerCase() ? "" : "mb-6!",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                    asChild: true,
                                    size: {
                                        sm: "lg",
                                        md: "xl",
                                        lg: "xl"
                                    },
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                        tag: "h1",
                                        dataTestId: "not-found-error-msg",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                            items: content,
                            documentId: "error404",
                            slotId: "content",
                            className: "gap-8 md:gap-12 lg:gap-16"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupportBanner/* CustomerSupportBanner */.j, {})
        ]
    });
};


/***/ }),

/***/ 87150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Page; },
  "v": function() { return /* binding */ PageLoadingSpinner; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./hooks/useGA4ScrollEvents.tsx + 2 modules
var useGA4ScrollEvents = __webpack_require__(46660);
// EXTERNAL MODULE: ./ui/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(91622);
// EXTERNAL MODULE: ./ui/components/NoSearchResults.tsx + 2 modules
var NoSearchResults = __webpack_require__(20769);
// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(70282);
// EXTERNAL MODULE: ./hooks/usePageview.ts
var usePageview = __webpack_require__(8623);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useBrowsingHistory.tsx
var useBrowsingHistory = __webpack_require__(99778);
// EXTERNAL MODULE: ./hooks/useLocation.tsx
var useLocation = __webpack_require__(60248);
;// CONCATENATED MODULE: ./hooks/useBloomreachPixel.ts






var getBloomreachPageType = function(url, isCategory) {
    switch(true){
        case isCategory:
            return "category";
        case url.split("/").length === 3:
            return "homepage";
        case url.includes("/pd/"):
            return "product";
        case url.includes("/search"):
            return "search";
        case url.includes("/help"):
            return "content";
        default:
            return "other";
    }
};
var loadPixelScript = function(accountId, onLoad) {
    (function() {
        var brtrk = document.createElement("script");
        brtrk.type = "text/javascript";
        brtrk.async = true;
        brtrk.src = "https://cdn.brcdn.com/v1/br-trk-".concat(accountId, ".js");
        if (onLoad) brtrk.onload = onLoad;
        var s = document.getElementsByTagName("script")[0];
        if (s.parentNode) s.parentNode.insertBefore(brtrk, s);
    })();
};
var useBloomreachPageviewPixel = function() {
    var fetching = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, bloomreachData = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var prevPath = (0,useBrowsingHistory/* useBrowsingHistory */.k)().prevPath;
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref.countryCode, bloomreach = ref.bloomreach, env = ref.env;
    var location = (0,useLocation/* useLocation */.TH)().location;
    var customerId = (0,useAuth/* useAuth */.aC)().customerId;
    var hasFired = (0,react.useRef)(false);
    var fireBloomreachPixelEvent = function(accountId, objectName, pageType, prevPath) {
        if (!bloomreach || !objectName) return Promise.resolve();
        return new Promise(function(resolve) {
            var ref;
            var br_data = window[objectName] || {};
            br_data.acct_id = accountId;
            br_data.ptype = pageType;
            br_data.title = document.title;
            br_data.view_id = bloomreach.viewId;
            br_data.user_id = customerId;
            if (env.STAGE !== "production") {
                br_data.test_data = true;
            }
            br_data.cat_id = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.cat_id;
            br_data.cat = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.cat;
            br_data.search_term = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.search_term;
            br_data.prod_id = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.prod_id;
            br_data.prod_name = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.prod_name;
            br_data.sku = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.sku;
            br_data.is_conversion = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.is_conversion;
            br_data.basket_value = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.basket_value;
            br_data.order_id = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.order_id;
            br_data.basket = {
                items: bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.basket
            };
            br_data.customer_country = (ref = location.userCountry) === null || ref === void 0 ? void 0 : ref.id.toUpperCase();
            br_data.currency = bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.currency;
            var fullPrevPath = prevPath ? "".concat(window.location.origin).concat(prevPath) : "";
            br_data.orig_ref_url = fullPrevPath;
            // document.referrer is set to '' when user navigates directly to the site.
            // Set ref to previous path if it exist, otherwise set to document.referrer
            br_data.ref = fullPrevPath ? fullPrevPath : document.referrer;
            var isInitialEvent = !prevPath;
            if (isInitialEvent) {
                window[objectName] = br_data;
                loadPixelScript(accountId, function() {
                    return resolve();
                });
            } else {
                var ref1, ref2, ref3, ref4;
                (ref2 = (ref1 = window.BrTrk) === null || ref1 === void 0 ? void 0 : ref1.getTracker()) === null || ref2 === void 0 ? void 0 : ref2.updateBrData(br_data);
                (ref4 = (ref3 = window.BrTrk) === null || ref3 === void 0 ? void 0 : ref3.getTracker()) === null || ref4 === void 0 ? void 0 : ref4.logPageView();
                // in the case of sequentially firing events for different account IOs, we
                // need to ensure that the work has been done for recording the first event
                // before we let the second event fire.
                // a setTimeout of 0 should defer the next event to the next tick
                setTimeout(function() {
                    return resolve();
                }, 0);
            }
        });
    };
    var resetHasFired = function() {
        return hasFired.current = false;
    };
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", resetHasFired);
        return function() {
            return router.events.off("routeChangeComplete", resetHasFired);
        };
    }, [
        router.events
    ]);
    var pageType = getBloomreachPageType(router.asPath, !!(bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.cat_id));
    (0,react.useEffect)(function() {
        var shouldFire = !hasFired.current;
        if (!shouldFire || !bloomreach || !customerId || !env.bloomreachAccountId || fetching) return;
        var eventFireOrder = [
            {
                accountId: env.bloomreachSEOAccountId,
                objectName: bloomreach.seoObjectName
            },
            {
                accountId: env.bloomreachAccountId,
                objectName: bloomreach.objectName
            }, 
        ];
        var queue = Promise.resolve();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _value = _step.value, accountId = _value.accountId, objectName = _value.objectName;
                if (accountId && objectName) {
                    queue = queue.then(function() {
                        return fireBloomreachPixelEvent(accountId, objectName, pageType, prevPath);
                    });
                }
            };
            for(var _iterator = eventFireOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        hasFired.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetching,
        countryCode,
        customerId,
        bloomreachData === null || bloomreachData === void 0 ? void 0 : bloomreachData.sku,
        bloomreach,
        location,
        env.bloomreachAccountId,
        env.bloomreachSEOAccountId,
        pageType,
        hasFired.current, 
    ]);
};

// EXTERNAL MODULE: ./hooks/a11y/useFocusVisible.ts
var useFocusVisible = __webpack_require__(2235);
// EXTERNAL MODULE: ./hooks/useEmarsysWebExtend.tsx + 2 modules
var useEmarsysWebExtend = __webpack_require__(78108);
// EXTERNAL MODULE: ./hooks/useCookieSettings.tsx + 1 modules
var useCookieSettings = __webpack_require__(34457);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
;// CONCATENATED MODULE: ./ui/components/Page.tsx














var PageLoadingSpinner = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex w-full h-[80vh]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "m-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* LoadingSpinner */.T, {
                    className: "w-full",
                    dataTestId: "page-loading-spinner"
                }),
                props.loadingMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "p-2 text-center text-base text-puma-black-300",
                    children: props.loadingMessage
                })
            ]
        })
    });
};
var Page = function(param) {
    var _query = param.query, query = _query === void 0 ? {
        fetching: false,
        error: undefined,
        stale: false
    } : _query, _emarsysData = param.emarsysData, emarsysData = _emarsysData === void 0 ? {
        skipTracking: true
    } : _emarsysData, loadingMessage = param.loadingMessage, pageViewPageType = param.pageViewPageType, bloomreachData = param.bloomreachData, children = param.children;
    var fetching = Array.isArray(query) ? query.some(function(x) {
        return x.fetching;
    }) : query.fetching;
    var showCookieSettings = (0,useCookieSettings/* useCookieSettings */.eK)().showCookieSettings;
    var isDesktop = (0,media/* getIsDesktop */.w)();
    (0,useGA4ScrollEvents/* useGA4ScrollEvents */.F)();
    var router = (0,next_router.useRouter)();
    var UK_STOREFINDER_PATH = "/uk/en/storefinder";
    var JP_STOREFINDER_PATH = "/jp/ja/storefinder";
    var storeFinderPaths = new Set([
        UK_STOREFINDER_PATH,
        JP_STOREFINDER_PATH
    ]);
    var isPdp = (0,analytics/* getPageType */.C2)(router.pathname) === "pdp";
    (0,useFocusVisible/* useFocusVisible */._Y)();
    // Register a page view once the page data has loaded
    (0,usePageview/* default */.Z)(fetching, pageViewPageType);
    useBloomreachPageviewPixel(fetching, bloomreachData);
    var omitTrackingCommand = (0,useEmarsysWebExtend/* useEmarsysWebExtend */._)().omitTrackingCommand;
    (0,react.useEffect)(function() {
        if (emarsysData === null || emarsysData === void 0 ? void 0 : emarsysData.skipTracking) {
            omitTrackingCommand();
        }
    }, [
        emarsysData === null || emarsysData === void 0 ? void 0 : emarsysData.skipTracking,
        omitTrackingCommand
    ]);
    var queriesWithErrors = [];
    if (Array.isArray(query)) {
        queriesWithErrors = query.filter(function(x) {
            return !!x.error;
        });
    } else if (query.error) {
        queriesWithErrors = [
            query
        ];
    }
    var hasNotFoundError = queriesWithErrors.some(function(q) {
        var ref;
        return (ref = q.error) === null || ref === void 0 ? void 0 : ref.graphQLErrors.some(function(e) {
            return e.extensions && e.extensions.code === "NOT_FOUND";
        });
    });
    var hasData = Array.isArray(query) ? query.some(function(x) {
        return x.data;
    }) : query.data;
    if (fetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoadingSpinner, {
            loadingMessage: loadingMessage
        });
    }
    if (hasNotFoundError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchResults/* NoSearchResults */.qx, {});
    }
    if (queriesWithErrors.length > 0 && !hasData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_error["default"], {
            statusCode: 500
        });
    }
    var position = "relative";
    if (showCookieSettings && !isDesktop) {
        position = "fixed";
    }
    var isUkOrJapanStorefinder = storeFinderPaths.has(router.asPath);
    var padding = isUkOrJapanStorefinder ? "mobile:p-6 tablet:p-8 desktop:p-12" : "mobile:p-4 tablet:p-6 desktop:p-8";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "box-border flex flex-col  ".concat(!isPdp && "mobile:space-y-4 tablet:space-y-6 desktop:space-y-8", "  ").concat(padding, " max-w-screen-3xl mx-auto font-display ").concat(position),
        children: children
    });
};


/***/ }),

/***/ 81406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Price; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);
/* harmony import */ var hooks_usePriceFormatter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23658);



var Price = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    var formatter = (0,hooks_usePriceFormatter__WEBPACK_IMPORTED_MODULE_2__/* .usePriceFormatter */ .o)({
        showSign: props.showSign
    });
    var formattedPrice = formatter(props.amount);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: t("orderDetailAmount", {
            amount: formattedPrice
        })
    });
};


/***/ }),

/***/ 10395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aS": function() { return /* binding */ ProductBadges; },
  "fD": function() { return /* binding */ SaleBadge; }
});

// UNUSED EXPORTS: ECO_BADGES, EXCLUSIVE_BADGES, FAVOURITE_BADGES, INFO_BADGES, ProductBadge, SALE_BADGES, getBadgeColor

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/isAppExclusiveValidRange.ts
var isAppExclusiveValidRange = __webpack_require__(22649);
;// CONCATENATED MODULE: ./ui/components/CustomizedBadge.tsx

var CustomizedBadge = function(param) {
    var label = param.label;
    var style = {
        background: "linear-gradient(90deg, #0EEBF9 0%, #946FBA 33%, #F2006C 66%, #F84D04 100%)"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        "data-test-id": "customized-product-badge",
        className: "flex-shrink-0 text-xs h-6 px-4 min-w-6 inline-flex text-neutral-0 items-center justify-center gap-1 font-bold uppercase",
        style: style,
        children: label
    });
};

;// CONCATENATED MODULE: ./ui/components/ProductBadge.tsx







var INFO_BADGES = [
    "new",
    "restock",
    "unisex",
    "big-and-tall",
    "plus-size",
    "shop-the-look",
    "limited-edition", 
];
var FAVOURITE_BADGES = [
    "top-rated",
    "most-favorited",
    "best-seller",
    "puma-select",
    "trending",
    "select", 
];
var EXCLUSIVE_BADGES = [
    "puma-store-exclusive",
    "exclusive",
    "app-exclusive",
    "online-exclusive", 
];
var ECO_BADGES = [
    "vegan",
    "sustainable",
    "sustainable-material",
    "recycled",
    "recycled-materials",
    "organic-cotton",
    "bio-based", 
];
var SALE_BADGES = [
    "sale",
    "black-friday",
    "cyber-monday",
    "singles-day-special",
    "christmas-deal",
    "special-offer",
    "last-chance",
    "special-price", 
];
var PERSONIZABLE_BADGES = [
    "customize",
    "personalize"
];
var getBadgeColor = function() {
    var badge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var lowerCaseBadge = badge.toLowerCase();
    switch(true){
        case FAVOURITE_BADGES.includes(lowerCaseBadge):
            return "info";
        case EXCLUSIVE_BADGES.includes(lowerCaseBadge):
            return "muted";
        case ECO_BADGES.includes(lowerCaseBadge):
            return "success";
        case SALE_BADGES.includes(lowerCaseBadge):
        case lowerCaseBadge.includes("deal"):
        case lowerCaseBadge.includes("percent"):
            return "brand";
        case INFO_BADGES.includes(lowerCaseBadge):
        case lowerCaseBadge.includes("worn by"):
        case lowerCaseBadge.includes("designed by"):
        default:
            return "base";
    }
};
var ProductBadge = function(param) {
    var _id = param.id, id = _id === void 0 ? "" : _id, label = param.label, icon = param.icon;
    return PERSONIZABLE_BADGES.includes(id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizedBadge, {
        label: label
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Badge */.Cts, {
        color: getBadgeColor(id),
        icon: icon,
        dataTestId: "product-badge",
        label: label.replace(/-/g, " ")
    });
};
var SaleBadge = function(props) {
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var saleBadgeEnabled = (0,useFeature/* useFeature */.S)("SHOW_SALES_BADGE_ON_PRODUCT_IMAGE");
    var percentageOff = (ref = props.variant) === null || ref === void 0 ? void 0 : ref.percentageDiscountBadge;
    var isSalePriceElapsed = (ref1 = props.variant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productPrice) === null || ref2 === void 0 ? void 0 : ref2.isSalePriceElapsed;
    if (!percentageOff || !saleBadgeEnabled) return null;
    var label = t("percentOff", {
        amount: percentageOff
    });
    //Change saleBadge label after 4 weeks
    if (isSalePriceElapsed) {
        label = t("sale");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Badge */.Cts, {
        color: "brand",
        label: label,
        "data-test-id": "product-badge-sale",
        className: "absolute top-0 left-0 z-[5]"
    });
};
var ProductBadges = function(props) {
    var _variant = props.variant, badges = _variant.badges, appOnlyDateTimeFrom = _variant.appOnlyDateTimeFrom, appOnlyDateTimeTo = _variant.appOnlyDateTimeTo, isAppExclusive = _variant.isAppExclusive;
    if (!(badges === null || badges === void 0 ? void 0 : badges.length)) return null;
    var validRange = (0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppExclusive, appOnlyDateTimeFrom, appOnlyDateTimeTo);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        direction: "row",
        gap: "xs",
        children: badges.filter(Boolean).map(function(item) {
            if (!validRange && item.id === "app-exclusive") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge, {
                id: item.id,
                label: item.label
            }, item.id);
        })
    });
};


/***/ }),

/***/ 45876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ProductListItemImages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34209);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89113);
/* harmony import */ var _ResponsiveProductImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99531);






var ProductListItemImages = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var fireClickProductImage = (0,hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_3__/* .useGA4Events */ .tL)().fireClickProductImage;
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)(), useVerticalMedia = ref.staticFeatures.useVerticalMedia;
    var isOneOfTopProducts = Number(props === null || props === void 0 ? void 0 : props.position) <= 4;
    var _variant = props.variant, orderable = _variant.orderable, displayOutOfStock = _variant.displayOutOfStock;
    var outOfStock = Boolean(!orderable || displayOutOfStock);
    // Only show the first image
    var firstImage = props.variant.images && props.variant.images.length > 0 ? props.variant.images[0] : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative group",
        "data-test-id": props.dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex",
                children: firstImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full flex-none transform-gpu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveProductImage__WEBPACK_IMPORTED_MODULE_4__/* .ResponsiveProductImage */ .U, {
                        src: useVerticalMedia ? firstImage.verticalImageHref || firstImage.href : firstImage.href,
                        widths: [
                            300,
                            350,
                            400,
                            450,
                            500,
                            550,
                            600
                        ],
                        sizes: {
                            mobile: "50vw",
                            tablet: "33vw",
                            desktop: "25vw"
                        },
                        width: 400,
                        alt: firstImage.alt,
                        title: firstImage.alt,
                        isVertical: useVerticalMedia,
                        className: (0,twind__WEBPACK_IMPORTED_MODULE_5__.tw)(outOfStock && "opacity-50"),
                        onClick: function() {
                            return fireClickProductImage(firstImage.href);
                        },
                        loading: isOneOfTopProducts ? "eager" : "lazy"
                    })
                }, firstImage.href)
            }),
            outOfStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-test-id": "product-list-item-badge",
                className: "absolute bottom-5 left-0 uppercase text-xs font-bold bg-white px-2 py-0.5 border-puma-black border-l-2",
                children: (displayOutOfStock === null || displayOutOfStock === void 0 ? void 0 : displayOutOfStock.displayValue) || t("soldOut")
            })
        ]
    });
};


/***/ }),

/***/ 43477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RecommendationTile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49224);
/* harmony import */ var utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69377);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68302);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37678);
/* harmony import */ var hooks_useGetRecommenderLocation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16666);
/* harmony import */ var hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89113);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83168);
/* harmony import */ var utils_ga4Items__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54093);
/* harmony import */ var utils_referrerParametersUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74067);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79758);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20368);
/* harmony import */ var _ProductBadge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10395);
/* harmony import */ var _ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1108);
/* harmony import */ var _ResponsiveProductImage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99531);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98463);



















var RecommendationTile = function(param) {
    var containerClassName = param.containerClassName, _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "recommendation-tile" : _dataTestId, linkClassName = param.linkClassName, product = param.product, productInfoConfig = param.productInfoConfig, fromRecommender = param.fromRecommender, gaBannerData = param.gaBannerData, fetching = param.fetching, itemListId = param.itemListId, itemListName = param.itemListName, position = param.position;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useTrackRecommendationClickMutation */ .jNL)(), 2), trackRecommendationClick = ref8[1];
    var recommenderLocation = (0,hooks_useGetRecommenderLocation__WEBPACK_IMPORTED_MODULE_5__/* .useGetRecommenderLocation */ .g)();
    var ref9 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_10__/* .useSiteConfig */ .N)(), showHeaderSubHeaderProductDetail = ref9.staticFeatures.showHeaderSubHeaderProductDetail;
    var ref10 = (0,hooks_useGA4Events__WEBPACK_IMPORTED_MODULE_6__/* .useGA4Events */ .tL)(), setProduct = ref10.setProduct, fireClickProductImage = ref10.fireClickProductImage;
    if (!product) return null;
    var regularPrice = ((ref = product.productPrice) === null || ref === void 0 ? void 0 : ref.price) ? product.productPrice.price : 0;
    var salePrice = ((ref1 = product.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice) ? product.productPrice.salePrice : undefined;
    var promotionPrice = ((ref2 = product.productPrice) === null || ref2 === void 0 ? void 0 : ref2.promotionPrice) ? product.productPrice.promotionPrice : undefined;
    var isSalePriceElapsed = (ref3 = product.productPrice) === null || ref3 === void 0 ? void 0 : ref3.isSalePriceElapsed;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
        onClick: function() {
            var lid = fromRecommender ? fromRecommender.recommenderId : itemListId;
            var lname = fromRecommender ? fromRecommender.recommenderName : itemListName;
            if (lid && lname) (0,utils_ga4Items__WEBPACK_IMPORTED_MODULE_16__/* .setGa4ItemInMap */ .HH)("".concat(product.masterId, "_").concat(product.colorValue), {
                lid: lid,
                lname: lname,
                idx: position
            });
            setProduct(product);
            (0,utils_referrerParametersUtils__WEBPACK_IMPORTED_MODULE_8__/* .setReferrerType */ .Sl)(utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .REFERRER_TYPE_VAL.Carousel */ .Ei.Carousel);
            if (fromRecommender) {
                trackRecommendationClick({
                    masterId: product.masterId,
                    swatch: product.colorValue,
                    recommenderId: fromRecommender.recommenderId,
                    recommenderName: fromRecommender.recommenderName
                });
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.PRODUCT_RECOMMENDER_CLICKED */ ._q.PRODUCT_RECOMMENDER_CLICKED, {
                    ecommerce: {
                        productRecommenderLocation: recommenderLocation(),
                        recommenderName: fromRecommender.recommenderName,
                        productName: product.name,
                        productSku: product.id
                    }
                });
            }
            if (gaBannerData) {
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.PROMOTION_CLICK */ ._q.PROMOTION_CLICK, {
                    ecommerce: {
                        promoClick: {
                            promotions: [
                                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, gaBannerData), {
                                    id: (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName) || gaBannerData.id,
                                    "cta-click": "Banner Clicked"
                                }), 
                            ]
                        }
                    }
                });
            }
        },
        href: (0,utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_2__/* .buildProductUrl */ .B)(product.masterId, product.name, {
            color: product.colorValue
        }),
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)(linkClassName, (0,twind_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
            scrollSnapAlign: "start"
        })),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)("flex flex-col", containerClassName),
            "data-test-id": dataTestId,
            "data-product-id": product.id,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_11__/* .SaleBadge */ .fD, {
                            variant: product
                        }),
                        (product === null || product === void 0 ? void 0 : product.images) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveProductImage__WEBPACK_IMPORTED_MODULE_13__/* .ResponsiveProductImage */ .U, {
                            "data-test-id": "".concat(dataTestId, "-image"),
                            className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)(product.displayOutOfStock && "opacity-50"),
                            alt: product === null || product === void 0 ? void 0 : (ref4 = product.images) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.alt,
                            width: 400,
                            widths: [
                                300,
                                450,
                                750,
                                900,
                                1050,
                                1200,
                                1350,
                                1500
                            ],
                            sizes: {
                                mobile: "33vw",
                                tablet: "50vw",
                                desktop: "25vw"
                            },
                            src: product === null || product === void 0 ? void 0 : (ref6 = product.images) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.href,
                            onClick: function() {
                                var ref;
                                return fireClickProductImage(product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0].href);
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_14__/* .Skeleton */ .O, {
                            className: "w-full aspect-1-1"
                        }),
                        product.displayOutOfStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "data-test-id": "".concat(dataTestId, "-soldout-badge"),
                            className: "absolute bottom-0 left-0 uppercase text-xs font-bold bg-white px-2 py-0.5 border-puma-black border-l-2",
                            children: product.displayOutOfStock.displayValue
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)((0,twind_css__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)("h-full flex-1 flex flex-col mt-3 items-start justify-between"), productInfoConfig === null || productInfoConfig === void 0 ? void 0 : productInfoConfig.containerClassName),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)((0,twind_css__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)("text-sm desktop:text-base pr-5 line-clamp-2 text-left font-bold"), productInfoConfig === null || productInfoConfig === void 0 ? void 0 : productInfoConfig.productTitleContainerClassName),
                                    title: product.name,
                                    "data-test-id": "".concat(dataTestId, "-name"),
                                    children: showHeaderSubHeaderProductDetail ? product.header : product.name
                                }),
                                showHeaderSubHeaderProductDetail && product.subHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "w-full mobile:text-sm text-base text-puma-gray-60 text-left line-clamp-2",
                                    "data-test-id": "".concat(dataTestId, "-subheader"),
                                    children: product.subHeader
                                })
                            ]
                        }),
                        product.productPrice && !fetching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (0,twind_css__WEBPACK_IMPORTED_MODULE_1__.tw)((0,twind_css__WEBPACK_IMPORTED_MODULE_1__/* .apply */ .nn)("flex flex-col text-sm desktop:text-base items-start relative"), productInfoConfig === null || productInfoConfig === void 0 ? void 0 : productInfoConfig.priceContainerClassName),
                            title: product.name,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_12__/* .ProductPrice */ .jF, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                price: {
                                    amount: regularPrice,
                                    salePrice: salePrice,
                                    promotionPrice: promotionPrice,
                                    isSalePriceElapsed: isSalePriceElapsed
                                },
                                compact: false,
                                wrapText: true
                            }, _ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_12__/* .RECOMMENDATION_CAROUSEL_PRICE_STRATEGY */ .Km))
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_14__/* .Skeleton */ .O, {
                            className: "w-16 h-6"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 99531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ResponsiveProductImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34209);
/* harmony import */ var ui_components_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53579);
/* harmony import */ var utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75350);







var ResponsiveProductImage = function(_param) {
    var src = _param.src, widths = _param.widths, responsiveSizes = _param.sizes, isVertical = _param.isVertical, ratio = _param.ratio, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "widths",
        "sizes",
        "isVertical",
        "ratio",
        "className"
    ]);
    var ref;
    // Vertical product images do not have a transform parameter in the url
    var finalSrc = isVertical ? (0,utils_image__WEBPACK_IMPORTED_MODULE_2__/* .addWidthTransform */ .n9)(src) : src;
    // Cloudinary product images specify their size via a transform parameter e.g. w_600,h_600
    var originalImageWidth = ((ref = finalSrc.match(/w_(\d*)[,\/]/)) === null || ref === void 0 ? void 0 : ref[1]) || "2000";
    var smallestWidthSrc = finalSrc.replace(new RegExp(originalImageWidth, "g"), widths[0].toString());
    var srcSet = (0,utils_image__WEBPACK_IMPORTED_MODULE_2__/* .getResponsiveImageSrcSet */ .oO)(finalSrc, widths, originalImageWidth);
    var sizes = (0,utils_image__WEBPACK_IMPORTED_MODULE_2__/* .getResponsiveImageSizes */ .lv)(responsiveSizes);
    var verticalRatio = "2 / 3";
    var imgRatio = isVertical ? verticalRatio : ratio;
    var imgClassName = (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)(className, isVertical && "object-contain");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Img__WEBPACK_IMPORTED_MODULE_1__/* .Img */ .E, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        src: smallestWidthSrc,
        srcSet: srcSet,
        sizes: sizes,
        className: imgClassName,
        ratio: imgRatio,
        title: rest.alt
    }));
};


/***/ }),

/***/ 2232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ SanityContentSlot; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./hooks/useInView.ts
var useInView = __webpack_require__(50641);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(57178);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./ui/content/CallToActions.tsx + 1 modules
var CallToActions = __webpack_require__(85814);
// EXTERNAL MODULE: ./ui/content/CountdownClock.tsx + 1 modules
var CountdownClock = __webpack_require__(3099);
;// CONCATENATED MODULE: ./utils/alignmentToFlexDirection.ts
/** Converts a horizontal or vertical alignment to a flex direction. */ var alignmentToFlexDirection = function(x) {
    return ({
        top: "start",
        left: "start",
        center: "center",
        middle: "center",
        right: "end",
        bottom: "end"
    })[x];
};

// EXTERNAL MODULE: ./ui/elements/Markdown.tsx + 1 modules
var Markdown = __webpack_require__(41467);
// EXTERNAL MODULE: ./hooks/usePromotionView.ts
var usePromotionView = __webpack_require__(32736);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/urls.ts
var urls = __webpack_require__(90901);
// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ./ui/components/SanityImage.tsx
var SanityImage = __webpack_require__(86468);
// EXTERNAL MODULE: ./hooks/useLinkResolver.ts
var useLinkResolver = __webpack_require__(13022);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
;// CONCATENATED MODULE: ./ui/content/LinkOrTag.tsx








var TagType;
(function(TagType) {
    TagType["DIV"] = "div";
    TagType["SECTION"] = "section";
    TagType["ARTICLE"] = "article";
    TagType["H1"] = "h1";
})(TagType || (TagType = {}));
var LinkOrTag = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var className = props.className, query = props.query, href = props.href, dataTestId = props.dataTestId, gaBannerData = props.gaBannerData, ga4Data = props.ga4Data, newtab = props.newtab, dataLinkLoc = props.dataLinkLoc, linkType = props.linkType, headingSize = props.headingSize, otherLinkProps = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "query",
        "href",
        "dataTestId",
        "gaBannerData",
        "ga4Data",
        "newtab",
        "dataLinkLoc",
        "linkType",
        "headingSize"
    ]);
    var Tag = props.tag || TagType.DIV;
    /** we need to use the UDS Heading components for the H1 tags */ if (Tag === TagType.H1 && !props.href) return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
        dataTestId: "body-header",
        ref: ref,
        asChild: true,
        size: props.headingSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
            tag: Tag,
            className: className,
            dataTestId: dataTestId,
            children: props.children
        })
    });
    return linkType && href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        "aria-hidden": true
    }, otherLinkProps), {
        className: className,
        query: query,
        href: href || null,
        dataTestId: dataTestId,
        gaBannerData: gaBannerData,
        ga4Data: ga4Data,
        dataLinkLoc: dataLinkLoc,
        newtab: newtab,
        children: props.children
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherLinkProps), {
        ref: ref,
        className: className,
        "data-test-id": dataTestId,
        "data-link-loc": dataLinkLoc,
        children: props.children
    }));
});
LinkOrTag.displayName = "LinkOrTag";

// EXTERNAL MODULE: ./ui/content/ContentHeading.tsx
var ContentHeading = __webpack_require__(83057);
;// CONCATENATED MODULE: ./ui/content/BodyContent.tsx


















var BodyContent = function(param) {
    var campaignId = param.campaignId, copy = param.copy, countdownClock = param.countdownClock, ctas = param.ctas, header = param.header, pageContent = param.pageContent, disclaimer = param.disclaimer, horizontalAlignment = param.horizontalAlignment, logo = param.logo, puid = param.puid, headingTag = param.headingTag, link = param.link, linkType = param.linkType, _id = param._id, _type = param._type;
    var ref;
    var asPath = (0,next_router.useRouter)().asPath;
    var hAlign = alignmentToFlexDirection(horizontalAlignment || "center");
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var bodyContentRef = (0,react.useRef)(null);
    var navigateTo = (0,urls/* slotLink */.RF)(linkType, ctas, link);
    var creative_name = _type || "BodyContent";
    var promotion_id = _id || "";
    var promotion_name = header || "";
    var gaTrackData = {
        id: (puid === null || puid === void 0 ? void 0 : puid.current) || "",
        name: promotion_name,
        creative: "body-content",
        position: "0",
        campaign: campaignId || ""
    };
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: (ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
            return getLink(cta);
        })) || []
    });
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(bodyContentRef, extendedGaTrackData).ga4PromotionTrackerPosition;
    var linkUrl = getLink(navigateTo);
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: linkUrl,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOrTag, {
        className: "text-puma-black relative",
        ref: bodyContentRef,
        href: linkUrl,
        gaBannerData: gaTrackData,
        ga4Data: ga4Data,
        dataTestId: "body-content",
        linkType: linkType,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-".concat(hAlign, " text-").concat(horizontalAlignment, " mobile:space-y-1 tablet:space-y-2 desktop:space-y-3"),
            children: [
                (logo === null || logo === void 0 ? void 0 : (ref = logo.asset) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: logo,
                    relative: true,
                    preserveImageWidth: true
                }),
                header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                    header: header,
                    className: "text-3xl md:text-4xl font-bold font-display leading-tight",
                    headingTag: headingTag,
                    dataTestId: "body-content-header"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy, {
                    copy: copy,
                    countdownClock: countdownClock
                }),
                pageContent && /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                    id: _id + "-page-content",
                    blocks: pageContent,
                    serializers: serializeBlockContent/* serializeTocBlockContent */.lw,
                    className: "w-full"
                }),
                disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                    id: _id + "-disclaimer",
                    blocks: disclaimer,
                    serializers: serializeBlockContent/* serializeTocBlockContent */.lw,
                    className: "w-full"
                }),
                Boolean(ctas === null || ctas === void 0 ? void 0 : ctas.length) && linkType === constants/* SLOT_LINK_TYPE.CTA */.no.CTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap justify-".concat(hAlign, " flex-gap-4 pb-6 xs:pb-8 pt-2 max-w-screen-sm"),
                    "data-test-id": "body-content-ctas",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                        ctas: ctas,
                        gaBannerData: gaTrackData,
                        ga4Data: ga4Data
                    })
                })
            ]
        })
    });
};
var Copy = function(param) {
    var countdownClock = param.countdownClock, copy = param.copy;
    var isCountdownAvailable = (0,CountdownClock/* useIsCountdownAvailable */.s)(countdownClock === null || countdownClock === void 0 ? void 0 : countdownClock.availableFrom, countdownClock === null || countdownClock === void 0 ? void 0 : countdownClock.availableTo);
    // Prioritise rendering the countdown clock over the copy
    if (countdownClock && isCountdownAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownClock/* CountdownClock */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "data-test-id": "countdown-clock"
        }, countdownClock), {
            config: {
                timeUnitClassName: "text-2xl mobile:text-lg font-normal",
                containerClassName: "space-x-1 text-puma-black-300"
            }
        }));
    }
    if (!copy) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "text-lg font-display max-w-5xl text-puma-grey-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
            content: copy
        })
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
;// CONCATENATED MODULE: ./ui/content/BodyHeader.tsx











var BodyHeader = function(param) {
    var header = param.header, horizontalAlignment = param.horizontalAlignment, size = param.size, _id = param._id, _type = param._type, link = param.link;
    var asPath = (0,next_router.useRouter)().asPath;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var _obj;
    var Tag = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* GenericTextSize.Large */.L0X.Large, "h1"), (0,_define_property/* default */.Z)(_obj, graphql/* GenericTextSize.Medium */.L0X.Medium, "h2"), (0,_define_property/* default */.Z)(_obj, graphql/* GenericTextSize.Small */.L0X.Small, "h3"), _obj)[size || graphql/* GenericTextSize.Small */.L0X.Small];
    var _obj1;
    var headingSize = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, graphql/* GenericTextSize.Large */.L0X.Large, {
        initial: "sm",
        sm: "base",
        md: "lg"
    }), (0,_define_property/* default */.Z)(_obj1, graphql/* GenericTextSize.Medium */.L0X.Medium, {
        initial: "xs",
        sm: "sm",
        md: "base"
    }), (0,_define_property/* default */.Z)(_obj1, graphql/* GenericTextSize.Small */.L0X.Small, {
        initial: "xxs",
        sm: "xs",
        md: "sm"
    }), _obj1)[size || graphql/* GenericTextSize.Small */.L0X.Small];
    var promotion_id = _id || "";
    var promotion_name = header || "";
    var creative_name = _type || "BodyHeader";
    var bodyHeaderRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ctaLink = getLink(link);
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        cta_links: ctaLink ? [
            ctaLink
        ] : []
    });
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(bodyHeaderRef, extendedGaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: ctaLink,
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOrTag, {
        dataTestId: "body-header",
        ga4Data: ga4Data,
        href: ctaLink,
        query: link === null || link === void 0 ? void 0 : link.query,
        linkType: constants/* SLOT_LINK_TYPE.LINK */.no.LINK,
        tag: TagType.H1,
        ref: bodyHeaderRef,
        headingSize: headingSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
            className: "text-".concat(horizontalAlignment),
            children: header
        })
    });
};

// EXTERNAL MODULE: ./ui/elements/LayoutContainer.tsx
var LayoutContainer = __webpack_require__(2254);
;// CONCATENATED MODULE: ./ui/content/SplitHero.tsx


















var SplitHero = function(param) {
    var backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage, _campaignId = param.campaignId, campaignId = _campaignId === void 0 ? "" : _campaignId, copy = param.copy, countdownClock = param.countdownClock, _ctas = param.ctas, ctas = _ctas === void 0 ? [] : _ctas, linkType = param.linkType, link = param.link, footnote = param.footnote, _header = param.header, header = _header === void 0 ? "" : _header, _horizontalAlignment = param.horizontalAlignment, horizontalAlignment = _horizontalAlignment === void 0 ? "center" : _horizontalAlignment, headingTag = param.headingTag, layout = param.layout, logo = param.logo, mobileBackgroundImage = param.mobileBackgroundImage, puid = param.puid, textColor = param.textColor, id = param.id, _type = param._type, priority = param.priority;
    var ref, ref1, ref2, ref3, ref4;
    var asPath = (0,next_router.useRouter)().asPath;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var hAlign = alignmentToFlexDirection(horizontalAlignment);
    var hasContent = header || copy || footnote || ctas && ctas.length > 0;
    var imageDimensions = backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref = backgroundImage.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.dimensions;
    var mobileImageDimensions = mobileBackgroundImage === null || mobileBackgroundImage === void 0 ? void 0 : (ref2 = mobileBackgroundImage.asset) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : ref3.dimensions;
    var splitHeroRef = (0,react.useRef)(null);
    var promotion_name = header || "";
    var gaTrackData = {
        id: (puid === null || puid === void 0 ? void 0 : puid.current) || "",
        name: promotion_name,
        creative: "split-hero",
        campaign: campaignId,
        position: ""
    };
    var navigateTo = (0,urls/* slotLink */.RF)(linkType, ctas, link);
    var promotion_id = id;
    var creative_name = _type || "SplitHero";
    var ctasLinks = (ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: ctasLinks
    });
    var ref5 = (0,usePromotionView/* usePromotionView */.Y)(splitHeroRef, extendedGaTrackData), promotionTrackerPosition = ref5.promotionTrackerPosition, ga4PromotionTrackerPosition = ref5.ga4PromotionTrackerPosition;
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: getLink(navigateTo),
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkOrTag, {
            dataLinkLoc: "banner",
            className: (0,twind.tw)("relative flex mobile:flex-col", layout === "left" ? "flex-row-reverse" : "flex-row"),
            ref: splitHeroRef,
            query: navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.query,
            newtab: !!(navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.newtab),
            href: getLink(navigateTo),
            gaBannerData: gaTrackData,
            ga4Data: ga4Data,
            linkType: linkType,
            tag: TagType.ARTICLE,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full aspect-".concat((mobileImageDimensions === null || mobileImageDimensions === void 0 ? void 0 : mobileImageDimensions.width) || (imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.width), "-").concat((mobileImageDimensions === null || mobileImageDimensions === void 0 ? void 0 : mobileImageDimensions.height) || (imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height), " md:aspect-").concat(imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.width, "-").concat(imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                        source: backgroundImage,
                        mobileSource: mobileBackgroundImage,
                        priority: priority
                    })
                }),
                hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full tablet:w-2/4 desktop:w-2/5 flex-none flex-col items-center p-8 pt-6 tablet:p-10 desktop:p-16 text-[".concat(textColor, "] bg-[").concat(backgroundColor, "]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: (logo === null || logo === void 0 ? void 0 : (ref4 = logo.asset) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                                className: "h-14 w-max mobile:m-auto",
                                source: logo,
                                relative: true,
                                priority: priority
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative w-full h-full flex flex-col items-".concat(hAlign, " justify-center mobile:items-center"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-".concat(horizontalAlignment, " mobile:text-center"),
                                    children: [
                                        header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                                            header: header,
                                            className: "mobile:text-3xl tablet:text-4xl desktop:text-5xl font-bold font-display leading-tight",
                                            headingTag: headingTag
                                        }),
                                        copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-base desktop:text-2xl leading-tight",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                                content: copy
                                            })
                                        }),
                                        footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mobile:text-xs tablet:text-sm desktop:text-base mt-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                                content: footnote
                                            })
                                        })
                                    ]
                                }),
                                countdownClock && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownClock/* CountdownClock */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, countdownClock), {
                                    config: {
                                        showLabels: true,
                                        labelClassName: "text-xs desktop:text-sm uppercase desktop:font-bold",
                                        timeUnitClassName: "text-[32px] xl:text-[56px] font-normal",
                                        containerClassName: "py-6 space-x-8 xl:space-x-12"
                                    }
                                })),
                                linkType === constants/* SLOT_LINK_TYPE.CTA */.no.CTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap justify-".concat(hAlign, " mobile:justify-center flex-gap-3 md:flex-gap-4"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                        ctas: ctas,
                                        gaBannerData: gaTrackData,
                                        ga4Data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Data), {
                                            link_url: ctasLinks[0] || ""
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./hooks/useResizeObserver.ts
var useResizeObserver = __webpack_require__(13765);
// EXTERNAL MODULE: ./ui/elements/ImageOverlay.tsx
var ImageOverlay = __webpack_require__(26730);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
;// CONCATENATED MODULE: ./utils/whiteToBlack.ts


var whiteToBlack = function(x) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
        variant: x.variant === "white" ? "black" : x.variant
    });
};

// EXTERNAL MODULE: ./hooks/a11y/index.ts + 4 modules
var a11y = __webpack_require__(71129);
;// CONCATENATED MODULE: ./ui/content/FullBleedHero.tsx


























var FullBleedHero = function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, backgroundImage = param.backgroundImage, backgroundOverlay = param.backgroundOverlay, campaignId = param.campaignId, copy = param.copy, countdownClock = param.countdownClock, _ctas = param.ctas, ctas = _ctas === void 0 ? [] : _ctas, disclaimer = param.disclaimer, linkType = param.linkType, link = param.link, footnote = param.footnote, header = param.header, headingTag = param.headingTag, _horizontalAlignment = param.horizontalAlignment, horizontalAlignment = _horizontalAlignment === void 0 ? "left" : _horizontalAlignment, id = param.id, logo = param.logo, logoMobile = param.logoMobile, logoPosition = param.logoPosition, minAspectRatio = param.minAspectRatio, mobileBackgroundImage = param.mobileBackgroundImage, mobileBackgroundOverlay = param.mobileBackgroundOverlay, overlayContent = param.overlayContent, puid = param.puid, priority = param.priority, _textAlignment = param.textAlignment, textAlignment = _textAlignment === void 0 ? "left" : _textAlignment, _textColor = param.textColor, textColor = _textColor === void 0 ? "#ffffff" : _textColor, _type = param._type, _verticalAlignment = param.verticalAlignment, verticalAlignment = _verticalAlignment === void 0 ? "middle" : _verticalAlignment;
    var ref, ref1, ref2, ref3;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref4 = (0,useResizeObserver/* useResizeObserver */.y)(), ref5 = ref4.ref, width = ref4.width;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var isMobile = (0,media/* getIsMobile */.W)();
    var ref6 = (0,react.useState)(false), isTooltipOpen = ref6[0], setTooltipOpen = ref6[1];
    var tooltipRef = (0,react.useRef)(null);
    var buttonIconRef = (0,react.useRef)(null);
    var tooltipContainerId = "tooltip-container-".concat(id);
    (0,a11y/* useDialogDismiss */.sH)({
        ref: tooltipRef,
        external: tooltipRef,
        handler: function(e) {
            var firstTooltipContainer = document.getElementById(tooltipContainerId); // tooltipRef didn't work because the tooltip is rendered twice for some reason...
            if ((e === null || e === void 0 ? void 0 : e.target) && (firstTooltipContainer === e.target || (firstTooltipContainer === null || firstTooltipContainer === void 0 ? void 0 : firstTooltipContainer.contains(e.target)))) {
                return;
            }
            if (!(e === null || e === void 0 ? void 0 : e.target) || !buttonIconRef.current || !buttonIconRef.current.contains(e === null || e === void 0 ? void 0 : e.target)) {
                setTooltipOpen(!isTooltipOpen);
            }
        }
    });
    var ctasAlign = alignmentToFlexDirection(textAlignment);
    var hAlign = alignmentToFlexDirection(horizontalAlignment);
    var vAlign = alignmentToFlexDirection(verticalAlignment);
    var imageDimensions = backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref = backgroundImage.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.dimensions;
    var mobileImageDimensions = mobileBackgroundImage === null || mobileBackgroundImage === void 0 ? void 0 : (ref2 = mobileBackgroundImage.asset) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : ref3.dimensions;
    // NOTE: will result in { w: 100, h: 56.25 } as an example
    // as a fraction 56.25/100 simplified is 9/16 giving the 16:9 ratio
    var aspectRatio = {
        w: minAspectRatio !== 0 ? 100 : null,
        h: minAspectRatio !== 0 ? minAspectRatio * 100 : null
    };
    var imgWidth = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.w) || (imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.width);
    var imgHeight = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.h) || (imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height);
    var hasContent = header || copy || footnote || ctas && ctas.length > 0 || (logo === null || logo === void 0 ? void 0 : logo.asset) || (logoMobile === null || logoMobile === void 0 ? void 0 : logoMobile.asset);
    var countdownConfig = {
        showLabels: true,
        labelClassName: "text-xs desktop:text-sm uppercase desktop:font-bold",
        timeUnitClassName: "text-[32px] desktop:text-[56px] font-normal",
        containerClassName: "my-6 space-x-8 desktop:space-x-12"
    };
    var promotion_name = header || "";
    var gaTrackData = {
        id: (puid === null || puid === void 0 ? void 0 : puid.current) || "",
        name: promotion_name,
        creative: "full-bleed-hero",
        campaign: campaignId || "",
        position: ""
    };
    var navigateTo = (0,urls/* slotLink */.RF)(linkType, ctas, link);
    var promotion_id = id;
    var creative_name = _type || "FullBleedHero";
    var ctasLinks = (ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: ctasLinks
    });
    var ref7 = (0,usePromotionView/* usePromotionView */.Y)(ref5, extendedGaTrackData), promotionTrackerPosition = ref7.promotionTrackerPosition, ga4PromotionTrackerPosition = ref7.ga4PromotionTrackerPosition;
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: getLink(navigateTo),
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        "data-test-id": "full-bleed-hero-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkOrTag, {
            linkType: linkType,
            tag: TagType.SECTION,
            ref: ref5,
            dataLinkLoc: "banner",
            query: navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.query,
            href: getLink(navigateTo),
            newtab: !!(navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.newtab),
            gaBannerData: gaTrackData,
            ga4Data: ga4Data,
            className: (0,css.tw)("bg-[".concat(backgroundColor, "]"), "relative flex items-".concat(vAlign, " justify-").concat(hAlign, " inset-0 w-full aspect-").concat(imgWidth, "-").concat(imgHeight), "mobile:(relative flex-col items-center justify-center w-full aspect-".concat((mobileImageDimensions === null || mobileImageDimensions === void 0 ? void 0 : mobileImageDimensions.width) || imgWidth, "-").concat((mobileImageDimensions === null || mobileImageDimensions === void 0 ? void 0 : mobileImageDimensions.height) || imgHeight, ")")),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute top-0 left-0 w-full h-full mobile:relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                            priority: priority,
                            source: backgroundImage,
                            mobileSource: mobileBackgroundImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOverlay/* ImageOverlay */.v, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backgroundOverlay), {
                            className: "hidden desktop:block"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOverlay/* ImageOverlay */.v, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mobileBackgroundOverlay), {
                            className: "block desktop:hidden"
                        })),
                        !!disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-0 right-0 pr-8 pb-6 mobile:pr-6 mobile:pb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TooltipRoot */.wYI, {
                                invert: true,
                                side: "top",
                                align: "end",
                                open: isTooltipOpen,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TooltipTrigger */.aJU, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonIcon */.Eik, {
                                            ref: buttonIconRef,
                                            label: "Disclaimer",
                                            icon: "info-outline",
                                            variant: "primary",
                                            size: "xs",
                                            invert: true,
                                            round: true,
                                            onClick: function(e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setTooltipOpen(!isTooltipOpen);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TooltipContent */._vU, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: tooltipContainerId,
                                            className: "line-clamp-7",
                                            ref: tooltipRef,
                                            onClick: function(e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                                                blocks: disclaimer,
                                                serializers: serializeBlockContent/* serializeBlockContent */.H6
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,css.tw)("relative p-6 desktop:p-12 xl:p-16 flex flex-col", "text-".concat(textAlignment, " items-").concat(ctasAlign, " text-[").concat(textColor, "]"), {
                        "mobile:w-full absolute": overlayContent,
                        "mobile:(relative items-center text-center)": !overlayContent,
                        // if content below and not background-color, use back text
                        "mobile:text-black": !overlayContent && !backgroundColor
                    }),
                    children: [
                        header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                            header: header,
                            className: (0,css.tw)("font-bold leading-tight", "mobile:text-2xl tablet:text-3xl desktop:text-4xl xl:text-5xl"),
                            headingTag: headingTag
                        }),
                        copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (0,css.tw)("mt-1 leading-tight mobile:text-sm tablet:xs:text-lg desktop:text-xl xl:text-2xl"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                content: copy
                            })
                        }),
                        footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mobile:text-xs tablet:text-sm desktop:text-base mt-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                content: footnote
                            })
                        }),
                        countdownClock && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownClock/* CountdownClock */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, countdownClock), {
                            config: countdownConfig
                        })),
                        linkType === constants/* SLOT_LINK_TYPE.CTA */.no.CTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,css.tw)("flex flex-wrap flex-gap-2 xs:flex-gap-4", !countdownClock && "mt-6", "justify-center md:justify-".concat(ctasAlign)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                ctas: !overlayContent && isMobile ? ctas === null || ctas === void 0 ? void 0 : ctas.map(whiteToBlack) : ctas,
                                gaBannerData: gaTrackData,
                                ga4Data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Data), {
                                    link_url: ctasLinks[0] || ""
                                }),
                                linkProps: {
                                    // Avoid hydration issues:
                                    // If parent LinkOrTag will render as Link, don't render this with an anchor
                                    isAnchor: !(linkType && getLink(navigateTo))
                                }
                            })
                        }, "ctas-" + width),
                        ((logo === null || logo === void 0 ? void 0 : logo.asset) || (logoMobile === null || logoMobile === void 0 ? void 0 : logoMobile.asset)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,css.tw)("max-w-32", logoPosition === "above" ? "order-[-1] mb-4" : "order-1 mt-4"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                                source: logo,
                                mobileSource: logoMobile,
                                relative: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./ui/components/VideoOrImage.tsx
var VideoOrImage = __webpack_require__(4692);
;// CONCATENATED MODULE: ./ui/content/FeatureHero.tsx














var FeatureHero = function(props) {
    var ref, ref1, ref2;
    var asPath = (0,next_router.useRouter)().asPath;
    var promotionId = props._id || "";
    var promotionName = props.header || "";
    var creativeName = props._type || "FeatureHero";
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var featureHeroRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotionId,
        name: promotionName,
        creative: creativeName
    };
    var ctasLinks = ((ref = props.ctas) === null || ref === void 0 ? void 0 : ref.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        cta_links: ctasLinks
    });
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(featureHeroRef, extendedGaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creativeName,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotionId,
        promotion_name: promotionName,
        link_url: ctasLinks[0] || "",
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "sm:pb-10 relative",
        "data-test-id": "feature-hero-section",
        ref: featureHeroRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
                bleed: true,
                className: "absolute h-4/5 top-10 hidden sm:block bg-[".concat(props.backgroundColor, "]")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid sm:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative pt-96 sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                            image: props.optionalPrimaryImage,
                            video: props.primaryVideo
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex flex-col items-center sm:items-start mt-8 mb-10 sm:mb-12 sm:mt-16",
                                children: [
                                    ((ref1 = props.logo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.asset) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                                        className: "h-24 w-max mobile:m-auto",
                                        source: props.logo,
                                        relative: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative z-10 text-center text-[".concat(props.textColor, "] sm:text-left px-4 sm:px-0 pt-0 lg:pt-6 sm:pr-16 lg:pr-32"),
                                        children: [
                                            props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                                                header: props.header,
                                                className: "text-4xl lg:text-5xl font-bold leading-tight",
                                                headingTag: props.headingTag
                                            }),
                                            props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xl lg:text-2xl leading-tight",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                                    content: props.copy
                                                })
                                            }),
                                            props.footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                                    content: props.footnote
                                                })
                                            }),
                                            props.ctas && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative flex flex-wrap justify-center sm:justify-start flex-gap-3 md:flex-gap-4 mt-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                                    ctas: props.ctas,
                                                    ga4Data: ga4Data
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative pt-56 lg:pt-96",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                                    image: props.optionalSecondaryImage,
                                    video: props.secondaryVideo
                                })
                            }),
                            props.ctas && props.ctas[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                query: props.ctas[0].query,
                                newtab: !!props.ctas[0].newtab,
                                href: ctasLinks[0] || "",
                                className: "absolute inset-0 h-full w-full",
                                "aria-hidden": true,
                                tabIndex: -1,
                                ga4Data: ga4Data
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative pt-96 -ml-10 -mb-10 z-0 hidden sm:block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                                image: props.optionalPrimaryImage,
                                video: props.primaryVideo
                            }),
                            props.ctas && props.ctas[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                query: props.ctas[0].query,
                                newtab: !!props.ctas[0].newtab,
                                href: ctasLinks[0] || "",
                                className: "absolute inset-0 h-full w-full",
                                "aria-hidden": true,
                                tabIndex: -1
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useDeviceOrientation.ts
var useDeviceOrientation = __webpack_require__(30030);
// EXTERNAL MODULE: ./ui/components/SanityVideo.tsx + 1 modules
var SanityVideo = __webpack_require__(68020);
;// CONCATENATED MODULE: ./ui/content/VideoHero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "pointer-events-none absolute inset-0 p-4 tablet:p-8 desktop:p-12 xl:p-16 flex flex-col items-",
        " justify-",
        " text-",
        "",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var VideoHero = function(props) {
    var ref, ref1, ref2, ref3;
    var videoHeroRef = (0,react.useRef)(null);
    var width = (0,useResizeObserver/* useResizeObserver */.y)(videoHeroRef).width;
    var deviceOrientation = (0,useDeviceOrientation/* useDeviceOrientation */.J)();
    var isMobile = (0,media/* getIsMobile */.W)();
    var isMobileUserAgent = (0,useSiteConfig/* useSiteConfig */.N)().isMobileUserAgent;
    var tAlign = props.horizontalAlignment || "left";
    var hAlign = alignmentToFlexDirection(props.horizontalAlignment || "left");
    var vAlign = alignmentToFlexDirection(props.verticalAlignment || "middle");
    var header = props.header, copy = props.copy, footnote = props.footnote, ctas = props.ctas;
    var hasContent = Boolean(header || copy || footnote || (ctas === null || ctas === void 0 ? void 0 : ctas.length));
    var backgroundVideo = ((ref = props.backgroundVideoObject) === null || ref === void 0 ? void 0 : (ref1 = ref.source) === null || ref1 === void 0 ? void 0 : ref1.url) ? props.backgroundVideoObject : {
        source: props.backgroundVideo
    };
    var mobileBackgroundVideo = ((ref2 = props.mobileBackgroundVideoObject) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.source) === null || ref3 === void 0 ? void 0 : ref3.url) ? props.mobileBackgroundVideoObject : props.mobileBackgroundVideo ? {
        source: props.mobileBackgroundVideo
    } : backgroundVideo;
    var video = isMobile || isMobileUserAgent && deviceOrientation === "portrait" || constants/* isServer */.sk && isMobileUserAgent ? mobileBackgroundVideo : backgroundVideo;
    var shouldMapWhiteCTAsToBlack = !props.overlayContent && isMobile;
    var ctasToRender = shouldMapWhiteCTAsToBlack ? ctas === null || ctas === void 0 ? void 0 : ctas.map(whiteToBlack) : ctas;
    var promotion_id = props.id || "";
    var promotion_name = props.header || "";
    var creative_name = props._type || "VideoHero";
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(videoHeroRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: undefined,
        cta_click: undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        "data-test-id": "video-hero",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            ref: videoHeroRef,
            className: "relative flex flex-col items-".concat(vAlign, " justify-").concat(hAlign),
            children: [
                !!video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityVideo/* SanityVideo */.m, {
                        video: video,
                        videoOptions: {
                            autoPlay: props.autoplay,
                            controls: props.controls,
                            loop: props.loop,
                            muted: props.mute
                        },
                        className: "w-full",
                        onContextMenu: function(e) {
                            return e.preventDefault();
                        },
                        controlsList: "nodownload nofullscreen",
                        disablePictureInPicture: true,
                        disableRemotePlayback: true,
                        playsInline: true,
                        preload: props.priority ? "auto" : "none",
                        priority: props.priority
                    })
                }),
                hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,css.tw)((0,css/* apply */.nn)(_templateObject(), hAlign, vAlign, tAlign, props.textColor && " text-[".concat(props.textColor, "]")), props.horizontalAlignment && "text-".concat(props.horizontalAlignment), !props.overlayContent && "mobile:(w-full relative items-center text-center text-black)"),
                    "data-test-id": "video-hero-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-inherit",
                            children: [
                                props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                                    header: props.header,
                                    className: (0,css.tw)("pointer-events-auto font-bold", props.minAspectRatio === 0.25 ? "mobile:text-2xl tablet:text-3xl desktop:text-4xl xl:text-5xl" : "mobile:text-3xl tablet:text-4xl desktop:text-5xl xl:text-6xl"),
                                    headingTag: props.headingTag,
                                    dataTestId: "video-hero-header"
                                }),
                                props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pointer-events-auto mt-1 mobile:text-sm tablet:xs:text-lg desktop:text-xl xl:text-2xl",
                                    "data-test-id": "video-hero-copy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.copy
                                    })
                                }),
                                props.footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pointer-events-auto mobile:text-xs tablet:text-sm desktop:text-base mt-1",
                                    "data-test-id": "video-hero-footnote",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.footnote
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,css.tw)("flex flex-wrap gap-2 xs:gap-4 mt-3", "mobile:justify-center justify-".concat(hAlign)),
                            "data-test-id": "video-hero-ctas",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                ctas: ctasToRender,
                                ga4Data: ga4Data
                            })
                        }, "ctas-" + width)
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./ui/content/ProductCarousel.tsx
var ProductCarousel = __webpack_require__(48204);
;// CONCATENATED MODULE: ./ui/content/ProductCarouselSkeleton.tsx




/**
 * A thin wrapper on ProductCarousel that will force the component to render its
 * skeleton (which was already defined within the ProductCarousel component)
 */ var ProductCarouselSkeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel/* ProductCarousel */.GM, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        skeletonOnly: true
    }));
};

// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(38579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/toKebabCase.ts
var toKebabCase = __webpack_require__(36662);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./hooks/useItemListViewEvent.ts
var useItemListViewEvent = __webpack_require__(35538);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
// EXTERNAL MODULE: ./hooks/useProductClickHandling.ts
var useProductClickHandling = __webpack_require__(7362);
// EXTERNAL MODULE: ./hooks/usePdp.tsx + 1 modules
var usePdp = __webpack_require__(41316);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
// EXTERNAL MODULE: ./utils/referrerParametersUtils.ts
var referrerParametersUtils = __webpack_require__(74067);
;// CONCATENATED MODULE: ./utils/imageLoaders.ts
function sanityImageLoader(param) {
    var src = param.src, width = param.width, quality = param.quality;
    var url = new URL(src);
    url.searchParams.set("auto", "format");
    url.searchParams.set("w", width.toString());
    if (quality) {
        url.searchParams.set("q", quality === null || quality === void 0 ? void 0 : quality.toString());
    }
    return url.href;
}
function cloudinaryImageLoader(param) {
    var src = param.src, width = param.width, quality = param.quality;
    var href = src.replace(/w_\d+/, "w_".concat(width.toString())).replace(/h_\d+/, "h_".concat(width.toString()));
    if (quality) {
        href = href.replace(/q_\d+|q_auto/, "q_".concat(quality.toString()));
    }
    return href;
}

;// CONCATENATED MODULE: ./ui/content/ProductComparison.tsx




function ProductComparison_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  td {\n    @apply px-4 py-4 text-center;\n  }\n  th {\n    @apply px-6 py-4 text-left uppercase border-white border-r-[1vw];\n  }\n  & > tbody > :nth-child(odd) {\n    @apply bg-puma-black-800;\n  }\n  & > tbody > :nth-child(even) {\n    @apply bg-white;\n  }\n  & > tbody > :last-of-type {\n    @apply bg-white;\n  }\n"
    ]);
    ProductComparison_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var tableStyles = (0,style/* css */.iv)(ProductComparison_templateObject());
var ProductComparison = function(props) {
    var ref;
    var header = props.header;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var pdp = (0,usePdp/* usePdp */.Y)();
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), currency = ref1.currency, regionCode = ref1.regionCode, _staticFeatures = ref1.staticFeatures, searchLocalImagesOnProductComparison = _staticFeatures.searchLocalImagesOnProductComparison, showHeaderSubHeaderProductDetail = _staticFeatures.showHeaderSubHeaderProductDetail;
    var router = (0,next_router.useRouter)();
    var productId = router.query.id;
    var ref2 = (0,react.useState)(function() {
        if (!props.__typename) return props.products;
        return props.products.map(function(product) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product.product), {
                comparisonFields: product === null || product === void 0 ? void 0 : (ref = product.comparisonFields) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
                    acc[curr.name] = curr.value;
                    return acc;
                }, {})
            });
        }).sort(function(a) {
            return a.masterId === productId ? -1 : 1;
        });
    }), products = ref2[0];
    var getImageURL = function(product) {
        var ref;
        if (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0]) return product.images[0].href;
        var url = "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/".concat(product === null || product === void 0 ? void 0 : product.masterId, "/").concat((product === null || product === void 0 ? void 0 : product.color) || (product === null || product === void 0 ? void 0 : product.colorValue));
        if (!searchLocalImagesOnProductComparison) return "".concat(url, "/sv01");
        if (!pdp || pdp && pdp.productDivision === "Footwear") {
            url += "/sv01";
        }
        return "".concat(url, "/fnd/").concat(regionCode);
    };
    var itemListId = props.id;
    var itemListName = props._type || "";
    var listItems = (0,react.useMemo)(function() {
        if (!props.products) return [];
        return props.products.map(function(product, index) {
            return (0,analytics/* transformListProductToAnalyticsItem */.pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: undefined
                },
                itemListId: itemListId,
                itemListName: itemListName,
                index: index
            });
        });
    }, [
        props.products,
        currency.code,
        itemListId,
        itemListName
    ]);
    var productComparisonRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: props.id,
        name: header || "",
        creative: props._type || "ProductComparison"
    };
    (0,usePromotionView/* usePromotionView */.Y)(productComparisonRef, gaTrackData, false, true);
    (0,useItemListViewEvent/* useItemListViewEvent */.t)({
        itemListId: itemListId,
        itemListName: itemListName,
        items: listItems.map(function(item) {
            return (0,_object_spread/* default */.Z)({}, item);
        })
    });
    // To differentiate in which ProductComparision the click occurred.
    var setIsProductClicked = (0,useProductClickHandling/* useProductClickHandling */.g)();
    var ref3 = (0,useGA4Events/* useGA4Events */.tL)(), setProduct = ref3.setProduct, fireClickProductImage = ref3.fireClickProductImage;
    var handleButtonClick = function() {
        var ref;
        (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.Comparison */.Ei.Comparison);
        (ref = document.querySelector("#pdp-product-title")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    var handleLinkClick = function(product, i) {
        (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.Comparison */.Ei.Comparison);
        var imageUrl = getImageURL(product);
        fireClickProductImage(imageUrl);
        var ref;
        (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(product.masterId, "_").concat((ref = product === null || product === void 0 ? void 0 : product.colorValue) !== null && ref !== void 0 ? ref : product === null || product === void 0 ? void 0 : product.color), {
            lid: itemListId,
            lname: itemListName,
            idx: i - 1
        });
        setProduct(product);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,style.tw)("relative w-full"),
        "aria-label": header || undefined,
        ref: productComparisonRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,style.tw)("max-w-full overflow-x-auto"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                className: (0,style.tw)("table-fixed", tableStyles),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            onClick: function() {
                                return setIsProductClicked(true);
                            },
                            children: [
                                props.header
                            ].concat((0,_to_consumable_array/* default */.Z)(products)).map(function(product, i) {
                                return i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "min-w-[220px] lg:min-w-[315px] lg:max-w-[360px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "font-bold uppercase text-[1.75rem]",
                                        children: header
                                    })
                                }, header) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    className: "bg-white!",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: (0,buildProductUrl/* buildProductUrl */.B)(product.masterId, (product === null || product === void 0 ? void 0 : product.productName) || (product === null || product === void 0 ? void 0 : product.name), {
                                            color: (product === null || product === void 0 ? void 0 : product.colorValue) || product.color
                                        }),
                                        onClick: function() {
                                            return handleLinkClick(product, i);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-4 border flex justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                alt: (product === null || product === void 0 ? void 0 : product.productName) || (product === null || product === void 0 ? void 0 : product.name),
                                                src: getImageURL(product),
                                                loader: cloudinaryImageLoader,
                                                height: 600,
                                                width: 600
                                            })
                                        })
                                    }, product.productId)
                                }, product.productId);
                            })
                        }),
                        props === null || props === void 0 ? void 0 : (ref = props.comparisonFields) === null || ref === void 0 ? void 0 : ref.map(function(field, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: [
                                    field
                                ].concat((0,_to_consumable_array/* default */.Z)(products)).map(function(product, i) {
                                    var ref, ref1;
                                    return i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: field
                                    }, field) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: field === "Name" && showHeaderSubHeaderProductDetail && product.header ? product.header : field === "Category" && showHeaderSubHeaderProductDetail && product.subHeader ? product.subHeader : ((ref = product.comparisonFields) === null || ref === void 0 ? void 0 : ref["field_".concat(idx, "_").concat(product.masterId)]) ? product.comparisonFields["field_".concat(idx, "_").concat(product.masterId)] : ((ref1 = product.comparisonFields) === null || ref1 === void 0 ? void 0 : ref1[(0,toKebabCase/* toKebabCase */.m)(field)]) ? product.comparisonFields[(0,toKebabCase/* toKebabCase */.m)(field)] : "-"
                                    }, product.productId + field);
                                })
                            }, field + idx);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: [
                                props.header
                            ].concat((0,_to_consumable_array/* default */.Z)(products)).map(function(product, i) {
                                return i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}, header) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center w-[14rem] mx-auto",
                                        onClick: function() {
                                            return setIsProductClicked(true);
                                        },
                                        children: product.masterId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            className: "w-full",
                                            type: "button",
                                            variant: "secondary",
                                            onClick: function() {
                                                return handleButtonClick();
                                            },
                                            label: t("productComparisonCtaCurrent")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                                            className: "w-full",
                                            variant: "secondary",
                                            href: (0,buildProductUrl/* buildProductUrl */.B)(product.masterId, (product === null || product === void 0 ? void 0 : product.productName) || (product === null || product === void 0 ? void 0 : product.name), {
                                                color: (product === null || product === void 0 ? void 0 : product.colorValue) || product.color
                                            }),
                                            label: t("productComparisonCta"),
                                            onClick: function() {
                                                return handleLinkClick(product, i);
                                            }
                                        })
                                    })
                                }, product.productId);
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./ui/content/FeaturesGrid.tsx















var smallImageStyles = "relative pt-72 flex-grow hidden lg:col-span-2 lg:block";
var largeImageStyles = "relative pt-72 flex-grow md:col-span-4";
var FeatureGridRow = function(param) {
    var layout = param.layout, primaryImage = param.primaryImage, mobilePrimaryImage = param.mobilePrimaryImage, secondaryImage = param.secondaryImage, ctas = param.ctas, header = param.header, headingTag = param.headingTag, copy = param.copy, id = param.id, _type = param._type, priority = param.priority;
    var asPath = (0,next_router.useRouter)().asPath;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var promotionId = id;
    var promotionName = header || "";
    var creativeName = _type || "FeaturesGridRow";
    var featureGridRowRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotionId,
        name: promotionName,
        creative: creativeName
    };
    var ctasLinks = (ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        cta_links: ctasLinks
    });
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(featureGridRowRef, extendedGaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creativeName,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotionId,
        promotion_name: promotionName,
        link_url: ctasLinks[0] || "",
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex ".concat(layout === "left" ? "flex-col-reverse" : "flex-col", " md:grid md:grid-cols-8"),
        ref: featureGridRowRef,
        children: [
            layout === "left" ? secondaryImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: smallImageStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: secondaryImage,
                    priority: priority
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: largeImageStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: primaryImage,
                    mobileSource: mobilePrimaryImage,
                    priority: priority
                })
            }),
            !!(ctas === null || ctas === void 0 ? void 0 : ctas.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                query: ctas[0].query,
                newtab: !!ctas[0].newtab,
                href: ctasLinks[0] || "",
                className: "absolute inset-0 h-full w-full",
                "aria-hidden": true,
                tabIndex: -1,
                ga4Data: ga4Data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col items-center justify-center pb-2 p-4 md:pb-7 text-center text-puma-black md:col-span-4 ".concat(secondaryImage ? "lg:col-span-2" : ""),
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                        header: header,
                        className: (0,css.tw)("font-bold text-xl"),
                        headingTag: headingTag
                    }),
                    copy && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            content: copy
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap justify-center flex-gap-3 lg:flex-gap-4 mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                            ctas: ctas,
                            ga4Data: ga4Data
                        })
                    })
                ]
            }),
            layout === "left" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: largeImageStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: primaryImage,
                    mobileSource: mobilePrimaryImage,
                    priority: priority
                })
            }) : secondaryImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: smallImageStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: secondaryImage,
                    priority: priority
                })
            })
        ]
    });
};
var FeaturesGrid = function(props) {
    var ref;
    var asPath = (0,next_router.useRouter)().asPath;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var featuresGridRef = (0,react.useRef)(null);
    var creative_name = props._type || "FeaturesGrid";
    var promotion_id = props._id || "";
    var gaTrackData = {
        id: props._id,
        name: "",
        creative: creative_name,
        promotion_id: promotion_id
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(featuresGridRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: "",
        link_url: getLink(props.link),
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOrTag, {
        href: getLink(props.link),
        linkType: constants/* SLOT_LINK_TYPE.LINK */.no.LINK,
        className: "space-y-4 md:space-y-0",
        ga4Data: ga4Data,
        tag: TagType.SECTION,
        ref: featuresGridRef,
        children: (ref = props.featureRows) === null || ref === void 0 ? void 0 : ref.map(function(featureRow) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureGridRow, (0,_object_spread/* default */.Z)({}, featureRow), featureRow.id);
        })
    });
};

// EXTERNAL MODULE: ./hooks/useHorizontalScroll.ts
var useHorizontalScroll = __webpack_require__(42833);
// EXTERNAL MODULE: ./ui/components/ChevronButton.tsx
var ChevronButton = __webpack_require__(24393);
;// CONCATENATED MODULE: ./ui/content/ProductGroupFeatures.tsx







var ProductGroupFeatures = function(props) {
    var ref;
    var ref1 = (0,useHorizontalScroll/* useHorizontalScroll */.m)(), ref2 = ref1.ref, prev = ref1.prev, next = ref1.next, overflowing = ref1.overflowing;
    var gridStyles = "grid gap-4 xs:grid-cols-2 md:grid-cols-3";
    var scrollStyles = "flex w-full overflow-x-scroll pb-6 space-x-4";
    var gaTrackData = {
        id: props.id || "",
        name: "",
        creative: props._type || "ProductGroupFeatures"
    };
    (0,usePromotionView/* usePromotionView */.Y)(ref2, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref2,
                className: (0,twind.tw)({
                    "desktop:": gridStyles,
                    "mobile:": scrollStyles,
                    "tablet:": scrollStyles
                }),
                style: {
                    scrollSnapType: "x mandatory"
                },
                children: (ref = props.productFeatures) === null || ref === void 0 ? void 0 : ref.map(function(feature) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-4 text-".concat(feature.horizontalAlignment, " min-w-[50%] md:min-w-[25%] md:w-1/3 lg:min-w-64 lg:w-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative pt-[150%]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                                        image: feature.image,
                                        header: feature.header,
                                        video: feature.video
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-1",
                                children: [
                                    feature.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                        tag: "h1",
                                        className: "font-bold text-xl",
                                        children: feature.header
                                    }),
                                    feature.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-puma-black-300",
                                        children: feature.copy
                                    })
                                ]
                            })
                        ]
                    }, feature.id);
                })
            }),
            overflowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                className: "mobile:hidden absolute -left-2 top-1/2 transform -translate-y-1/2",
                direction: "left",
                onClick: prev
            }),
            overflowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                className: "mobile:hidden absolute -right-2 top-1/2 transform -translate-y-1/2",
                direction: "right",
                onClick: next
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/content/QuoteCallout.tsx








var QuoteCallout = function(props) {
    var ref, ref1;
    var asPath = (0,next_router.useRouter)().asPath;
    var promotion_id = props.id || "";
    var promotion_name = props.header || "";
    var creative_name = props._type || "QuoteCallout";
    var quoteCalloutRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(quoteCalloutRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-puma-black relative pt-3 pb-6 sm:pt-6 sm:pb-8",
        "data-test-id": "quote-callout",
        ref: quoteCalloutRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center text-center space-y-4",
            children: [
                props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                    header: props.header,
                    className: (0,style.tw)([
                        "text-3xl md:text-4xl lg:text-5xl font-bold font-display leading-tight",
                        props.headerColor ? "text-[".concat(props.headerColor, "]") : "text-puma-black", 
                    ]),
                    headingTag: props.headingTag,
                    dataTestId: "quote-callout-header"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,style.tw)([
                        "lg:flex justify-center items-center"
                    ]),
                    children: [
                        props.quote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:flex flex-1 justify-center order-2",
                            "data-test-id": "quote-callout-quote",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                                className: "text-lg sm:text-2xl lg:text-4xl font-display max-w-5xl text-puma-black-300 m-0 lg:mx-8 xl:mx-14 pb-6 uppercase",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    content: props.quote
                                })
                            })
                        }),
                        Boolean(props.copy || ((ref = props.ctas) === null || ref === void 0 ? void 0 : ref.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,style.tw)([
                                "lg:flex flex-1 flex-wrap justify-center order-1 items-center flex-col max-w-5xl lg:px-10 xl:px-16",
                                props.quote && "lg:border-r-1", 
                            ]),
                            children: [
                                props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (0,style.tw)([
                                        "md:text-lg font-display text-center",
                                        props.copyColor ? "text-[".concat(props.copyColor, "]") : "text-puma-black-300", 
                                    ]),
                                    "data-test-id": "quote-callout-copy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.copy
                                    })
                                }),
                                Boolean((ref1 = props.ctas) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap justify-center flex-gap-4 pb-6 xs:pb-8 pt-4 py-4",
                                    "data-test-id": "quote-callout-ctas",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                        ctas: props.ctas,
                                        ga4Data: ga4Data
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./utils/extractProductVariants.ts
var extractProductVariants = __webpack_require__(71926);
// EXTERNAL MODULE: ./ui/components/ResponsiveProductImage.tsx
var ResponsiveProductImage = __webpack_require__(99531);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
;// CONCATENATED MODULE: ./ui/content/TrendingTile.tsx

























var SIDE_BY_SIDE = "SIDE_BY_SIDE";
var TRENDING_INLINE = "TRENDING_INLINE";
var TrendingTile = function(_param) {
    var _inSideBySide = _param.inSideBySide, inSideBySide = _inSideBySide === void 0 ? false : _inSideBySide, deferred = _param.deferred, tile = (0,_object_without_properties/* default */.Z)(_param, [
        "inSideBySide",
        "deferred"
    ]);
    var ref, ref1, ref2, ref3;
    var asPath = (0,next_router.useRouter)().asPath;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var countdownClock = tile.countdownClock;
    var overlayTextColor = "".concat(tile.textColor ? "text-[".concat(tile.textColor, "]") : "text-white");
    var trendingTileRef = (0,react.useRef)(null);
    var promotion_name = tile.header || ((ref = tile.ctas) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
    var gaTrackData = {
        id: ((ref2 = tile.puid) === null || ref2 === void 0 ? void 0 : ref2.current) || "",
        name: promotion_name,
        creative: "trending-tile",
        position: ""
    };
    var navigateTo = (0,urls/* slotLink */.RF)(tile === null || tile === void 0 ? void 0 : tile.linkType, tile === null || tile === void 0 ? void 0 : tile.ctas, tile === null || tile === void 0 ? void 0 : tile.link);
    var promotion_id = tile.id || "";
    var creative_name = tile._type || "TrendingTile";
    var ctasLinks = ((ref3 = tile.ctas) === null || ref3 === void 0 ? void 0 : ref3.map(function(cta) {
        return getLink(cta);
    })) || [];
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: promotion_id,
        creative_name: creative_name,
        cta_links: ctasLinks
    });
    var ref4 = (0,usePromotionView/* usePromotionView */.Y)(trendingTileRef, extendedGaTrackData), promotionTrackerPosition = ref4.promotionTrackerPosition, ga4PromotionTrackerPosition = ref4.ga4PromotionTrackerPosition;
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkOrTag, {
        dataTestId: "trending-tile",
        ref: trendingTileRef,
        newtab: !!(navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.newtab),
        query: navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo.query,
        href: getLink(navigateTo),
        gaBannerData: gaTrackData,
        className: (0,style.tw)("relative w-full"),
        linkType: tile.linkType,
        ga4Data: tile.ga4Data ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile.ga4Data), {
            promotion_name: tile.header || "",
            link_url: getLink(navigateTo)
        }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Data), {
            link_url: getLink(navigateTo)
        }),
        children: [
            tile.einsteinRecommender && tile.backgroundType === "einsteinRecommenderType" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingTileRecommenderBackground, {
                altText: tile.einsteinRecommenderAltText,
                pageType: tile.einsteinRecommender
            }),
            tile.backgroundImage && tile.backgroundType === "chosenImageType" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                style: {
                    paddingTop: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                        source: tile.backgroundImage,
                        priority: !deferred
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOverlay/* ImageOverlay */.v, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile.backgroundOverlay), {
                        className: "block mobile:hidden"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.tw)("mt-3 w-full", (tile.overlay || inSideBySide) && "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 ".concat(overlayTextColor), inSideBySide && "flex flex-col items-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileHeaderAndCopy, {
                        copy: tile.copy,
                        header: tile.header,
                        inSideBySide: inSideBySide,
                        countdownClock: countdownClock
                    }),
                    tile.linkType === constants/* SLOT_LINK_TYPE.CTA */.no.CTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(TileCtas, {
                        inSideBySide: inSideBySide,
                        ctas: tile.ctas,
                        gaBannerData: gaTrackData,
                        ga4Data: tile.ga4Data ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile.ga4Data), {
                            promotion_name: tile.header || ""
                        }) : ga4Data
                    })
                ]
            })
        ]
    });
};
var TileCtas = function(param) {
    var ctas = param.ctas, inSideBySide = param.inSideBySide, gaBannerData = param.gaBannerData, ga4Data = param.ga4Data;
    if (inSideBySide) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:flex flex-wrap flex-gap-4 mt-3 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                        ctas: ctas,
                        gaBannerData: gaBannerData,
                        ga4Data: ga4Data
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:hidden flex tablet:flex flex-wrap justify-center flex-gap-2 xs:flex-gap-4 mt-3 relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                        ctas: ctas === null || ctas === void 0 ? void 0 : ctas.map(whiteToBlack),
                        gaBannerData: gaBannerData,
                        ga4Data: ga4Data
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mt-3 flex flex-col space-y-3 max-w-64 mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
            ctas: ctas,
            gaBannerData: gaBannerData,
            ga4Data: ga4Data
        })
    });
};
var TrendingTileRecommenderBackground = function(param) {
    var altText = param.altText, _pageType = param.pageType, pageType = _pageType === void 0 ? "" : _pageType;
    var ref;
    var fireClickProductImage = (0,useGA4Events/* useGA4Events */.tL)().fireClickProductImage;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRecommendationsWithDetailsQuery */.MA5)({
        variables: {
            pageType: pageType
        },
        pause: isServer
    }), 1), result = ref1[0];
    var product = (0,extractProductVariants/* extractProductVariants */.b)((ref = result.data) === null || ref === void 0 ? void 0 : ref.recommendationsWithDetails.recommendations)[0];
    return (product === null || product === void 0 ? void 0 : product.images[0].href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveProductImage/* ResponsiveProductImage */.U, {
            className: "w-full",
            src: product === null || product === void 0 ? void 0 : product.images[0].href,
            widths: [
                750,
                900,
                1050,
                1200,
                1350,
                1500
            ],
            sizes: {
                mobile: "100vw",
                tablet: "33vw",
                desktop: "33vw"
            },
            width: 600,
            height: 600,
            alt: altText || (product === null || product === void 0 ? void 0 : product.images[0].alt),
            onClick: function() {
                return fireClickProductImage(product === null || product === void 0 ? void 0 : product.images[0].href);
            }
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "aspect-1-1 bg-puma-black-600"
    });
};
var TileHeaderAndCopy = function(param) {
    var copy = param.copy, header = param.header, inSideBySide = param.inSideBySide, countdownClock = param.countdownClock;
    var clock = countdownClock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownClock/* CountdownClock */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, countdownClock), {
        config: {
            timeUnitClassName: "text-base font-normal",
            containerClassName: "space-x-1 justify-center"
        }
    })) : null;
    if (inSideBySide) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                    tag: "h1",
                    className: "font-bold text-3xl sm:text-4xl relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        content: header
                    })
                }),
                clock,
                !clock && copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        content: copy
                    })
                })
            ]
        });
    }
    // Default - such as rendering in TrendingInline
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl font-bold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    content: header
                })
            }),
            clock,
            !clock && copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    content: copy
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/content/SideBySide.tsx










var SideBySide = function(props) {
    var ref;
    var asPath = (0,next_router.useRouter)().asPath;
    var promotion_id = props.id || "";
    var promotion_name = "";
    var creative_name = props.__typename || "SideBySide";
    var sideBySideRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(sideBySideRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: undefined,
        cta_click: undefined,
        fireEventFromPdp: asPath.includes("/pd/")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "md:grid gap-4 sm:gap-8 md:gap-8 desktop:grid-cols-2 tablet:grid-cols-1",
        "data-test-id": "side-by-side-section",
        ref: sideBySideRef,
        children: (ref = props.requiredTiles) === null || ref === void 0 ? void 0 : ref.map(function(tile) {
            var additionalProps = {
                inSideBySide: true,
                id: props.id,
                gridTemplateColumnConfig: {}
            };
            var type = tile.__typename || tile._type;
            // Include grid template if rendering Product Recommender
            if (type === "ProductRecommender" && !tile.showAsGrid) {
                additionalProps.gridTemplateColumnConfig = {
                    mobile: ProductCarousel/* DEFAULT_PRODUCT_GRID_SIZE */.md,
                    tablet: ProductCarousel/* DEFAULT_PRODUCT_GRID_SIZE */.md,
                    desktop: ProductCarousel/* DEFAULT_PRODUCT_GRID_SIZE */.md
                };
                var ref = getComponent(type), Component = ref.component;
                return /*#__PURE__*/ (0,react.createElement)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile, additionalProps), {
                    key: tile.id
                }));
            }
            if (type === "TrendingTile") {
                return /*#__PURE__*/ (0,react.createElement)(TrendingTile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile), {
                    key: tile.id,
                    ga4Data: ga4Data
                }));
            }
            return null;
        })
    });
};

;// CONCATENATED MODULE: ./ui/content/TrendingInline.tsx



function TrendingInline_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  grid-area: ",
        ";\n                "
    ]);
    TrendingInline_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(",
        ", 1fr);\n    grid-template-areas: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var TrendingInline = function(props) {
    var trendingInlineRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: props._id || "",
        name: "",
        creative: props.__typename || "TrendingInline"
    };
    (0,usePromotionView/* usePromotionView */.Y)(trendingInlineRef, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "relative w-full",
        "data-test-id": "trending-inline-section",
        ref: trendingInlineRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,css.tw)("grid gap-5", layouts[props.requiredTiles.length]),
            children: props.requiredTiles.map(function(tile, idx) {
                var area = "abcd"[idx];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,css.tw)((0,css/* css */.iv)(TrendingInline_templateObject(), area)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingTile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile), {
                        deferred: props.deferred
                    }))
                }, "".concat(tile.id, "-").concat(idx));
            })
        })
    });
};
var grid = function(tmpl) {
    var template = tmpl.trim().split("\n");
    return (0,css/* css */.iv)(_templateObject1(), template[0].split(" ").length, template.join(" "));
};
var layouts = {
    1: {
        "": grid("\n      'a'\n    ")
    },
    2: {
        "mobile:": grid("\n      'a'\n      'b'\n    "),
        "tablet:": grid("\n      'a b'\n    "),
        "desktop:": grid("\n      'a b'\n    ")
    },
    3: {
        "mobile:": grid("\n      'a'\n      'b'\n      'c'\n    "),
        "tablet:": grid("\n      'a b'\n      'c c'\n    "),
        "desktop:": grid("\n      'a b c'\n    ")
    },
    4: {
        "mobile:": grid("\n      'a'\n      'b'\n      'c'\n      'd'\n    "),
        "tablet:": grid("\n      'a b'\n      'c d'\n    "),
        "desktop:": grid("\n      'a b c d'\n    ")
    }
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(51074);
// EXTERNAL MODULE: ./hooks/useOnRouterChangeStart.ts
var useOnRouterChangeStart = __webpack_require__(97491);
// EXTERNAL MODULE: ./utils/ga4VideoEvents.ts
var ga4VideoEvents = __webpack_require__(78615);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
;// CONCATENATED MODULE: ./utils/sleep.ts
// TODO: add unit test -> https://pumaglobal.atlassian.net/browse/WEB-1655
var sleep = function(ms) {
    return new Promise(function(res) {
        return setTimeout(res, ms);
    });
};

;// CONCATENATED MODULE: ./ui/components/YoutubePlayerWithGA4Events.tsx













// when import normally use this component
// this is a wrapper of YoutubePlayerWithGA4Events_Child and only add the hook of pageEventContext
// NOTE: maybe in a future we can save and consume the pageviewEventHasFired with zustand
var YoutubePlayerWithGA4Events = function(props) {
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayerWithGA4Events_Child, (0,_object_spread/* default */.Z)({
        pageviewEventHasFired: pageviewEventHasFired
    }, props));
};
// when testing use this export
// this is the component without using pageEventContext hook so we can hardcode the pageviewEventHasFired when testing
var YoutubePlayerWithGA4Events_Child = function(param) {
    var opts = param.opts, className = param.className, title = param.title, videoId = param.videoId, // ───────────────────
    pageviewEventHasFired = param.pageviewEventHasFired, onVideoStartCallback = param.onVideoStartCallback;
    var ref = (0,store/* useFiredEventsStore */.xm)(), eventHasFired = ref.eventHasFired, setEventFired = ref.setEventFired;
    var youtubeComponentRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(-1), videoProgress = ref1[0], setVideoProgress = ref1[1];
    var ref2 = (0,react.useState)(undefined), currentPercentage = ref2[0], setCurrentPercentage = ref2[1];
    (0,useOnRouterChangeStart/* useOnRouterChangeStart */.k)((0,react.useCallback)(function() {
        if (pageviewEventHasFired) {
            // when page start to change -> reset current local state
            // this avoid problems of fire again the events previously cleaned on pageEventContext
            setVideoProgress(-1);
            setCurrentPercentage(undefined);
        }
    }, [
        pageviewEventHasFired
    ]));
    var getPlayerData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, player, currentTime, duration, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        player = (ref = youtubeComponentRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                        return [
                            4,
                            player === null || player === void 0 ? void 0 : player.getCurrentTime()
                        ];
                    case 1:
                        currentTime = _state.sent() || 0;
                        return [
                            4,
                            player === null || player === void 0 ? void 0 : player.getDuration()
                        ];
                    case 2:
                        duration = _state.sent() || 0;
                        _tmp = {};
                        return [
                            2,
                            (_tmp.currentTime = currentTime, _tmp.duration = duration, _tmp)
                        ];
                }
            });
        });
        return function getPlayerData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // every 50 milis check the video progress and save to local state
        var every50Milis = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, currentTime, duration, toFixed0, percent;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getPlayerData()
                            ];
                        case 1:
                            ref = _state.sent(), currentTime = ref.currentTime, duration = ref.duration;
                            if (duration) {
                                toFixed0 = function(value) {
                                    return parseInt(value.toFixed(0), 10);
                                };
                                percent = toFixed0(currentTime / duration * 100);
                                setVideoProgress(percent);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function every50Milis() {
                return _ref.apply(this, arguments);
            };
        }();
        var interval = setInterval(every50Milis, 50);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    (0,react.useEffect)(function() {
        // get the "current" percentage from the percentages (0, 10, 25, 50, 75, 100)
        if (videoProgress !== -1 && pageviewEventHasFired) {
            var percentageToFire = (0,_to_consumable_array/* default */.Z)(constants/* VIDEO_GA4_EVENT_PERCENTAGES */.Gl).reverse().find(function(percentage) {
                return videoProgress >= parseInt(percentage) ? percentage : null;
            });
            setCurrentPercentage(percentageToFire);
        }
    }, [
        videoProgress,
        pageviewEventHasFired
    ]);
    var getVideoData = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, currentTime, duration, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPlayerData()
                    ];
                case 1:
                    ref = _state.sent(), currentTime = ref.currentTime, duration = ref.duration;
                    _tmp = {};
                    return [
                        2,
                        (_tmp.video_current_time = (currentTime || 0).toFixed(2), _tmp.video_duration = (duration || 0).toFixed(2), _tmp.video_percent = 0, _tmp.video_provider = "youtube", _tmp.video_title = title, _tmp.video_url = "https://www.youtube.com/watch?v=".concat(videoId), _tmp.visible = "".concat(true), _tmp)
                    ];
            }
        });
    }), [
        title,
        videoId
    ]);
    (0,react.useEffect)(function() {
        // only call function to fire event when the current percentage changes (0, 10, 25, 50, 75, 100)
        if (pageviewEventHasFired) {
            if (currentPercentage !== undefined) {
                (0,ga4VideoEvents/* firePreviousAndCurrentGA4VideoEvents */._E)({
                    percentage: currentPercentage,
                    eventHasFired: eventHasFired,
                    setEventFired: setEventFired,
                    getVideoData: getVideoData,
                    onVideoStartCallback: onVideoStartCallback
                });
            }
        }
    // NOTE: do not add eventHasFired neither setEventFired to the dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPercentage,
        pageviewEventHasFired,
        getVideoData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "youtube-player-with-ga4-events",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
            ref: youtubeComponentRef,
            videoId: videoId,
            iframeClassName: className,
            title: title,
            opts: opts,
            onReady: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // NOTE: this fix a bug that the first duration obtained is
                                //       different than the real duration and causes that the
                                //       event 100% is never fired
                                e.target.stopVideo();
                                e.target.playVideo();
                                return [
                                    4,
                                    sleep(200)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onPlay: function() {
                return setCurrentPercentage("0");
            },
            onEnd: function() {
                return setCurrentPercentage("100");
            }
        })
    });
};

;// CONCATENATED MODULE: ./ui/content/YouTubeVideoCarousel.tsx








var YouTubeVideoCarousel = function(props) {
    var videoIds = props.videoIds;
    var ref = (0,react.useState)((videoIds !== null && videoIds !== void 0 ? videoIds : [])[0]), currentVideo = ref[0], setCurrentVideo = ref[1];
    var language = (0,useSiteConfig/* useSiteConfig */.N)().language;
    var youtubeVideoCarouselRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: props.id,
        name: "",
        creative: props.__typename || "YouTubeVideoCarousel"
    };
    (0,usePromotionView/* usePromotionView */.Y)(youtubeVideoCarouselRef, gaTrackData, true);
    if (!(videoIds === null || videoIds === void 0 ? void 0 : videoIds.length)) return null;
    var isPlaylist = videoIds.length > 1;
    var youtubePlayerOpts = {
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: props.autoplay || currentVideo !== videoIds[0] ? 1 : 0,
            controls: 1,
            modestbranding: 1,
            cc_lang_pref: language,
            hl: language
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-test-id": "youtube-video-carousel",
        ref: youtubeVideoCarouselRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mobile:pt-[56.25%] tablet:pt-[42.8%] desktop:pt-[42.8%]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayerWithGA4Events, {
                    videoId: currentVideo,
                    className: "absolute inset-0 w-full h-full",
                    title: "PUMA Video Carousel" // TODO: i18n
                    ,
                    opts: youtubePlayerOpts
                })
            }),
            isPlaylist && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaylistControls, {
                showThumbnails: props.showThumbnails,
                videoIds: videoIds,
                currentVideo: currentVideo,
                setCurrentVideo: setCurrentVideo
            })
        ]
    });
};
var PlaylistControls = function(props) {
    var ControlsComponent = props.showThumbnails ? Thumbnails : Buttons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlsComponent, {
        videoIds: props.videoIds,
        currentVideo: props.currentVideo,
        setCurrentVideo: props.setCurrentVideo
    });
};
var Thumbnails = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center mt-1 md:mt-3 space-x-1 md:space-x-3 items-center overflow-x-auto",
        children: props.videoIds.map(function(video) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,css.tw)("relative max-w-24 min-w-16 flex-grow-0 w-full overflow-hidden hover:opacity-100", video !== props.currentVideo && "opacity-80"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-[56.25%] w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute inset-0 w-full h-full object-cover object-center",
                        src: "https://img.youtube.com/vi/".concat(video, "/hqdefault.jpg"),
                        onClick: function() {
                            return props.setCurrentVideo(video);
                        },
                        width: "80",
                        height: "45"
                    }),
                    video === props.currentVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-[50%] top-[50%] transform translate-x-[-50%] translate-y-[-50%] rounded-full overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            name: "play-outline",
                            size: "xl"
                        })
                    })
                ]
            }, video);
        })
    });
};
var Buttons = function(param) {
    var videoIds = param.videoIds, currentVideo = param.currentVideo, setCurrentVideo = param.setCurrentVideo;
    var videoIndex = videoIds.indexOf(currentVideo);
    var isFirstVideo = videoIndex === 0;
    var isLastVideo = videoIndex === videoIds.length - 1;
    var goToPreviousVideo = function() {
        return setCurrentVideo(videoIds[videoIndex - 1]);
    };
    var goToNextVideo = function() {
        return setCurrentVideo(videoIds[videoIndex + 1]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                        className: "transform -translate-y-1/2 mr-6",
                        disabled: isFirstVideo,
                        direction: "left",
                        onClick: goToPreviousVideo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                        className: "transform -translate-y-1/2",
                        disabled: isLastVideo,
                        direction: "right",
                        onClick: goToNextVideo
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-auto",
                "data-test-id": "video-counter",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(videoIndex + 1, " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block bg-black h-px my-1 mx-2.5 w-7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: " ".concat(videoIds.length)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var hooks_esm = __webpack_require__(68138);
// EXTERNAL MODULE: ./types/analyticTypes.ts
var analyticTypes = __webpack_require__(90099);
// EXTERNAL MODULE: ./utils/debounce.ts
var debounce = __webpack_require__(40572);
;// CONCATENATED MODULE: ./hooks/useClosestMedia.tsx



var Screens = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};
var DEFAULT_QUERIES = Object.keys(Screens);
var isMatch = function(media) {
    var query = "(min-width: ".concat(Screens[media], ")");
    return window.matchMedia(query).matches;
};
var findClosest = function() {
    var queries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_QUERIES;
    if (constants/* isServer */.sk) return "sm";
    for(var i = queries.length - 1; i >= 0; i--){
        if (isMatch(queries[i])) {
            return queries[i];
        }
    }
    return "sm";
};
var useClosestMedia = function() {
    var ref = (0,react.useState)(function() {
        return findClosest();
    }), closest = ref[0], setClosest = ref[1];
    (0,react.useEffect)(function() {
        var listener = (0,debounce/* debounce */.D)(function() {
            return setClosest(findClosest());
        }, 500);
        window.addEventListener("resize", listener);
        return function() {
            return window.removeEventListener("resize", listener);
        }; //Cleanup
    }, []);
    return closest;
};

;// CONCATENATED MODULE: ./hooks/useStyliticsSanity.tsx








// Create Context
var StyliticsSanityContext = /*#__PURE__*/ (0,react.createContext)({});
// Create Custom Context Hook
var useStyliticsSanity = function() {
    return (0,react.useContext)(StyliticsSanityContext);
};
var defaultLastInViewArgs = {
    columns: {
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3,
        "2xl": 3
    }
};
var useLastInView = function(numTiles) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultLastInViewArgs;
    var closest = useClosestMedia();
    var isLastInView = function(index) {
        if (index + 1 === numTiles) return true;
        return (index + 1) % args.columns[closest] === 0;
    };
    return {
        columns: args.columns,
        isLastInView: isLastInView,
        screenSize: closest
    };
};
// Create Provider
var StyliticsSanityProvider = function(props) {
    var isCarousel = props.isCarousel, tiles = props.tiles, ga4Data = props.ga4Data;
    var ref = (0,react.useState)(), activeId = ref[0], setActiveId = ref[1];
    var ref1 = (0,react.useState)(false), carouselNavHidden = ref1[0], setCarouselNavHidden = ref1[1];
    var carouselProps = (0,hooks_esm/* useHorizontalScroll */.mZ)({
        infinite: false
    });
    var ref2;
    var view = useLastInView((ref2 = tiles === null || tiles === void 0 ? void 0 : tiles.length) !== null && ref2 !== void 0 ? ref2 : 0);
    var hideCarouselNavBtns = function(isHidden) {
        return setCarouselNavHidden(isHidden);
    };
    var toggleActiveId = function(id) {
        return setActiveId(id);
    };
    var fireCarouselTracking = function() {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (0,_define_property/* default */.Z)({
            domevent: "Stylitics - Product Click",
            domlabel: "Stacked Carousel"
        }, analyticTypes/* Dimensions.d27 */.Db.d27, props.tags));
    };
    var fireGridTracking = function() {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (0,_define_property/* default */.Z)({
            domevent: "Stylitics - Product Click",
            domlabel: "Gallery"
        }, analyticTypes/* Dimensions.d27 */.Db.d27, props.tags));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanityContext.Provider, {
        value: {
            activeId: activeId,
            isCarousel: isCarousel,
            carouselUi: {
                carousel: carouselProps,
                carouselNavHidden: carouselNavHidden,
                hideCarouselNavBtns: hideCarouselNavBtns
            },
            outfitUi: (0,_object_spread/* default */.Z)({
                toggleActiveId: toggleActiveId
            }, view),
            tiles: tiles,
            fireTracking: isCarousel ? fireCarouselTracking : fireGridTracking,
            ga4Data: ga4Data
        },
        children: props.children
    });
};

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsChevronButton.tsx


var StyliticsChevronButton = function(props) {
    var directionClass = props.direction === "left" ? "stylitics-chevron-button-prev" : "stylitics-chevron-button-next";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,twind.tw)("stylitics-chevron-button", directionClass),
        type: "button",
        "data-test-id": directionClass,
        "aria-label": "".concat(props.direction, "-arrow"),
        onClick: props.onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            viewBox: "0 0 9 16",
            xmlns: "http://www.w3.org/2000/svg",
            className: "stylitics-chevron-arrow-svg",
            "data-test-id": "".concat(directionClass, "-svg"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0,0 L9,8 L0,16"
            })
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsChevronButton = (StyliticsChevronButton);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/stylitics-sanity-css.ts

function stylitics_sanity_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  /* \n    *  Stylitics CSS Table of Contents\n    *   \n    *  1.0 - Stylitics Carousel\n    *    1.1 - Stylitics Chevron Button\n    *    1.2 - Carousel\n    *  2.0 - Stylitics Outfit\n    *    2.1 - Outfit Flyout Menu\n    *       2.1.1 - Outfit Product Details\n    *    2.2 - Outfit Mobile Modal\n    *  3.0 - Animations\n  */\n\n  /*\n    ****\n    * 1.0 Stylitics Carousel\n    ****\n    */\n\n  /*\n    ****\n    * 1.1 - Stylitics Chevron Button\n    * Component: web/ui/components/StyliticsSanity/StyliticsChevronButton.tsx\n    ****\n    */\n  .stylitics-chevron-button {\n    cursor: pointer;\n\n    position: absolute;\n    z-index: 1;\n    top: calc(50% + 10px);\n    transform: translateY(-50%);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    width: 44px;\n    height: 44px;\n    padding: 0;\n\n    font-size: 60px;\n    font-weight: 300;\n\n    background-color: #191919;\n    border: none;\n    border-radius: 50%;\n  }\n\n  .stylitics-chevron-button path {\n    fill: none;\n    stroke: rgb(0, 0, 0);\n    stroke-linecap: butt;\n    stroke-linejoin: miter;\n    stroke-width: 2;\n  }\n\n  .stylitics-chevron-button:hover {\n    opacity: 0.5;\n  }\n\n  .stylitics-chevron-button.stylitics-chevron-button-prev {\n    left: 10px;\n    transform: translateY(-50%);\n  }\n\n  .stylitics-chevron-button.stylitics-chevron-button-prev\n    .stylitics-chevron-arrow-svg {\n    transform: rotate(180deg);\n    margin-right: 3px;\n    margin-left: 0;\n  }\n  .stylitics-chevron-button.stylitics-chevron-button-next {\n    right: 10px;\n    transform: translateY(-50%);\n  }\n\n  .stylitics-chevron-arrow-svg {\n    z-index: 1;\n\n    overflow: visible;\n\n    width: 8px;\n    height: 15px;\n    margin-left: 3px;\n  }\n\n  .stylitics-chevron-arrow-svg path {\n    stroke: #ffffff !important;\n  }\n\n  /*\n  ****\n  * 1.2 - Carousel\n  * Component: web/ui/components/StyliticsSanity/StyliticsCarouselContainer.tsx\n  ****\n  */\n  .stylitics-carousel-group {\n    display: grid;\n    grid-gap: 16px;\n\n    height: 100%;\n    padding-top: 15px;\n\n    background-color: transparent;\n  }\n\n  .stylitics-carousel-group.desktop {\n    will-change: transform;\n\n    transform: translateX(calc(-0px));\n\n    transition-timing-function: ease-in-out;\n    transition-duration: 0.25s;\n    transition-property: transform;\n  }\n  /*\n  ****\n  * 2.0 Stylitics Outfit\n  ****\n  * The outfit component is shared between the carousel\n  * and grid. It\'s the same concept as a "bundle" in the\n  * StyliticsWidget.\n  * Component: web/ui/components/StyliticsSanity/StyliticsOutfitContainer.tsx\n  ****\n  */\n  .stylitics-card {\n    position: relative;\n    z-index: 0;\n\n    display: inline-block;\n\n    min-width: auto;\n    height: 460px;\n    max-height: 460px;\n    padding: 0px;\n  }\n\n  .stylitics-card.active {\n    z-index: 1;\n  }\n\n  .stylitics-card:first-child {\n    margin-left: 0;\n  }\n\n  .stylitics-carousel-card-wrap {\n    cursor: pointer;\n    transition-timing-function: ease;\n    transition-duration: 200ms;\n    transition-property: opacity, transform;\n  }\n\n  @media (min-width: 1024px) {\n    .stylitics-carousel-card-wrap.slide-left {\n      transform: translateX(calc(-100% - 16px));\n    }\n  }\n\n  .stylitics-outfit-container {\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    width: 100%;\n    height: 100%;\n    padding: 5%;\n\n    font-size: 14px;\n\n    opacity: 1;\n    background-color: #fff;\n    border-color: #efefef;\n    border-style: solid;\n    border-width: thin;\n  }\n\n  .stylitics-image-container {\n    position: relative;\n    transform: translateX(calc(100%-20px));\n    flex-grow: 1;\n    width: 100%;\n  }\n\n  .stylitics-main-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border-radius: 0;\n  }\n\n  .stylitics-main-image:focus,\n  .stylitics-main-image:focus-within {\n    outline-offset: -5px !important;\n  }\n\n  .stylitics-outfit-footer {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 0;\n    align-items: center;\n    justify-content: flex-end;\n\n    margin-top: 10px;\n    margin-bottom: 0px;\n    padding: 0;\n\n    color: inherit;\n    text-decoration: none;\n\n    transition-timing-function: ease-out;\n    transition-duration: 0.25s;\n    transition-property: opacity;\n  }\n\n  .stylitics-outfit-footer-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .stylitics-outfit-footer button:hover,\n  .stylitics-outfit-footer button:focus {\n    background: transparent;\n    border-color: transparent;\n  }\n\n  .stylitics-outfit-footer button::after {\n    all: unset;\n  }\n\n  /*\n  ****\n  * 2.1 - Outfit Flyout Menu\n  * Component: web/ui/components/StyliticsSanity/StyliticsOutfitFlyout.tsx\n  ****\n  */\n  .stylitics-outfit-details {\n    top: 0;\n\n    justify-content: flex-start;\n\n    width: calc(100%+16px);\n\n    background-color: white;\n    border: 1px solid #efefef;\n    border-left-color: transparent;\n\n    animation: 0.5s forwards slideIn;\n  }\n\n  .stylitics-product-list-container {\n    overflow-y: auto;\n  }\n\n  .stylitics-product-list {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n\n  .stylitics-product-list:focus,\n  .stylitics-product-list:focus-visible {\n    outline: none;\n  }\n\n  .stylitics-product-list::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .stylitics-product-list::-webkit-scrollbar-thumb {\n    background-color: #bebebe;\n    border: 3px solid transparent;\n  }\n\n  .stylitics-product-container {\n    flex-grow: 1;\n\n    margin-left: 3px;\n    padding: 8px 0px 5px;\n\n    font-size: 0px;\n    list-style: none;\n\n    border-bottom: 1px solid rgb(238, 238, 238);\n  }\n\n  .stylitics-product-container:last-child {\n    border-bottom: none;\n  }\n\n  .stylitics-product-inner-container {\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: flex-start;\n\n    width: 100%;\n    height: 100%;\n    min-height: 80px;\n    margin-left: 3px;\n    padding: 0;\n\n    font-family: inherit;\n    font-size: 0;\n    text-align: left;\n\n    background-color: #fff;\n    background-image: none;\n    border: none;\n    border-style: none;\n  }\n\n  .stylitics-product-image-wrapper {\n    position: relative;\n  }\n\n  .stylitics-product-image {\n    cursor: pointer;\n\n    display: flex;\n    flex: 0 0 36%;\n    align-items: flex-end;\n\n    width: auto;\n    min-width: 60px;\n    height: 100%;\n    margin: auto;\n\n    background-repeat: no-repeat;\n    background-position: center 10%;\n    background-position-y: 10%;\n    background-size: contain;\n    border: none;\n    outline: none;\n\n    transition-timing-function: ease-in-out;\n    transition-duration: 0.2s;\n    transition-property: background-image;\n  }\n\n  .stylitics-close {\n    cursor: pointer;\n\n    position: absolute;\n    top: -10px;\n    right: -8px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 30px;\n    height: 30px;\n\n    font-weight: 700;\n\n    background: #f5f5f5;\n    border: none;\n    border-radius: 25px;\n  }\n\n  @media (max-width: 1024px) {\n    .stylitics-close {\n      cursor: pointer;\n\n      position: absolute;\n      z-index: 1;\n      top: 24px;\n      right: 27px;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      width: 36px;\n      height: 36px;\n\n      background: #f5f5f5;\n      border-radius: 25px;\n    }\n  }\n\n  .stylitics-close:hover {\n    opacity: 0.5;\n  }\n\n  /*\n  ****\n  * 2.1.1 - Outfit Product Details\n  * Component: web/ui/components/StyliticsSanity/StyliticsOutfitFlyout.tsx\n  ****\n  */\n  .stylitics-product-info {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: flex-start;\n\n    height: auto;\n    padding: 0px 10px 10px 16px;\n\n    font-size: 15.5px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: gray;\n  }\n\n  .stylitics-product-info p {\n    margin: 0;\n  }\n\n  .stylitics-product-name {\n    overflow: hidden;\n\n    margin: 0;\n\n    font-size: 16px;\n    font-weight: 700;\n    color: black;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .stylitics-product-name:hover {\n    opacity: 0.5;\n  }\n\n  .stylitics-product-name-wrap {\n    overflow: hidden;\n    display: -webkit-box;\n\n    max-height: 40px;\n\n    line-height: 20px;\n    white-space: normal;\n\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  .stylitics-product-price-and-cta {\n    display: flex;\n    flex-basis: 50%;\n    flex-direction: row;\n    flex-shrink: 1;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-top: 10px;\n  }\n\n  .stylitics-product-price {\n    margin: 0;\n  }\n\n  .stylitics-product-regular-price {\n    font-weight: 500;\n    color: black;\n  }\n\n  .stylitics-product-regular-price-slashed {\n    font-weight: 400;\n    color: #767676 !important;\n    text-decoration: line-through;\n  }\n\n  .stylitics-product-sale-price {\n    font-weight: 500;\n    color: black;\n  }\n\n  /*\n  ****\n  * 2.2 - Outfit Mobile Modal\n  * Component: web/ui/components/StyliticsSanity/StyliticsOutfitFlyoutMobile.tsx\n  ****\n  */\n  .stylitics-modal-container {\n    touch-action: none;\n\n    position: fixed;\n    z-index: 999;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    background: rgba(0, 0, 0, 0.33);\n  }\n  .stylitics-modal {\n    position: absolute;\n    bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    width: 100%;\n    height: min-content;\n    max-height: 80%;\n\n    background: white;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n  }\n  .stylitics-modal-product-list {\n    overflow: auto;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0 25px;\n  }\n  .stylitics-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 0;\n  }\n  .stylitics-modal-header h1 {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  /*\n  ****\n  * 3.0 Animations\n  ****\n  * Simple animations for translating the flyout menu and fading.\n  * TODO: Expand this to add a loading shimmer for product images.\n  ****\n  */\n  .is-faded {\n    opacity: 0.1;\n  }\n\n  .is-unfading {\n    opacity: 1;\n    transition-delay: 0ms;\n  }\n\n  @keyframes slideIn {\n    0% {\n      left: 0%;\n      opacity: 0;\n    }\n    8% {\n      left: 8%;\n      opacity: 6.394884621840902e-14;\n    }\n    16% {\n      left: 16%;\n      opacity: 0.0005794679287529636;\n    }\n    24% {\n      left: 24%;\n      opacity: 0.004632407963000018;\n    }\n    33% {\n      left: 33%;\n      opacity: 0.015630625675027043;\n    }\n    41% {\n      left: 41%;\n      opacity: 0.03704592663705597;\n    }\n    49% {\n      left: 49%;\n      opacity: 0.07235011642130895;\n    }\n    58% {\n      left: 58%;\n      opacity: 0.12501500060000792;\n    }\n    66% {\n      left: 66%;\n      opacity: 0.19851238474537503;\n    }\n    74% {\n      left: 74%;\n      opacity: 0.296314074429632;\n    }\n    83% {\n      left: 83%;\n      opacity: 0.42189187522500116;\n    }\n    91% {\n      left: 91%;\n      opacity: 0.5787175927037039;\n    }\n    99% {\n      left: 99%;\n      opacity: 0.7702630324379629;\n    }\n    100% {\n      left: 100%;\n      opacity: 1;\n    }\n  }\n'
    ]);
    stylitics_sanity_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styliticsCarouselStyles = (0,css/* css */.iv)(stylitics_sanity_css_templateObject());

// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./ui/components/Price.tsx
var Price = __webpack_require__(81406);
// EXTERNAL MODULE: ./ui/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(91622);
;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsLoader.tsx


var StyliticsLoader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-10 h-full flex py-48",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* LoadingSpinner */.T, {
                dataTestId: "stylitics-loader",
                className: "w-32 h-32 m-auto"
            })
        }) : props.children
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsLoader = (StyliticsLoader);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsOutfitFlyout.tsx















var ProductDetails = function(param) {
    var product = param.product;
    var name = product.name, price = product.price, salePrice = product.salePrice, styleId = product.styleId;
    var isOnSale = salePrice && salePrice !== price;
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var ref = (0,react.useState)(), productUrl = ref[0], setProductUrl = ref[1];
    (0,react.useEffect)(function() {
        var productId = styleId.split("_")[0];
        var productColor = styleId.split("_")[1];
        var url = (0,buildProductUrl/* buildProductUrl */.B)(productId, name, {
            color: productColor
        });
        setProductUrl(url);
    }, [
        name,
        styleId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": "stylitics-outfit-flyout-details",
        className: "stylitics-product-info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stylitics-product-info-inner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.Stylitics */.Ei.Stylitics);
                    },
                    className: "stylitics-product-name stylitics-product-name-wrap",
                    href: productUrl && localizeUrlPath(productUrl),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: product.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "stylitics-product-price-and-cta",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "stylitics-product-price space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,twind.tw)("stylitics-product-regular-price", {
                                    "stylitics-product-regular-price-slashed": isOnSale
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                    amount: price
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isOnSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "stylitics-product-sale-price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                        amount: salePrice
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                            onClick: function() {
                                return (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.Stylitics */.Ei.Stylitics);
                            },
                            href: productUrl !== null && productUrl !== void 0 ? productUrl : "",
                            target: "_blank",
                            variant: "underline",
                            label: "SHOP"
                        })
                    })
                ]
            })
        ]
    });
};
var ProductContainer = function(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        "data-test-id": "stylitics-outfit-flyout-product",
        className: "stylitics-product-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            className: "stylitics-product-inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "stylitics-product-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stylitics-product-image",
                        style: {
                            backgroundImage: "url(".concat(product.image.href, ")")
                        },
                        role: "img",
                        "aria-label": product.image.alt,
                        tabIndex: -1
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                    product: product
                })
            ]
        })
    });
};
var FlyoutDesktop = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "stylitics-outfit-container stylitics-outfit-details",
        "data-test-id": "stylitics-outfit-flyout-desktop",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stylitics-product-list-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsLoader, {
                    loading: props.isLoading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "stylitics-product-list",
                        children: props.products.map(function(product) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContainer, {
                                product: product
                            }, product.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                className: "stylitics-close",
                onClick: props.onClose
            })
        ]
    });
};
var FlyoutMobile = function(props) {
    (0,react.useEffect)(function() {
        // prevent the user from scrolling behind the "modal"
        document.body.classList.toggle("overflow-hidden", true);
    }, []);
    var handleClose = function() {
        document.body.classList.toggle("overflow-hidden", false);
        props.onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-test-id": "stylitics-outfit-flyout-mobile",
            className: "stylitics-outfit-details-modal",
            "aria-modal": "true",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stylitics-modal-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "stylitics-modal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyliticsSanity_StyliticsLoader, {
                        loading: props.isLoading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "stylitics-modal-product-list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "stylitics-modal-header",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                            tag: "h1",
                                            children: "Product List"
                                        })
                                    }),
                                    props.products.map(function(product) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContainer, {
                                            product: product
                                        }, product.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                className: "stylitics-close",
                                onClick: handleClose
                            })
                        ]
                    })
                })
            })
        })
    });
};
var StyliticsOutfitFlyout = function(props) {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useLookQuery */.wcd)({
        variables: {
            id: props.outfitId
        },
        pause: !props.isActive
    }), 1), outfitProducts = ref2[0];
    var ref3 = useStyliticsSanity(), screenSize = ref3.outfitUi.screenSize;
    var Flyout = screenSize === "md" || screenSize === "sm" ? FlyoutMobile : FlyoutDesktop;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flyout, {
            isLoading: outfitProducts.stale || outfitProducts.fetching || !outfitProducts.data,
            products: (ref4 = (ref = outfitProducts.data) === null || ref === void 0 ? void 0 : (ref1 = ref.look) === null || ref1 === void 0 ? void 0 : ref1.products) !== null && ref4 !== void 0 ? ref4 : [],
            onClose: props.onClose
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsOutfitFlyout = (StyliticsOutfitFlyout);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsOutfitContainer.tsx







var StyliticsOutfit = function(props) {
    var outfit = props.outfit;
    var ref = useStyliticsSanity(), activeId = ref.activeId, fireTracking = ref.fireTracking, toggleActiveId = ref.outfitUi.toggleActiveId, hideCarouselNavBtns = ref.carouselUi.hideCarouselNavBtns;
    var isActive = activeId === outfit.id;
    var handleOutfitOpen = function() {
        props.checkIsLastInView();
        hideCarouselNavBtns(true);
        toggleActiveId(outfit.id);
        fireTracking();
    };
    var handleClose = function() {
        toggleActiveId(undefined);
        hideCarouselNavBtns(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "stylitics-outfit-container",
                style: isActive ? {
                    position: "absolute"
                } : {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stylitics-image-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "stylitics-main-image",
                            style: {
                                backgroundImage: "url(".concat(outfit.image.coverImageHref ? outfit.image.coverImageHref : outfit.image.href, ")")
                            },
                            role: "img",
                            "aria-label": outfit.image.alt,
                            tabIndex: -1,
                            onClick: handleOutfitOpen
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stylitics-outfit-footer",
                        onClick: handleOutfitOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,twind.tw)("stylitics-outfit-footer-wrapper", {
                                invisible: isActive
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                label: "View Details",
                                variant: "underline",
                                onClick: handleOutfitOpen
                            })
                        })
                    })
                ]
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsOutfitFlyout, {
                isActive: isActive,
                onClose: handleClose,
                outfitId: outfit.id
            })
        ]
    });
};
var StyliticsOutfitContainer = function(props) {
    var cardRef = (0,react.useRef)(null);
    var ref = useStyliticsSanity(), activeId = ref.activeId, isLastInView = ref.outfitUi.isLastInView;
    var ref1 = (0,react.useState)(false), lastInView = ref1[0], setLastInView = ref1[1];
    var anyCardOpen = !!activeId;
    var isActive = activeId === props.outfit.id;
    var checkIsLastInView = function() {
        return setLastInView(isLastInView(props.index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: cardRef,
        className: (0,twind.tw)("stylitics-card", {
            active: isActive
        }),
        "data-test-id": "stylitics-outfit-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-test-id": "stylitics-carousel-card-wrap",
            className: (0,twind.tw)("stylitics-carousel-card-wrap", {
                "is-faded": anyCardOpen && !isActive,
                "slide-left": lastInView && isActive
            }),
            style: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsOutfit, (0,_object_spread/* default */.Z)({
                checkIsLastInView: checkIsLastInView
            }, props))
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsOutfitContainer = (StyliticsOutfitContainer);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsPromoTile.tsx













var flexFromVerticalAlignment = function(alignment) {
    return ({
        top: "start",
        middle: "center",
        bottom: "end"
    })[alignment];
};
var StyliticsPromoTile = function(props) {
    var ref, ref1, ref2;
    var textColor = props.textColor || "#000000";
    var bgColor = props.backgroundColor || "transparent";
    var ref3 = (0,useResizeObserver/* useResizeObserver */.y)(), ref4 = ref3.ref, width = ref3.width;
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var fontSize = (0,twind.tw)(width <= 280 && "text-md", width > 280 && width <= 360 && "text-lg", width > 360 && width < 640 && "text-xl", width >= 640 && "text-2xl");
    var additionalCtaClass = (0,useSiteConfig/* useSiteConfig */.N)().additionalCtaClass;
    var ga4Data = useStyliticsSanity().ga4Data;
    var gaTrackData = {
        id: ((ref = props.puid) === null || ref === void 0 ? void 0 : ref.current) || "",
        name: props.header || (props === null || props === void 0 ? void 0 : (ref1 = props.cta) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
        creative: "promo-tile",
        campaign: ((ref2 = props.puid) === null || ref2 === void 0 ? void 0 : ref2.current) || "",
        position: ""
    };
    var ctaLink = getLink(props.cta);
    var extendedGaTrackData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gaTrackData), {
        promotion_id: ga4Data === null || ga4Data === void 0 ? void 0 : ga4Data.promotion_id,
        creative_name: ga4Data === null || ga4Data === void 0 ? void 0 : ga4Data.creative_name,
        cta_links: ctaLink ? [
            ctaLink
        ] : []
    });
    var promotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(ref4, extendedGaTrackData).promotionTrackerPosition;
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "stylitics-card",
        style: {
            scrollSnapAlign: "start"
        },
        "data-test-id": "stylitics-carousel-promo-tile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: ref4,
            className: (0,twind.tw)("bg-[".concat(bgColor, "]"), "relative flex flex-col flex-none w-full h-full", "justify-".concat(flexFromVerticalAlignment(props.verticalAlignment))),
            "data-test-id": "stylitics-promo-tile",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,twind.tw)(!props.contentBelow ? "absolute inset-0" : "relative w-full h-full flex-grow"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoOrImage/* VideoOrImage */.X, {
                        image: props.backgroundImage,
                        header: props.header,
                        video: props.video,
                        mobileImage: props.mobileBackgroundImage
                    })
                }),
                props.cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    dataTestId: "stylitics-promo-tile-cta",
                    query: props.cta.query,
                    newtab: !!props.cta.newtab,
                    href: ctaLink,
                    className: "absolute inset-0 h-full w-full",
                    "aria-hidden": true,
                    tabIndex: -1,
                    gaBannerData: gaTrackData,
                    ga4Data: ga4Data && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ga4Data), {
                        link_url: ctaLink
                    })
                }),
                (props.header || props.copy || props.cta) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,twind.tw)("relative p-6 text-center w-full flex flex-col items-center text-[".concat(textColor, "]"), props.contentBelow && "mt-4"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: fontSize,
                            children: [
                                props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    "data-test-id": "stylitics-promo-tile-header",
                                    className: "font-bold text-[1em] leading-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.header
                                    })
                                }),
                                props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    "data-test-id": "stylitics-promo-tile-copy",
                                    className: "mt-3 font-bold text-[0.62em] leading-snug",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.copy
                                    })
                                })
                            ]
                        }),
                        props.cta && props.cta.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                ctas: [
                                    props.cta
                                ],
                                className: additionalCtaClass !== null && additionalCtaClass !== void 0 ? additionalCtaClass : "",
                                gaBannerData: gaTrackData,
                                ga4Data: ga4Data
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsPromoTile = (StyliticsPromoTile);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsTileList.tsx




var StyliticsTileList = function(param) {
    var tiles = param.tiles;
    var isPromoTile = function(tile) {
        return tile._type === "tileWithPosition";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tiles === null || tiles === void 0 ? void 0 : tiles.map(function(tile, index) {
            return isPromoTile(tile) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsPromoTile, (0,_object_spread/* default */.Z)({}, tile.tile), tile._key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsOutfitContainer, {
                outfit: tile,
                index: index
            }, tile.id);
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsTileList = (StyliticsTileList);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsCarouselContainer.tsx







var Carousel = function() {
    var tiles = useStyliticsSanity().tiles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsTileList, {
        tiles: tiles
    });
};
var StyliticsCarouselContainer = function() {
    var ref = useStyliticsSanity(), _carouselUi = ref.carouselUi, carousel = _carouselUi.carousel, carouselNavHidden = _carouselUi.carouselNavHidden, screenSize = ref.outfitUi.screenSize, tiles = ref.tiles;
    var isMobile = screenSize === "md" || screenSize === "sm";
    var gridStyles = (0,twind.tw)([
        "no-scrollbars!",
        (0,css/* css */.iv)({
            scrollSnapType: "x mandatory"
        }),
        {
            mobile: (0,css/* css */.iv)({
                gridTemplateColumns: "repeat(".concat(tiles.length, ", calc(100% - 16px))")
            }),
            tablet: (0,css/* css */.iv)({
                gridTemplateColumns: "repeat(".concat(tiles.length, ", calc(50% - 16px))")
            }),
            desktop: (0,css/* css */.iv)({
                gridTemplateColumns: "repeat(".concat(tiles.length, ", calc(33.333% - 16px))")
            })
        }, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "stylitics-carousel",
        className: (0,twind.tw)(styliticsCarouselStyles, "py-[30px] px-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative overflow-x-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center relative flex-row w-full pr-0 pl-0 my-0 mx-auto",
                children: [
                    carousel.hasPrev && !carouselNavHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsChevronButton, {
                        direction: "left",
                        onClick: carousel.scrollToPrev
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: carousel.ref,
                        className: "overflow-x-hidden pb-0 pt-[8px]",
                        style: {
                            width: "calc(100% + 16px)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,twind.tw)("stylitics-carousel-group", gridStyles, {
                                desktop: !isMobile
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                        })
                    }),
                    carousel.hasNext && !carouselNavHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsChevronButton, {
                        direction: "right",
                        onClick: carousel.scrollToNext
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsCarouselContainer = (StyliticsCarouselContainer);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsGridContainer.tsx









var StyliticsGridContainer = function() {
    var ref = useStyliticsSanity(), tiles = ref.tiles, columns = ref.outfitUi.columns;
    var gridColumns = Object.keys(columns).reduce(function(prev, current) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, current, "grid-cols-".concat(columns[current])));
    }, {});
    var gridStyles = (0,twind.tw)([
        "grid overflow-x-hidden no-scrollbars! py-[30px]",
        (0,css/* css */.iv)({
            scrollSnapType: "x mandatory"
        }),
        "gap-5",
        gridColumns, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "stylitics-grid",
        className: (0,twind.tw)(styliticsCarouselStyles, gridStyles),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsTileList, {
            tiles: tiles
        })
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsGridContainer = (StyliticsGridContainer);

;// CONCATENATED MODULE: ./ui/components/StyliticsSanity/StyliticsHeader.tsx


var StyliticsHeader = function(param) {
    var header = param.header;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        id: "completeTheLook",
        "data-test-id": "stylitics-header",
        className: "font-bold text-xl sm:text-2xl pb-4 text-uppercase",
        children: !header ? t("completeTheLook") : header
    });
};
/* harmony default export */ var StyliticsSanity_StyliticsHeader = (StyliticsHeader);

// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
;// CONCATENATED MODULE: ./ui/content/StyliticsCarousel.tsx












// Consts
var MIN_OUTFITS = 2;
var MAX_OUTFITS = 25;
var StyliticsSanity = function(param) {
    var content = param.content, outfits = param.outfits, ga4Data = param.ga4Data, styliticsRef = param.styliticsRef;
    var contentTiles = content.tiles, numberOfTiles = content.numberOfTiles, _tileLayout = content.tileLayout, tileLayout = _tileLayout === void 0 ? "carousel" : _tileLayout, header = content.header, tags = content.tags;
    var calculateTiles = (0,react.useCallback)(function() {
        if (!outfits) return [];
        var display = (0,_to_consumable_array/* default */.Z)(outfits);
        var tileCount = numberOfTiles !== null && numberOfTiles !== void 0 ? numberOfTiles : MAX_OUTFITS;
        // If no tiles in Sanity -> display just outfits but only the max qty configured
        if (!contentTiles) {
            return display.slice(0, tileCount);
        }
        // Display tiles with outfits in the position specified in Sanity
        var newTiles = (0,_to_consumable_array/* default */.Z)(display);
        contentTiles.forEach(function(t) {
            // This actual position is derived because We don't want the sanity indices to be treated as 0-based.
            var actualPosition = t.position - 1;
            if (actualPosition < outfits.length) {
                newTiles.splice(actualPosition, 0, t);
            }
        });
        var promoTilesCount = display.filter(function(tile) {
            return tile._type === "tileWithPosition";
        }).length;
        if (numberOfTiles) tileCount = numberOfTiles - promoTilesCount;
        return newTiles.slice(0, tileCount);
    }, [
        outfits,
        contentTiles,
        numberOfTiles
    ]);
    var ref = (0,react.useState)(calculateTiles), tiles = ref[0], setTiles = ref[1];
    (0,react.useEffect)(function() {
        return setTiles(calculateTiles());
    }, [
        calculateTiles
    ]);
    var isCarousel = tileLayout === "carousel";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-full min-h-[700px]",
        ref: styliticsRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-[30px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsHeader, {
                    header: header
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyliticsSanityProvider, {
                    isCarousel: isCarousel,
                    tags: tags,
                    tiles: tiles,
                    ga4Data: ga4Data,
                    children: [
                        isCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsCarouselContainer, {}),
                        !isCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity_StyliticsGridContainer, {})
                    ]
                })
            ]
        })
    });
};
var StyliticsCarousel = function(props) {
    var ref, ref1;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var promotion_id = props._id || "";
    var promotion_name = props.header || "";
    var creative_name = props._type || "StyliticsCarousel";
    var styliticsSanityRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(styliticsSanityRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var ga4Data = {
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        link_url: undefined,
        cta_click: undefined
    };
    var hasTags = props.tags && props.tags.length > 0;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useOutfitsQuery */.I_9)({
        pause: !hasTags || isServer && !isCrawler,
        variables: {
            tags: ((ref = props.tags) === null || ref === void 0 ? void 0 : ref.join(",")) || ""
        }
    }), 1), results = ref2[0];
    var outfits = (ref1 = results.data) === null || ref1 === void 0 ? void 0 : ref1.outfits;
    if (!outfits || outfits.length < MIN_OUTFITS) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsSanity, {
        content: props,
        outfits: outfits,
        ga4Data: ga4Data,
        styliticsRef: styliticsSanityRef
    });
};

// EXTERNAL MODULE: ./ui/content/ProductRecommender.tsx + 1 modules
var ProductRecommender = __webpack_require__(30664);
;// CONCATENATED MODULE: ./ui/elements/Badge.tsx


var Badge = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,twind.tw)("rounded leading-none pb-1 px-1.5 font-bold text-sm", "bg-".concat(props.color), "text-".concat(props.color === "black" ? "white" : "black")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            children: props.label
        })
    });
};

;// CONCATENATED MODULE: ./ui/elements/CallToAction.tsx





var CallToAction = function(props) {
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        "data-test-id": "call-to-action",
        as: "button",
        variant: props.variant || "black",
        outlined: !!props.outlined,
        className: (0,twind.tw)("whitespace-normal", props.width === "equal" && "flex-1", props.width === "full" && "w-full", props.width === "fixed" && "w-full max-w-64"),
        href: getLink(props),
        newtab: !!props.newtab,
        popup: !!props.popup,
        query: props.query,
        onClickCTA: props.onClick,
        children: props.title
    }, props._key);
};

;// CONCATENATED MODULE: ./ui/elements/Text.tsx



var Text = function(props) {
    var header = props.header, copy = props.copy, footnote = props.footnote, align = props.align, color = props.color, icon = props.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,twind.tw)("flex flex-col relative", "text-".concat(align, " text-").concat(color, ", ").concat(icon && "gap-y-4")),
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-x-4",
                children: [
                    (icon === null || icon === void 0 ? void 0 : icon.img) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "tablet:hidden desktop:hidden",
                        src: icon.img.asset.url,
                        alt: icon.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "font-bold text-2xl leading-snug",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            content: header
                        })
                    })
                ]
            }),
            copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-normal text-base leading-snug",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    content: copy
                })
            }),
            footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: "font-normal text-sm leading-snug",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    content: footnote
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/elements/Card.tsx












var Card = function(param) {
    var image = param.image, link = param.link, badge = param.badge, style = param.style, text = param.text, ctas = param.ctas, handleClickCTA = param.handleClickCTA;
    var ref = (0,useLinkResolver/* useLinkResolver */.u)(), getLocalizedLink = ref.getLocalizedLink, getLink = ref.getLink;
    var imageKey = image && Object.keys(image).find(function(k) {
        var ref;
        return (ref = image[k]) === null || ref === void 0 ? void 0 : ref.asset;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,twind.tw)("relative overflow-hidden", (style === null || style === void 0 ? void 0 : style.border) && "border", (style === null || style === void 0 ? void 0 : style.shadow) && "shadow-lg", (style === null || style === void 0 ? void 0 : style.rounded) && "rounded-lg", (style === null || style === void 0 ? void 0 : style.background) && "bg-[".concat(style.background, "]")),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                href: getLink(link),
                "aria-label": getLocalizedLink(link),
                children: imageKey ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,twind.tw)("relative", imageKey === "portrait" && "pt-[133%]", imageKey === "square" && "pt-[100%]", imageKey === "landscape" && "pt-[66%]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                            source: image[imageKey]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-4 left-4",
                            children: (badge === null || badge === void 0 ? void 0 : badge.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, (0,_object_spread/* default */.Z)({}, badge))
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-puma-black-700 pt-[100%]"
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,twind.tw)("relative space-y-3", (style === null || style === void 0 ? void 0 : style.border) ? "p-5" : "pt-5"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({}, text)),
                    !!(ctas === null || ctas === void 0 ? void 0 : ctas.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,twind.tw)("flex flex-wrap flex-gap-3", text.align ? "justify-".concat(alignmentToFlexDirection(text.align)) : ""),
                        children: ctas.map(function(cta) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CallToAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cta), {
                                onClick: handleClickCTA && !!cta.title ? handleClickCTA === null || handleClickCTA === void 0 ? void 0 : handleClickCTA(cta.title) : undefined
                            }), cta._key);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/elements/Tile.tsx












var Tile = function(param) {
    var image = param.image, aspectRatio = param.aspectRatio, link = param.link, alignment = param.alignment, style = param.style, icon = param.icon, text = param.text, ctas = param.ctas, handleClickCTA = param.handleClickCTA;
    var ref, ref1;
    var ref2 = (0,useResizeObserver/* useResizeObserver */.y)(), ref3 = ref2.ref, width = ref2.width, height = ref2.height;
    var ref4 = (0,useLinkResolver/* useLinkResolver */.u)(), getLocalizedLink = ref4.getLocalizedLink, getLink = ref4.getLink;
    var orientation = Math.abs(width / height - 1) < 0.1 ? "square" : width > height ? "landscape" : "portrait";
    var imageKey = image && (image[orientation] && orientation || Object.keys(image).find(function(k) {
        var ref;
        return (ref = image[k]) === null || ref === void 0 ? void 0 : ref.asset;
    }));
    var ratio = aspectRatio ? ({
        portrait: 133,
        square: 100,
        landscape: 66
    })[aspectRatio] : 66;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,twind.tw)("relative overflow-hidden", (style === null || style === void 0 ? void 0 : style.border) && "border", (style === null || style === void 0 ? void 0 : style.shadow) && "shadow-lg", (style === null || style === void 0 ? void 0 : style.rounded) && "rounded-lg", (style === null || style === void 0 ? void 0 : style.background) && "bg-[".concat(style.background, "]")),
        children: !!link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref3
        }, link), {
            href: getLink(link),
            "aria-label": getLocalizedLink(link),
            className: (0,twind.tw)("flex", alignment.vertical && "items-".concat(alignmentToFlexDirection(alignment === null || alignment === void 0 ? void 0 : alignment.vertical)), aspectRatio && "before:(content-[''] float-left ".concat(icon ? "mobile:pb-0 tablet:pb-[".concat(ratio, "%] desktop:pb-[").concat(ratio, "%]") : "pb-[".concat(ratio, "%]"), ") after:(content-[''] table clear-both)")),
            children: [
                imageKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: image[imageKey]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,twind.tw)("relative w-full space-y-3 p-5", alignment.horizontal && "justify-".concat(alignmentToFlexDirection(alignment === null || alignment === void 0 ? void 0 : alignment.horizontal)), alignment.horizontal && "items-".concat(alignmentToFlexDirection(alignment === null || alignment === void 0 ? void 0 : alignment.horizontal)), icon && "flex flex-col justify-between h-full mobile:(px-4 py-6) tablet:p-8 desktop:p-8"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,twind.tw)("relative flex w-full", alignment.horizontal && "justify-".concat(alignmentToFlexDirection(alignment === null || alignment === void 0 ? void 0 : alignment.horizontal))),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, text), {
                                    icon: icon
                                })),
                                ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CallToAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cta), {
                                        onClick: handleClickCTA ? handleClickCTA === null || handleClickCTA === void 0 ? void 0 : handleClickCTA((cta === null || cta === void 0 ? void 0 : cta.title) || "") : undefined
                                    }), cta._key);
                                })
                            ]
                        }),
                        ctas && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,twind.tw)("flex flex-wrap flex-gap-3", (text === null || text === void 0 ? void 0 : text.align) && "justify-".concat(alignmentToFlexDirection(text === null || text === void 0 ? void 0 : text.align))),
                            children: ctas.map(function(cta) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, (0,_object_spread/* default */.Z)({}, cta), cta._key);
                            })
                        }),
                        (icon === null || icon === void 0 ? void 0 : (ref = icon.img) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "mobile:hidden",
                            src: icon.img.asset.url,
                            alt: icon.alt || ""
                        })
                    ]
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./ui/content/LaunchCalendar.tsx








var fireMyAccountOverviewEvent = function(title) {
    return function() {
        return (0,analytics/* myAccountOverviewEvent */.My)({
            userAction: "banner click - ".concat(title.toLowerCase())
        });
    };
};
// NOTE - This is confusingly called 'Launch Calendar' as this matches the component name in sanity
// https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/LaunchCalendar.ts#L20
// We actually mean this to be 'Cards and Tiles' which JP still use for their store locator pages
var LaunchCalendar = function(props) {
    var router = (0,next_router.useRouter)();
    var accountOverviewPage = router.asPath === "/".concat(router.query.country, "/").concat(router.query.language, "/account");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative grid gap-8 grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 ".concat(!accountOverviewPage ? "xl:grid-cols-4" : ""),
        children: props.calendarContent && props.calendarContent.map(function(item) {
            switch(item === null || item === void 0 ? void 0 : item._type){
                case "Card":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        handleClickCTA: accountOverviewPage && fireMyAccountOverviewEvent
                    }), item._key);
                case "Tile":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        handleClickCTA: accountOverviewPage && fireMyAccountOverviewEvent
                    }), item._key);
                default:
                    return null;
            }
        })
    });
};

// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
// EXTERNAL MODULE: ./hooks/useToast.tsx
var useToast = __webpack_require__(14476);
// EXTERNAL MODULE: ./ui/content/SignUpFormField.tsx
var SignUpFormField = __webpack_require__(32042);
;// CONCATENATED MODULE: ./ui/content/SignUpFormHero.tsx
























// See SignUpForm.tsx for DataLayer
var SignUpHeroBanner = function(props) {
    var inverted = !!props.inverted;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateContactMutation */.LrK)(), 2), createContactResult = ref[0], createContact = ref[1];
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var submittedSuccessfully = createContactResult.data && !createContactResult.error && !createContactResult.fetching;
    var openToast = (0,useToast/* useToast */.p)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useInView/* useInView */.Y)(), 2), signUpFormHeroInViewRef = ref1[0], signUpFormHeroInView = ref1[1];
    var gaTrackData = {
        id: props._id || "",
        name: props.header || "",
        creative: props._type || ""
    };
    (0,usePromotionView/* usePromotionView */.Y)(signUpFormHeroInViewRef, gaTrackData, true);
    (0,react.useEffect)(function() {
        if (submittedSuccessfully) {
            openToast({
                variant: "success",
                title: props.successHeader,
                description: props.successCopy
            });
        }
    }, [
        submittedSuccessfully,
        openToast,
        props.successCopy,
        props.successHeader, 
    ]);
    (0,react.useEffect)(function() {
        if (signUpFormHeroInView) {
            (0,analytics/* emailSignUpEvent */.QZ)(analyticTypes/* EmailSignUpActions.Impression */.VF.Impression, "SignUpFormHero");
        }
    }, [
        signUpFormHeroInView
    ]);
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {},
        shouldUnregister: false,
        mode: "onChange"
    });
    var submitForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var contact, result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        contact = (0,SignUpFormField/* createContactInput */.h)(data, props.contactSource, countryCode);
                        _tmp = {};
                        return [
                            4,
                            createContact((_tmp.input = {
                                contact: contact
                            }, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        (0,analytics/* emailSignUpEvent */.QZ)(result.error ? analyticTypes/* EmailSignUpActions.Error */.VF.Error : analyticTypes/* EmailSignUpActions.Submit */.VF.Submit, "SignUpFormHero");
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function submitForm(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (form.formState.isSubmitted && Object.keys(form.formState.errors).length) {
            (0,analytics/* emailSignUpEvent */.QZ)(analyticTypes/* EmailSignUpActions.Error */.VF.Error, "SignUpFormHero");
        }
    }, [
        form.formState
    ]);
    var details = {
        ctaLabel: props.submitButtonText
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        "data-test-id": "sign-up-form-hero-banner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (0,css.tw)("relative overflow-hidden", props.backgroundColor ? "bg-[".concat(props.backgroundColor, "]") : inverted ? "bg-black" : "bg-white", inverted ? "text-white" : "text-puma-black"),
            ref: signUpFormHeroInViewRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                        source: props.formBackgroundImage,
                        mobileSource: props.mobileBackgroundImage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex flex-col text-center items-center px-8 py-6 md:px-10 md:py-10 lg:px-16 lg:py-12 space-y-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                props.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHeading/* ContentHeading */.H, {
                                    header: props.header,
                                    className: "text-3xl xs:text-4xl md:text-5xl font-bold font-display",
                                    headingTag: props.headingTag
                                }),
                                props.copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base xs:text-xl md:text-2xl mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.copy
                                    })
                                }),
                                props.footnote && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs mt-1 md:text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        content: props.footnote
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mt-6 flex flex-col space-y-3 max-w-64 mx-auto mt-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                                        linkProps: {
                                            variant: inverted ? "white" : "black"
                                        },
                                        ctas: props.ctas
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "w-full border-t border-neutral-50"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "flex w-full flex-col max-w-3xl mt-4 justify-center space-y-6",
                            onSubmit: form.handleSubmit(function(data) {
                                return submitForm(data);
                            }),
                            children: [
                                (0,extractError/* extractError */.d)(createContactResult) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                                    title: "Error",
                                    variant: "error",
                                    content: (0,extractError/* extractError */.d)(createContactResult)
                                }),
                                props.fields.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,css.tw)("grid grid-cols-1 gap-2 md:gap-4", props.fields.length > 1 && "sm:grid-cols-2"),
                                            children: props.fields.map(function(field) {
                                                if (field === "name") return [
                                                    "firstName",
                                                    "lastName"
                                                ].map(function(name) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                            inverted: inverted,
                                                            form: form,
                                                            field: name,
                                                            isLoading: createContactResult.fetching,
                                                            details: details
                                                        })
                                                    }, name);
                                                });
                                                else if (field === "address") return [
                                                    "address",
                                                    "city",
                                                    "zip-code"
                                                ].map(function(name) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                            inverted: inverted,
                                                            form: form,
                                                            field: name,
                                                            isLoading: createContactResult.fetching,
                                                            details: details
                                                        })
                                                    }, name);
                                                });
                                                else if (field === "ticketChoice") return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "w-full flex flex-col sm:flex-row sm:col-span-2 sm:justify-around",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: "flex flex-col justify-center",
                                                            children: props.customText
                                                        }),
                                                        [
                                                            "montreal",
                                                            "toronto"
                                                        ].map(function(name) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                                inverted: inverted,
                                                                form: form,
                                                                field: name,
                                                                isLoading: createContactResult.fetching,
                                                                details: details
                                                            }, name);
                                                        })
                                                    ]
                                                }, field);
                                                else return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,css.tw)((field === "opt-out" || field === "ageCheck" || field === "emailPreference") && "flex justify-start mt-4 col-span-full"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                        inverted: inverted,
                                                        form: form,
                                                        field: field,
                                                        isLoading: createContactResult.fetching,
                                                        details: details
                                                    })
                                                }, field);
                                            })
                                        }),
                                        props.portableDisclaimerText && /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                                            id: "sign-up-form-newsletter-disclaimer-text",
                                            blocks: props.portableDisclaimerText,
                                            serializers: serializeBlockContent/* serializeTocBlockContent */.lw,
                                            className: "w-full"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                                label: props.submitButtonText,
                                                type: "submit",
                                                size: "lg",
                                                className: "w-full max-w-72",
                                                invert: inverted
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col sm:flex-row gap-2 md:gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-grow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                inverted: inverted,
                                                form: form,
                                                field: props.fields[0],
                                                isLoading: createContactResult.fetching,
                                                details: details
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            label: props.submitButtonText,
                                            type: "submit",
                                            size: "lg",
                                            className: "w-full max-w-72",
                                            invert: inverted
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./ui/content/InfoBanner.tsx
var InfoBanner = __webpack_require__(86491);
// EXTERNAL MODULE: ../node_modules/randomstring/index.js
var randomstring = __webpack_require__(9889);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./ui/content/PixleeSimpleWidget.tsx








var initPixlee = function(apiKey) {
    if (!window.PixleeAsyncInit) {
        window.PixleeAsyncInit = function() {
            window.Pixlee.init({
                apiKey: apiKey
            });
        };
    }
};
var addPixleeWidget = function(param) {
    var widgetId = param.widgetId, containerId = param.containerId;
    window.Pixlee.addSimpleWidget({
        widgetId: widgetId,
        containerId: containerId
    });
    window.Pixlee.resizeWidget();
};
var PixleeSimpleWidget = function(param) {
    var widgetId = param.widgetId;
    var ref, ref1;
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* usePixleeConfigQuery */.QW$)(), 1), pixleeConfigResponse = ref2[0];
    var ref3 = (0,react.useState)(false), widgetAdded = ref3[0], setWidgetAdded = ref3[1];
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var randomId = (0,react.useMemo)(function() {
        return randomstring.generate(8);
    }, []);
    var containerId = "pixlee-simple-widget-".concat(widgetId, "-").concat(randomId);
    var pixleeEnabled = !!((ref = pixleeConfigResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.pixleeConfig) === null || ref1 === void 0 ? void 0 : ref1.enable);
    var shouldInitPixlee = Boolean(!isServer && widgetId && pixleeEnabled);
    (0,react.useEffect)(function() {
        return function() {
            var ref;
            return (ref = window.Pixlee) === null || ref === void 0 ? void 0 : ref.close();
        };
    }, []);
    if (!shouldInitPixlee) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                "data-test-id": "pixlee-simple-widget-script",
                src: "https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js",
                onReady: function() {
                    initPixlee(env.pixleeApiKey);
                    if (!widgetAdded) {
                        addPixleeWidget({
                            widgetId: widgetId,
                            containerId: containerId
                        });
                        setWidgetAdded(true);
                    }
                }
            }, "pixlee-simple-widget-script"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: containerId,
                "data-test-id": "pixlee-simple-widget"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/content/Iframe.tsx





var Iframe = function(props) {
    if (!props.src) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeContainer, {
        id: props.id,
        typename: props.__typename,
        fullScreen: props.fullScreen,
        height: props.height,
        src: props.src
    });
};
var IframeContainer = function(param) {
    var id = param.id, typename = param.typename, fullScreen = param.fullScreen, height = param.height, src = param.src;
    var iframeRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: id || "",
        name: "",
        creative: typename || "Iframe"
    };
    (0,usePromotionView/* usePromotionView */.Y)(iframeRef, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: fullScreen,
        "data-test-id": "iframe-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (0,twind.tw)(fullScreen && "mobile:-my-4 tablet:-my-6 desktop:-my-8"),
            ref: iframeRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,twind.tw)("w-full", fullScreen ? "h-screen" : "h-[".concat(height || "600", "px]")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: "w-full h-full",
                    src: src,
                    allow: "geolocation"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./ui/content/AdditionalContentSection.tsx





function AdditionalContentSection(param) {
    var _id = param._id, _type = param._type, text = param.text, localeText = param.localeText;
    var additionalContentSectionRef = (0,react.useRef)(null);
    var promotionId = _id || "";
    var promotionName = "";
    var creativeName = _type || "AdditionalContentSection";
    var gaTrackData = {
        id: promotionId,
        name: promotionName,
        creative: creativeName
    };
    (0,usePromotionView/* usePromotionView */.Y)(additionalContentSectionRef, gaTrackData, true);
    if (!localeText && !text) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "additional-content-section",
        ref: additionalContentSectionRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
            id: _id + "-additional-content",
            blocks: localeText || text,
            serializers: serializeBlockContent/* serializeTocBlockContent */.lw,
            className: "w-full"
        })
    });
}

// EXTERNAL MODULE: ./hooks/usePriceFormatter.ts + 1 modules
var usePriceFormatter = __webpack_require__(23658);
// EXTERNAL MODULE: ./utils/removeHyphens.ts
var removeHyphens = __webpack_require__(47802);
// EXTERNAL MODULE: ./utils/getMinimalNumber.ts
var getMinimalNumber = __webpack_require__(23295);
// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
;// CONCATENATED MODULE: ./ui/content/AutomatedProductComparison.tsx



function AutomatedProductComparison_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  td {\n    @apply px-4 py-4 text-center;\n  }\n  th {\n    @apply w-80 min-w-80 px-6 py-4 text-left uppercase border-white border-r-[1vw];\n  }\n  & > tbody > :nth-child(odd) {\n    @apply bg-puma-black-800;\n  }\n  & > tbody > :nth-child(even) {\n    @apply bg-white;\n  }\n"
    ]);
    AutomatedProductComparison_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var AutomatedProductComparison_tableStyles = (0,style/* css */.iv)(AutomatedProductComparison_templateObject());
var AutomatedProductComparison = function(props) {
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var router = (0,next_router.useRouter)();
    var pdpMasterProductId = router.query.id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVariantsQuery */.kii)({
        variables: {
            input: {
                styleNumberIds: props.products.map(function(p) {
                    return "".concat(p.masterId, "_").concat(p.color);
                })
            },
            includeComparisonFields: true
        },
        pause: props.products.length === 0 || isServer
    }), 1), variantsResult = ref[0];
    var comparisonProducts = (0,react.useMemo)(function() {
        var ref;
        var variants = (ref = variantsResult.data) === null || ref === void 0 ? void 0 : ref.variants;
        if (!variants) return [];
        return (0,_to_consumable_array/* default */.Z)(variants).sort(function(p) {
            return p.masterId.toString() === pdpMasterProductId ? -1 : 1;
        }).filter(function(p, idx) {
            return idx === 0 ? true : p.orderable;
        });
    }, [
        variantsResult,
        pdpMasterProductId
    ]);
    if (comparisonProducts.length < 2) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutomatedProductComparisonSection, {
        id: props._id,
        header: props.header,
        type: props._type,
        pdpMasterProductId: pdpMasterProductId,
        comparisonFields: props.comparisonFields,
        comparisonProducts: comparisonProducts
    });
};
var AutomatedProductComparisonSection = function(param) {
    var id = param.id, header = param.header, type = param.type, pdpMasterProductId = param.pdpMasterProductId, comparisonFields = param.comparisonFields, comparisonProducts = param.comparisonProducts;
    var priceFormatter = (0,usePriceFormatter/* usePriceFormatter */.o)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref.staticFeatures.showHeaderSubHeaderProductDetail;
    var getComparisonFieldValueForProduct = function(field, product) {
        switch(field){
            case "product-name":
                return showHeaderSubHeaderProductDetail ? product.header : product.name;
            case "run-terrain":
                return product.runTerrain;
            case "key-technology":
                return product.technology;
            case "weight":
                if (product.weight) return "".concat(product.weight, "g");
                break;
            case "heel-to-toe-drop":
                if ((0,isNumber/* isNumber */.h)(product.heelToToeDrop)) {
                    return "".concat(product.heelToToeDrop, "mm");
                }
                break;
            case "price":
                var _productPrice;
                var ref = (_productPrice = product.productPrice) !== null && _productPrice !== void 0 ? _productPrice : {}, price = ref.price, salePrice = ref.salePrice, promotionPrice = ref.promotionPrice;
                var finalPrice = (0,getMinimalNumber/* getMinimalNumber */.q)(price, salePrice, promotionPrice);
                return finalPrice ? priceFormatter(finalPrice) : null;
            case "fastener":
                return product.fastener;
            case "pronation":
                return product.pronation;
            case "runner-type":
                return product.runnerType;
            case "cushioning":
                return product.refinementCushioningLevel;
            case "main-material":
                return product.mainMaterial;
            case "cup-type":
                return product.cupType;
            case "trouser-rise":
                return product.trouserRise;
            case "pocket":
                return product.pocketType;
            case "length":
                return product.apparelLength;
            case "characteristics":
                return product.characteristics;
            case "support-level":
                return product.supportLevelBra;
            case "stud-type":
                return product.studs;
            case "player-level":
                return product.playerLevel;
            case "fit":
                return product.fit;
            case "category":
                return showHeaderSubHeaderProductDetail && product.subHeader;
            default:
                return null;
        }
    };
    var automatedProductComparisonRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: id || "",
        name: header || "",
        creative: type || "AutomatedProductComparison"
    };
    (0,usePromotionView/* usePromotionView */.Y)(automatedProductComparisonRef, gaTrackData, true);
    var setProduct = (0,useGA4Events/* useGA4Events */.tL)().setProduct;
    // To differentiate in which carousel the click occurred.
    var setIsProductClicked = (0,useProductClickHandling/* useProductClickHandling */.g)();
    var handleLinkClick = function(product, i) {
        (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.AutomatedComparison */.Ei.AutomatedComparison);
        (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(product.masterId, "_").concat(product.colorValue), {
            lid: id,
            lname: type,
            idx: i
        });
        setProduct(product);
    };
    var handleButtonClick = function() {
        var ref;
        (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.AutomatedComparison */.Ei.AutomatedComparison);
        (ref = document.querySelector("#pdp-product-title")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "relative w-full",
        "aria-label": header || undefined,
        ref: automatedProductComparisonRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-full overflow-x-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                className: (0,style.tw)("table-auto w-full relative", AutomatedProductComparison_tableStyles),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "text-3xl font-bold uppercase align-top pt-8!",
                                    children: header
                                }),
                                comparisonProducts === null || comparisonProducts === void 0 ? void 0 : comparisonProducts.map(function(product) {
                                    var ref, ref3;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                        className: "p-0! bg-white!",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (ref1 = (ref = product.images[0]) === null || ref === void 0 ? void 0 : ref.href) !== null && ref1 !== void 0 ? ref1 : "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/".concat(product.masterId, "/").concat(product.colorValue, "/sv01"),
                                            alt: (ref2 = (ref3 = product.images[0]) === null || ref3 === void 0 ? void 0 : ref3.alt) !== null && ref2 !== void 0 ? ref2 : product.name,
                                            className: "mx-auto! h-40 w-40"
                                        })
                                    }, product.id);
                                })
                            ]
                        }),
                        comparisonFields === null || comparisonFields === void 0 ? void 0 : comparisonFields.map(function(field) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: (0,removeHyphens/* removeHyphens */.V)(field)
                                    }),
                                    comparisonProducts === null || comparisonProducts === void 0 ? void 0 : comparisonProducts.map(function(product) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: (ref3 = getComparisonFieldValueForProduct(field, product)) !== null && ref3 !== void 0 ? ref3 : "-"
                                        }, product.id);
                                    })
                                ]
                            }, field);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            onClick: function() {
                                return setIsProductClicked(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "bg-white!"
                                }),
                                comparisonProducts === null || comparisonProducts === void 0 ? void 0 : comparisonProducts.map(function(product, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "p-0! bg-white! p-4!",
                                        children: product.masterId.toString() === pdpMasterProductId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                            type: "button",
                                            variant: "secondary",
                                            onClick: function() {
                                                return handleButtonClick();
                                            },
                                            label: t("productComparisonCtaCurrent")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                                            variant: "secondary",
                                            href: (0,buildProductUrl/* buildProductUrl */.B)(product.masterId.toString(), product.name, {
                                                color: product.colorValue
                                            }),
                                            onClick: function() {
                                                return handleLinkClick(product, i);
                                            },
                                            label: t("productComparisonCta")
                                        })
                                    }, product.id);
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../node_modules/react-scrollbars-custom/dist/rsc.esm.js + 2 modules
var rsc_esm = __webpack_require__(23727);
// EXTERNAL MODULE: ./hooks/usePromotionSelect.ts
var usePromotionSelect = __webpack_require__(36858);
// EXTERNAL MODULE: ./utils/isTouchScreenDevice.ts
var isTouchScreenDevice = __webpack_require__(41332);
// EXTERNAL MODULE: ./utils/dateCalculations.ts
var dateCalculations = __webpack_require__(35525);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
;// CONCATENATED MODULE: ./ui/content/Quilt.tsx





















var configure = function(media) {
    if (!(media === null || media === void 0 ? void 0 : media.layout)) return {
        gap: "base",
        layout: "stack"
    };
    if (media.layout.startsWith("masonry")) {
        var ref = (0,_sliced_to_array/* default */.Z)(media.layout.split("-"), 2), align = ref[1];
        return {
            align: align,
            gap: media.gap,
            layout: "masonry"
        };
    }
    var ref1 = (0,_sliced_to_array/* default */.Z)(media.layout.split("-"), 2), layoutType = ref1[0], columns = ref1[1];
    return {
        columns: parseInt(columns),
        gap: media.gap,
        layout: layoutType,
        limit: media.limit
    };
};
var showTile = function(availableFrom, availableTo, dateToCheck) {
    if ((0,isNotNullish/* isNotNullish */.l)(availableFrom)) {
        var startDate = new Date(availableFrom);
        if ((0,isNotNullish/* isNotNullish */.l)(availableTo)) {
            return (0,dateCalculations/* isDateBetween */.zx)({
                startDate: startDate,
                endDate: new Date(availableTo),
                dateToCheck: dateToCheck
            });
        } else {
            return (0,dateCalculations/* IsDateAfter */.Cy)({
                dateToCheck: dateToCheck,
                startDate: startDate
            });
        }
    } else if ((0,isNotNullish/* isNotNullish */.l)(availableTo)) {
        return (0,dateCalculations/* isDateBefore */.hF)({
            dateToCheck: dateToCheck,
            endDate: new Date(availableTo)
        });
    }
    return true;
};
var Quilt = function(props) {
    var _id = props._id, _type = props._type, items = props.items, mobile = props.mobile, tablet = props.tablet, desktop = props.desktop, inverted = props.inverted, tileLayout = props.tileLayout, tileMediaRatio = props.tileMediaRatio, contentJustify = props.contentJustify;
    var router = (0,next_router.useRouter)();
    var dateToCheck = router.query.viewAt ? new Date(parseInt(router.query.viewAt)) : new Date();
    var isMobile = (0,media/* getIsMobile */.W)();
    var isMobileTouchDevice = (0,media/* getIsMobile */.W)() && (0,isTouchScreenDevice/* isTouchScreenDevice */.S)();
    var promotion_id = _id || "";
    var promotion_name = "";
    var creative_name = _type || "Quilt";
    var quiltRef = (0,react.useRef)(null);
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    (0,usePromotionView/* usePromotionView */.Y)(quiltRef, gaTrackData, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: quiltRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* QuiltRoot */.oK3, {
            config: {
                mobile: configure(mobile),
                tablet: configure(tablet),
                desktop: configure(desktop)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rsc_esm/* Scrollbar */.LW, {
                native: !isMobileTouchDevice,
                translateContentSizeYToHolder: true,
                removeTracksWhenNotUsed: true,
                disableTracksWidthCompensation: true,
                disableTrackYMousewheelScrolling: true,
                trackXProps: {
                    renderer: function(props) {
                        var elementRef = props.elementRef, style = props.style, restProps = (0,_object_without_properties/* default */.Z)(props, [
                            "elementRef",
                            "style"
                        ]);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                            ref: elementRef,
                            className: "TrackX",
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                                height: 6,
                                left: 0,
                                bottom: "-7px",
                                width: "100%",
                                display: isMobileTouchDevice ? "block" : "none"
                            })
                        }));
                    }
                },
                scrollerProps: {
                    renderer: function(props) {
                        var elementRef = props.elementRef, style = props.style, restProps = (0,_object_without_properties/* default */.Z)(props, [
                            "elementRef",
                            "style"
                        ]);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                            ref: elementRef,
                            className: "MyAwesomeScrollbarsScroller" // Default library className
                            ,
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                                scrollSnapType: "x mandatory",
                                scrollBehavior: "smooth"
                            })
                        }));
                    }
                },
                contentProps: {
                    renderer: function(props) {
                        var elementRef = props.elementRef, style = props.style, restProps = (0,_object_without_properties/* default */.Z)(props, [
                            "elementRef",
                            "style"
                        ]);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                            ref: elementRef,
                            className: "Content pb-4",
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                                display: "block"
                            })
                        }));
                    }
                },
                thumbXProps: {
                    renderer: function(props) {
                        var elementRef = props.elementRef, style = props.style, restProps = (0,_object_without_properties/* default */.Z)(props, [
                            "elementRef",
                            "style"
                        ]);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                            ref: elementRef,
                            className: "ThUmBX",
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                                background: "rgba(0, 0, 0, 0.65)"
                            })
                        }));
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* QuiltViewport */.oWz, {
                    asChild: true,
                    className: (0,twind.tw)(mobile.layout.startsWith("scroll") && "mobile:pb-6", tablet.layout.startsWith("scroll") && "tablet:pb-6", desktop.layout.startsWith("scroll") && "desktop:pb-8", "hide-scrollbar overflow-x-visible!"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: items.filter(function(item) {
                            return showTile(item === null || item === void 0 ? void 0 : item.availableFrom, item === null || item === void 0 ? void 0 : item.availableTo, dateToCheck);
                        }).map(function(item, i) {
                            return /*#__PURE__*/ (0,react.createElement)(QuiltTile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                isMobile: isMobile,
                                tileLayout: tileLayout,
                                tileMediaRatio: tileMediaRatio,
                                inverted: inverted,
                                contentJustify: contentJustify,
                                key: i
                            }));
                        })
                    })
                })
            })
        })
    });
};
var QuiltTile = function(props) {
    var quiltTileRef = (0,react.useRef)(null);
    var getLink = (0,useLinkResolver/* useLinkResolver */.u)().getLink;
    var normalized = (0,react.useMemo)(function() {
        switch(props._type){
            case "PromoTile":
                var ref;
                return {
                    id: props._id,
                    color: props.backgroundColor,
                    media: props.backgroundImage,
                    mobileMedia: props.mobileBackgroundImage,
                    heading: props.header,
                    description: props.copy,
                    title: (ref = props.cta) === null || ref === void 0 ? void 0 : ref.title,
                    link: getLink(props.cta)
                };
            case "category":
                return {
                    id: props._id,
                    heading: props.name,
                    link: props.url,
                    media: props.image
                };
            default:
                return {};
        }
    }, [
        props,
        getLink
    ]);
    var promotion_id = normalized.id || "";
    var promotion_name = normalized.heading || "";
    var creative_name = "QuiltTile";
    var gaTrackData = {
        id: promotion_id,
        name: promotion_name,
        creative: creative_name
    };
    var ga4PromotionTrackerPosition = (0,usePromotionView/* usePromotionView */.Y)(quiltTileRef, gaTrackData, true).ga4PromotionTrackerPosition;
    var router = (0,next_router.useRouter)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var link_page_type = normalized.link ? (0,analytics/* getPageType */.C2)(localizeUrlPath(normalized.link)) : undefined;
    var setPromotion = link_page_type === "plp";
    var ga4Data = (0,_object_spread/* default */.Z)({
        creative_name: creative_name,
        creative_slot: ga4PromotionTrackerPosition,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        cta_click: undefined,
        fireEventFromPdp: router.asPath.includes("/pd/"),
        link_url: normalized.link,
        link_page_type: link_page_type
    }, setPromotion && {
        setPromotion: setPromotion
    });
    var promotionSelectEvent = (0,usePromotionSelect/* usePromotionSelect */.y)().promotionSelectEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* QuiltCell */.N6d, {
        ref: quiltTileRef,
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TileRoot */.OH2, {
                className: "h-full",
                fill: "media",
                invert: props.inverted,
                layout: props.tileLayout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileMedia */.uIU, {
                        className: normalized.color ? "bg-[".concat(normalized.color, "]") : "",
                        ratio: props.tileMediaRatio,
                        vignette: props.tileLayout === "overlay",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                            source: normalized.media,
                            mobileSource: normalized.mobileMedia
                        })
                    }),
                    !!normalized.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkInvBlock */.p67, {
                        href: normalized.link,
                        focusable: !(normalized === null || normalized === void 0 ? void 0 : normalized.link),
                        onClick: function() {
                            return promotionSelectEvent((0,_object_spread/* default */.Z)({}, ga4Data));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TileContent */.Y2I, {
                        justify: props.contentJustify,
                        insetX: props.tileLayout === "stack" && !props.inverted && props.contentJustify !== "center" ? false : true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TileBody */.hnB, {
                                children: [
                                    normalized.heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileHeading */.ZRD, {
                                        balance: true,
                                        condensed: true,
                                        children: normalized.heading
                                    }),
                                    normalized.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileDescription */.NhG, {
                                        balance: true,
                                        children: normalized.description
                                    })
                                ]
                            }),
                            (normalized === null || normalized === void 0 ? void 0 : normalized.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TileActionList */.qWt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
                                    href: normalized.link || "",
                                    label: normalized === null || normalized === void 0 ? void 0 : normalized.title,
                                    onClick: function() {
                                        return promotionSelectEvent((0,_object_spread/* default */.Z)({}, ga4Data));
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(75350);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 3 modules
var ProductPrice = __webpack_require__(1108);
// EXTERNAL MODULE: ./ui/components/Sizes/index.ts + 9 modules
var Sizes = __webpack_require__(38913);
// EXTERNAL MODULE: ./ui/components/ProductListItemImages.tsx
var ProductListItemImages = __webpack_require__(45876);
// EXTERNAL MODULE: ./ui/components/Skeleton.tsx
var Skeleton = __webpack_require__(98463);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
;// CONCATENATED MODULE: ./ui/components/StyliticsWidget/StyliticsModal.tsx






























var MAX_PRODUCTS_PER_BUNDLE = 5;
var StyliticsModal = function(props) {
    var isMiniCartVisible = (0,useMiniCart/* useMiniCart */.lm)().isMiniCartVisible;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogRoot */.GRm, {
        dataTestId: "stylitics-modal",
        size: {
            _: "full",
            xs: "sm"
        },
        drawer: {
            _: false,
            xs: true
        },
        justify: "end",
        open: props.open,
        onOpenChange: function(open) {
            var ref;
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (0,_define_property/* default */.Z)({
                domevent: "Stylitics - Close"
            }, analyticTypes/* Dimensions.d27 */.Db.d27, (ref = props.selectedBundle) === null || ref === void 0 ? void 0 : ref.id));
            props.onOpenChange(open);
        },
        autoFocus: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogContent */.cZJ, {
            onInteractOutside: function(e) {
                var target = e.detail.originalEvent.target;
                var originatesFromMiniCart = Boolean(target === null || target === void 0 ? void 0 : target.closest("#modal"));
                // Prevents `StyliticsModal` from closing when the user interacts with `MiniCart` or other Modal
                if (isMiniCartVisible || originatesFromMiniCart) e.preventDefault();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeader */.fKu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeading */.EtB, {
                        children: t("completeTheLook")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogBody */.a7O, {
                    className: "overflow-y-auto overflow-x-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bundle, {
                            bundle: props.selectedBundle,
                            closeModal: function() {
                                return props.onOpenChange(false);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Scroller, {
                            bundles: props.bundles,
                            currentBundle: props.selectedBundle,
                            setCurrentBundle: props.setSelectedBundle
                        })
                    ]
                })
            ]
        })
    });
};
var Bundle = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), currentItem = ref[0], setCurrentItem = ref[1];
    var _bundle = props.bundle, items = _bundle.items, primary_remote_id = _bundle.primary_remote_id;
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref1.staticFeatures.showHeaderSubHeaderProductDetail;
    react.useEffect(function() {
        return setCurrentItem(items[0]);
    }, [
        items,
        primary_remote_id
    ]);
    // Sometimes Stylitics sends us more than 5 items per bundle. We only want to show the first 5.
    var itemsToRender = items.slice(0, MAX_PRODUCTS_PER_BUNDLE);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Container */.W20, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSelector, {
                items: itemsToRender,
                currentItem: currentItem,
                setCurrentItem: setCurrentItem,
                currentBundle: props.bundle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Spacer */.LZC, {
                gap: "sm"
            }),
            currentItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Product, {
                item: currentItem,
                bundle: props.bundle,
                closeModal: props.closeModal,
                flagHeaderSubHeader: showHeaderSubHeaderProductDetail
            }, currentItem.item_id)
        ]
    });
};
var ProductSelector = function(props) {
    var numberOfItems = props.items.length;
    var widgetInstance = (0,store/* useWidgetInstanceStore */.fK)().widgetInstance;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVariantsQuery */.kii)({
        variables: {
            input: {
                styleNumberIds: props.items.map(function(item) {
                    return item.remote_id;
                })
            }
        },
        pause: props.items.length === 0
    }), 1), variantsQuery = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        direction: "inline",
        gap: "xs",
        className: "justify-center",
        dataTestId: "stylitics-modal-product-selector",
        children: variantsQuery.fetching ? (0,_to_consumable_array/* default */.Z)(Array(numberOfItems)).map(function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                className: "w-16 aspect-1-1 flex-none",
                delay: "".concat((i + 1) * 100, "ms")
            }, i);
        }) : props.items.map(function(product) {
            var ref, ref1, ref2;
            var variant = (ref = variantsQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : ref1.find(function(variant) {
                var styleNumber = "".concat(variant.masterId, "_").concat(variant.colorValue);
                return styleNumber === product.remote_id;
            });
            var _href;
            var srcImg = (_href = variant === null || variant === void 0 ? void 0 : variant.images[0].href) !== null && _href !== void 0 ? _href : product.image_url;
            var isCurrentItem = product.item_id === ((ref2 = props.currentItem) === null || ref2 === void 0 ? void 0 : ref2.item_id);
            var _alt;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-16 flex-none transform-gpu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                    src: (0,utils_image/* resizeProductImage */.QW)(srcImg, 128, "2000"),
                    alt: (_alt = variant === null || variant === void 0 ? void 0 : variant.images[0].alt) !== null && _alt !== void 0 ? _alt : "",
                    title: variant === null || variant === void 0 ? void 0 : variant.images[0].alt,
                    className: (0,twind.tw)([
                        !product.stocked && "opacity-50",
                        !variant && "opacity-50",
                        isCurrentItem && "border border-puma-black-200 rounded-sm", 
                    ]),
                    onClick: function() {
                        var _obj;
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (_obj = {
                            domevent: "Stylitics - Select Product"
                        }, (0,_define_property/* default */.Z)(_obj, analyticTypes/* Dimensions.d27 */.Db.d27, props.currentBundle.id), (0,_define_property/* default */.Z)(_obj, "stylitics_product", variant === null || variant === void 0 ? void 0 : variant.name), (0,_define_property/* default */.Z)(_obj, "stylitics_product_id", product === null || product === void 0 ? void 0 : product.remote_id), _obj));
                        if (product === null || product === void 0 ? void 0 : product.remote_id) {
                            widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.trackClickItem(product === null || product === void 0 ? void 0 : product.remote_id);
                        }
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                            event_name: analytics/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics,
                            event_params: {
                                user_action: "".concat(analytics/* AnalyticsEvents.GA4_PRODUCT_CLICK */._q.GA4_PRODUCT_CLICK),
                                item_id_ep: "".concat(variant === null || variant === void 0 ? void 0 : variant.id),
                                item_name_ep: "".concat(variant === null || variant === void 0 ? void 0 : variant.name),
                                stylitics_outfit_id: "".concat(props.currentBundle.id),
                                stylitics_product_id: "".concat(product === null || product === void 0 ? void 0 : product.remote_id)
                            }
                        });
                        if (!variant) return;
                        props.setCurrentItem(product);
                    }
                })
            }, product.item_id);
        })
    });
};
var Product = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var widgetInstance = (0,store/* useWidgetInstanceStore */.fK)().widgetInstance;
    var addToCart = (0,useCart/* useCart */.j)({
        pause: true
    }).addToCart;
    var ref5 = (0,_sliced_to_array/* default */.Z)(props.item.remote_id.split("_"), 2), masterProductId = ref5[0], colorValue = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useProductQuery */.FA3)({
        variables: {
            id: masterProductId
        }
    }), 1), productQuery = ref6[0];
    var masterProduct = (ref = productQuery.data) === null || ref === void 0 ? void 0 : ref.product;
    var variant = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(variation) {
        return variation.colorValue === colorValue;
    });
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), selectedSize = ref7[0], setSelectedSize = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), addingToCart = ref8[0], setAddingToCart = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), addToCartErrorMsg = ref9[0], setAddToCartErrorMsg = ref9[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!productQuery.fetching && ((ref = props.item) === null || ref === void 0 ? void 0 : ref.remote_id)) {
            var ref1;
            // track view item when product is fetched
            widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.trackViewItem((ref1 = props.item) === null || ref1 === void 0 ? void 0 : ref1.remote_id);
        }
    }, [
        productQuery.fetching,
        (ref1 = props.item) === null || ref1 === void 0 ? void 0 : ref1.remote_id,
        widgetInstance
    ]);
    // Skeleton loader
    if (productQuery.fetching) {
        var delay = "100ms";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
            dataTestId: "stylitics-modal-skeleton-loader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        className: "w-full aspect-1-1",
                        delay: delay
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                        direction: "row",
                        gap: "none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                className: "w-full h-14",
                                delay: delay
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                                direction: "column",
                                gap: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                    className: "w-16 h-6",
                                    delay: delay
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            className: "w-full h-32",
                            delay: delay
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        className: "w-full h-10",
                        delay: delay
                    })
                ]
            })
        });
    }
    if (!variant || !masterProduct) return null;
    var productUrl = (0,buildProductUrl/* buildProductUrl */.B)(masterProduct.id, masterProduct.name, {
        swatch: variant.colorValue
    });
    var productName = props.flagHeaderSubHeader ? masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.header : masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name;
    var productNameHeading = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
        dataTestId: "stylitics-modal-product-name",
        size: "sm",
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: productName
                }),
                props.flagHeaderSubHeader && (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.subHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                    "data-test-id": "pdp-product-subheader",
                    className: "w-full mobile:text-md text-lg font-normal text-puma-gray-60 line-clamp-2",
                    children: masterProduct.subHeader
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
        dataTestId: "stylitics-modal-product",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
            gap: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemImages/* ProductListItemImages */.X, {
                    variant: variant,
                    dataTestId: "stylitics-modal-product-images"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: "row",
                    gap: "xs",
                    children: [
                        props.item.remote_id !== props.bundle.primary_remote_id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: productUrl,
                            onClick: function() {
                                (0,referrerParametersUtils/* setReferrerType */.Sl)(constants/* REFERRER_TYPE_VAL.Stylitics */.Ei.Stylitics);
                                var _obj;
                                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (_obj = {
                                    domevent: "Stylitics - Product Detail Click"
                                }, (0,_define_property/* default */.Z)(_obj, analyticTypes/* Dimensions.d27 */.Db.d27, props.bundle.id), (0,_define_property/* default */.Z)(_obj, "stylitics_product", variant.name), (0,_define_property/* default */.Z)(_obj, "stylitics_product_id", props.item.remote_id), _obj));
                                props.closeModal();
                            },
                            className: "hover:underline",
                            children: productNameHeading
                        }) : productNameHeading,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                            direction: "column",
                            gap: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, {
                                price: {
                                    amount: (ref2 = variant.productPrice) === null || ref2 === void 0 ? void 0 : ref2.price,
                                    promotionPrice: (ref3 = variant.productPrice) === null || ref3 === void 0 ? void 0 : ref3.promotionPrice,
                                    salePrice: (ref4 = variant.productPrice) === null || ref4 === void 0 ? void 0 : ref4.salePrice
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* Sizes */.u8, {
                    sizeGroups: variant.sizeGroups,
                    desiredSize: selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id,
                    onChange: function(sizeId) {
                        var sizes = (0,products/* getSizesFromSizeGroups */.hJ)(variant.sizeGroups);
                        var desiredSize = sizes.find(function(size) {
                            return size.id === sizeId;
                        });
                        var _obj;
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (_obj = {
                            domevent: "Stylitics - Size Click",
                            domlabel: desiredSize === null || desiredSize === void 0 ? void 0 : desiredSize.label
                        }, (0,_define_property/* default */.Z)(_obj, analyticTypes/* Dimensions.d27 */.Db.d27, props.bundle.id), (0,_define_property/* default */.Z)(_obj, "stylitics_product", variant.name), (0,_define_property/* default */.Z)(_obj, "stylitics_product_id", props.item.remote_id), _obj));
                        setSelectedSize(desiredSize);
                        setAddToCartErrorMsg(undefined);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                    dataTestId: "stylitics-modal-add-to-cart-error",
                    children: addToCartErrorMsg && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                                variant: "error",
                                content: addToCartErrorMsg
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Spacer */.LZC, {
                                gap: "sm"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                    label: t("addToCart"),
                    disabled: Boolean(productQuery.fetching || variant.displayOutOfStock || !selectedSize),
                    loading: addingToCart,
                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var ref, ref1, result, _tmp, _tmp1, _tmp2, _obj;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setAddingToCart(true);
                                    setAddToCartErrorMsg(undefined);
                                    _tmp = {};
                                    _tmp1 = {};
                                    return [
                                        4,
                                        addToCart((_tmp.swatch = variant.colorValue, _tmp.size = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id, _tmp.quantity = 1, _tmp.productId = (ref1 = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId) !== null && ref1 !== void 0 ? ref1 : "", _tmp.masterId = masterProduct.id, _tmp), (0,_define_property/* default */.Z)(_tmp1, analyticTypes/* Dimensions.d100 */.Db.d100, "stylitics"))
                                    ];
                                case 1:
                                    result = _state.sent();
                                    _tmp2 = {};
                                    widgetInstance === null || widgetInstance === void 0 ? void 0 : widgetInstance.trackAddItemToCart((_tmp2.itemId = masterProduct.id, _tmp2.price = ((ref = variant.productPrice) === null || ref === void 0 ? void 0 : ref.price) || undefined, _tmp2.placement = "widget", _tmp2));
                                    /**
             * This fix is necessary to prevent issues caused by the MiniCart `Modal` appearing on top of the UDS Dialog component.
             * It unsets the `top` value which is set in the `useBodyScrollLook` hook, which is already being set by the UDS Dialog component.
             *
             * TODO: Remove this when the MiniCart Modal is replaced with a UDS Dialog, or MiniCart is removed entirely. */ document.body.style.top = "";
                                    if (!result.error) {
                                        setSelectedSize(undefined);
                                        ;
                                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (_obj = {
                                            domevent: "Stylitics - Add to Cart"
                                        }, (0,_define_property/* default */.Z)(_obj, analyticTypes/* Dimensions.d27 */.Db.d27, props.bundle.id), (0,_define_property/* default */.Z)(_obj, "stylitics_product", variant.name), (0,_define_property/* default */.Z)(_obj, "stylitics_product_id", props.item.remote_id), _obj));
                                    }
                                    // This will set the error message if there is one, or unset it if there isn't
                                    setAddToCartErrorMsg((0,extractError/* extractError */.d)(result));
                                    setAddingToCart(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: "w-full",
                    dataTestId: "stylitics-modal-add-to-cart-button"
                })
            ]
        })
    });
};
var Scroller = function(param) {
    var bundles = param.bundles, currentBundle = param.currentBundle, setCurrentBundle = param.setCurrentBundle;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var previous = function() {
        return setCurrentBundle(bundles[currentBundle.position - 1]);
    };
    var next = function() {
        return setCurrentBundle(bundles[currentBundle.position + 1]);
    };
    var isFirstBundle = currentBundle.position === 0;
    var isLastBundle = currentBundle.position === bundles.length - 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        direction: "row",
        className: "justify-around items-center my-4",
        dataTestId: "stylitics-modal-look-scroller",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-8",
                children: !isFirstBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                    direction: "left",
                    variant: "ghost",
                    onClick: previous,
                    dataTestId: "stylitics-modal-look-scroller-left"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                weight: "bold",
                dataTestId: "stylitics-modal-look-scroller-text",
                children: t("lookXOfY", {
                    x: currentBundle.position + 1,
                    y: bundles.length
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-8",
                children: !isLastBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                    direction: "right",
                    variant: "ghost",
                    onClick: next,
                    dataTestId: "stylitics-modal-look-scroller-right"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./hooks/useStyliticsWidget.ts




var MIN_BUNDLES = 3;
var useStyliticsWidget = function(param) {
    var itemNumber = param.itemNumber, itemName = param.itemName;
    var locale = (0,useSiteConfig/* useSiteConfig */.N)().locale;
    var styliticsOptions = {
        api: {
            item_number: itemNumber,
            min: MIN_BUNDLES,
            max: 18
        },
        customer: {
            locale: locale
        },
        display: {
            disableMnM: false,
            swipeableCarouselArrows: true
        },
        responsive: [
            [
                220,
                {
                    columns: 1
                }
            ],
            [
                655,
                {
                    columns: 2
                }
            ],
            [
                895,
                {
                    columns: 3
                }
            ], 
        ]
    };
    var fireBundleTracking = function(domlabel, outfitID) {
        return (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (0,_define_property/* default */.Z)({
            domevent: "Stylitics - Product Click",
            domlabel: domlabel
        }, analyticTypes/* Dimensions.d27 */.Db.d27, outfitID));
    };
    var fireBundleTrackingStylitics = function(outfitID) {
        return (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PROMOTION_CLICK */._q.PROMOTION_CLICK, {
            ecommerce: {
                promoClick: {
                    promotions: [
                        {
                            id: outfitID,
                            name: "How To Wear It",
                            creative: "stylitics",
                            position: "1",
                            cta: "View Details"
                        }, 
                    ]
                }
            }
        });
    };
    var initShopTheLookElement = function() {
        var shopLookElement = document.createElement("span"); // create shop the look element
        shopLookElement.className = "stylitics-shop-the-look-badge"; // add css class to the element
        var shopLookLabelElement = document.createElement("span"); // create shop the label element
        shopLookLabelElement.className = "stylitics-shop-the-look-label"; // add css class to the label element
        shopLookLabelElement.textContent = "Shop the Look";
        shopLookElement.appendChild(shopLookLabelElement);
        return shopLookElement;
    };
    var createShopTheLookElement = function(bundleElement) {
        return bundleElement.appendChild(initShopTheLookElement());
    };
    var renderShopTheLook = function(bundleElement) {
        var ref;
        return (ref = bundleElement === null || bundleElement === void 0 ? void 0 : bundleElement.querySelector(".stylitics-bundle-badge")) === null || ref === void 0 ? void 0 : ref.appendChild(createShopTheLookElement(bundleElement));
    };
    var bundleTracking = function(param) {
        var element = param.element, trackerFn = param.trackerFn;
        var viewDetailsCta = element.querySelector(".stylitics-view-item-details-cta");
        viewDetailsCta === null || viewDetailsCta === void 0 ? void 0 : viewDetailsCta.addEventListener("click", trackerFn);
        var mainImage = element.querySelector(".stylitics-main-image");
        mainImage === null || mainImage === void 0 ? void 0 : mainImage.addEventListener("click", trackerFn);
    };
    var onBundle = function(param) {
        var element = param.element, bundle = param.bundle;
        var domlabel = "Complete the Look";
        if (bundle["on-model-image"]) {
            renderShopTheLook(element);
            domlabel = "Complete the Look - Shop the Model";
        }
        bundleTracking({
            element: element,
            trackerFn: function() {
                fireBundleTracking(domlabel, bundle.id), fireBundleTrackingStylitics(bundle.id);
            }
        });
    };
    var onBundles = function(data, callback) {
        if (data.bundles && data.bundles.length >= MIN_BUNDLES) {
            var ref;
            //if data.bundles.length is >= 3 then the widget will load, and this code block will run
            //If 2 or fewer outfits are returned then the widget will hide.
            callback(true);
            // show the complete the look button on the pdp
            (ref = document === null || document === void 0 ? void 0 : document.querySelector("#complete-the-look")) === null || ref === void 0 ? void 0 : ref.classList.remove("invisible");
        }
    };
    var onViewBundle = function(data) {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.STYLITICS_INTERACTION */._q.STYLITICS_INTERACTION, (0,_define_property/* default */.Z)({
            domevent: "Stylitics - Outfit Viewed"
        }, analyticTypes/* Dimensions.d27 */.Db.d27, data.bundle.id));
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PROMOTION_VIEW */._q.PROMOTION_VIEW, {
            ecommerce: {
                promoView: {
                    promotions: [
                        {
                            id: data.bundle.id,
                            name: "How To Wear It",
                            creative: "stylitics",
                            position: "1"
                        }, 
                    ]
                }
            }
        });
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics,
            event_params: {
                user_action: analytics/* AnalyticsEvents.GA4_IMPRESSION */._q.GA4_IMPRESSION,
                item_id_ep: itemNumber,
                item_name_ep: itemName,
                stylitics_outfit_id: data.bundle.id,
                stylitics_product_id: data.bundle.primary_stylitics_item_id || undefined
            }
        });
    };
    return {
        options: styliticsOptions,
        onBundle: onBundle,
        onBundles: onBundles,
        onViewBundle: onViewBundle
    };
};

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/components/StyliticsWidget/stylitics-widget-css.ts

function stylitics_widget_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .stylitics-bundle-badge {\n    top: 3%;\n    z-index: 1;\n  }\n\n  & .stylitics-bundle-badge .stylitics-shop-the-look-badge {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 4px 16px;\n\n    background: #a1a8af;\n    border-radius: 2px;\n\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n  }\n\n  &\n    .stylitics-bundle-badge\n    .stylitics-shop-the-look-badge\n    .stylitics-shop-the-look-label {\n    font-family: 'FFDINforPuma';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n\n    color: #ffffff;\n\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n  }\n"
    ]);
    stylitics_widget_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function stylitics_widget_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .stylitics-classic-base {\n    font-family: 'FFDINforPuma' !important;\n  }\n  .stylitics-item-container {\n    padding: 10px 0 !important;\n    border-bottom: 1px solid #dfe0e1 !important;\n  }\n  .stylitics-item-name {\n    font-weight: 700 !important;\n    font-size: 16px;\n  }\n  .stylitics-item-price-and-cta {\n    flex-direction: row !important;\n  }\n  .stylitics-item-regular-price {\n    font-weight: 400 !important;\n    color: gray-100 !important;\n  }\n  .stylitics-view-item-details-cta span {\n    font-size: 14px !important;\n  }\n  .stylitics-view-item-details-cta span,\n  .stylitics-cta-link {\n    width: 81px;\n    height: 16px;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    font-size: 12px !important;\n    line-height: 16px !important;\n    letter-spacing: 0.04rem !important;\n  }\n  .stylitics-view-item-details-cta,\n  .stylitics-cta-link {\n    padding-bottom: 4px !important;\n    border-bottom: #a1a8af solid 2px !important;\n    text-transform: uppercase;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: 16px !important;\n    letter-spacing: 0.04rem !important;\n  }\n  .stylitics-arrow-btn.stylitics-previous {\n    @media (hover: hover) {\n      left: 16px !important;\n    }\n\n    @media (hover: none) {\n      left: 45px !important;\n      opacity: 1 !important;\n    }\n  }\n  .stylitics-arrow-btn.stylitics-next {\n    @media (hover: hover) {\n      right: 32px !important;\n    }\n\n    @media (hover: none) {\n      right: 45px !important;\n      opacity: 1 !important;\n    }\n  }\n  .stylitics-arrow-btn {\n    background-color: #191919 !important;\n    position: absolute;\n  }\n  .stylitics-arrow {\n    path {\n      stroke: #ffffff !important;\n    }​\n  }\n  .stylitics-bundle-container{\n    border: 1px solid #DFE0E1 !important;\n  }\n  .stylitics-view-item-details-cta:hover,\n  .stylitics-cta-link:hover {\n    opacity: 1 !important;\n    color: #000000 !important;\n    border-bottom: #000000 solid 2px !important;\n  }\n\n  .stylitics-sequence.stylitics-sequence-scroll-snap {\n    padding-bottom: 2rem;\n    margin-bottom: 1rem;\n  }\n"
    ]);
    stylitics_widget_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var shopTheLookBadge = (0,css/* css */.iv)(stylitics_widget_css_templateObject());
var widgetOverrides = (0,css/* css */.iv)(stylitics_widget_css_templateObject1());

;// CONCATENATED MODULE: ./ui/content/HowToWearIt.tsx















var WRAPPER_ID = "completeTheLook";
var WIDGET_CONTAINER = "how-to-wear-it-container";
var HowToWearIt = function(param) {
    var overrideOptions = param.overrideOptions, _id = param._id, _type = param._type;
    var ref = (0,react.useState)(false), renderWidgetHeader = ref[0], setRenderWidgetHeader = ref[1];
    var ref1 = (0,react.useState)(), widget = ref1[0], setWidget = ref1[1];
    var ref2 = (0,react.useState)([]), bundles = ref2[0], setBundles = ref2[1];
    var ref3 = (0,react.useState)(), selectedBundle = ref3[0], setSelectedBundle = ref3[1];
    var ref4 = (0,react.useState)(false), showModal = ref4[0], setShowModal = ref4[1];
    var isStyliticsEnabled = (0,useFeature/* useFeature */.S)("OUTFITS_ENABLED");
    var setWidgetInstance = (0,store/* useWidgetInstanceStore */.fK)().setWidgetInstance;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref5 = (0,useSiteConfig/* useSiteConfig */.N)(), styliticsUsername = ref5.env.styliticsUsername;
    var variation = (0,usePdp/* usePdp */.Y)().variation;
    var ref6 = useStyliticsWidget({
        itemNumber: (variation === null || variation === void 0 ? void 0 : variation.styleNumber) || "",
        itemName: (variation === null || variation === void 0 ? void 0 : variation.name) || ""
    }), options = ref6.options, onBundle = ref6.onBundle, onBundles = ref6.onBundles, onViewBundle = ref6.onViewBundle;
    var initWidget = function() {
        // bail if the Stylitics script isn't loaded
        if (!window.StyliticsClassicWidget) return;
        if (!widget) {
            // Stylitics has a problem with instantiating a new instance with the same parameters which
            // could potentially happen here. Remove the `nonce` parameter once this is fixed on their end.
            var widgetOptions = overrideOptions !== null && overrideOptions !== void 0 ? overrideOptions : options;
            widgetOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, widgetOptions), {
                nonce: Math.random().toString(16)
            });
            var widgetInstance = new window.StyliticsClassicWidget(styliticsUsername, WIDGET_CONTAINER, widgetOptions);
            // save the widget instance to later use in the stylitics modal to track clicks/views
            setWidgetInstance(widgetInstance);
            widgetInstance.override("click", "bundle", function(data) {
                var ref, ref1, ref2, ref3;
                setSelectedBundle(data.bundle);
                setShowModal(true);
                var firstItemBundle = ((ref = data.bundle) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
                var itemID = firstItemBundle === null || firstItemBundle === void 0 ? void 0 : firstItemBundle.remote_id;
                var itemName = firstItemBundle === null || firstItemBundle === void 0 ? void 0 : firstItemBundle.name;
                // Triggers the first GA4 event for a product in the Modal Carousel when the user clicks on the Stylitics Carousel within the PDP
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics,
                    event_params: {
                        user_action: "".concat(analytics/* AnalyticsEvents.GA4_PRODUCT_CLICK */._q.GA4_PRODUCT_CLICK),
                        item_id_ep: "".concat(itemID),
                        item_name_ep: "".concat(itemName),
                        stylitics_outfit_id: "".concat((ref2 = data.bundle) === null || ref2 === void 0 ? void 0 : ref2.primary_stylitics_item_id),
                        stylitics_product_id: "".concat((ref3 = data.bundle) === null || ref3 === void 0 ? void 0 : ref3.primary_remote_id)
                    }
                });
            });
            widgetInstance.on("mount", "bundle", onBundle);
            widgetInstance.on("mount", "bundles", function(data) {
                setBundles(data.bundles);
                onBundles(data, setRenderWidgetHeader);
            });
            widgetInstance.on("view", "bundle", onViewBundle);
            widgetInstance.start();
            setWidget(widgetInstance);
        }
    };
    (0,react.useEffect)(function() {
        if (widget && variation) {
            widget.refresh({
                api: {
                    item_number: variation === null || variation === void 0 ? void 0 : variation.styleNumber
                }
            });
        }
    }, [
        variation,
        widget
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://web-assets.stylitics.com/v3-classic/latest/classic.release.js",
                onReady: initWidget,
                strategy: "lazyOnload"
            }),
            isStyliticsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "complete-the-look-carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-label": t(WRAPPER_ID),
                    children: [
                        renderWidgetHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            id: WRAPPER_ID,
                            className: "font-bold text-xl sm:text-2xl pb-4 text-uppercase",
                            children: t(WRAPPER_ID)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (0,css.tw)("relative w-full", widgetOverrides, shopTheLookBadge),
                            id: WIDGET_CONTAINER
                        })
                    ]
                })
            }),
            selectedBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyliticsModal, {
                bundles: bundles,
                selectedBundle: selectedBundle,
                setSelectedBundle: setSelectedBundle,
                open: showModal,
                onOpenChange: setShowModal
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/content/FaqModule.tsx + 1 modules
var FaqModule = __webpack_require__(62079);
;// CONCATENATED MODULE: ./ui/content/WebCarousel.tsx

function WebCarousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      [id*='WebCarousel-'] [data-test-id='full-bleed-hero-container'] {\n        @apply m-0 left-0 right-0 top-0 w-full h-full flex;\n      }\n      [id*='WebCarousel-'] {\n        @apply flex h-full overflow-y-hidden;\n      }\n      [id*='WebCarousel-'] [data-link-loc='banner'],\n      [id*='WebCarousel-'] > div:first-child,\n      [id*='WebCarousel-'][tag='section'] {\n        @apply flex-1;\n      }\n    "
    ]);
    WebCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var WebCarousel = function(param) {
    var content = param.content;
    var ref = (0,useHorizontalScroll/* useHorizontalScroll */.m)({
        infinite: false
    }), ref1 = ref.ref, hasPrev = ref.hasPrev, hasNext = ref.hasNext, next = ref.next, prev = ref.prev;
    (0,react.useEffect)(function() {
        if (content === null || content === void 0 ? void 0 : content.length) {
            ref1.current.dispatchEvent(new Event("scroll"));
        }
    }, [
        content,
        ref1
    ]);
    if (!(content === null || content === void 0 ? void 0 : content.length)) {
        return null;
    }
    var isDesktop = (0,media/* getIsDesktop */.w)();
    var gridClasses = (0,style.tw)([
        "grid overflow-x-auto pb-8 mb-4 mobile:pb-4",
        (0,style/* css */.iv)({
            scrollSnapType: "x mandatory",
            gridTemplateColumns: "repeat(".concat(content.length, ", 100%)")
        }),
        (0,style/* css */.iv)(WebCarousel_templateObject()), 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "group relative w-full",
        "data-test-id": "web-carousel-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                "data-test-id": "web-carousel",
                className: gridClasses,
                children: content === null || content === void 0 ? void 0 : content.map(function(item, index) {
                    var componentData = {
                        component: item,
                        targetDevices: [
                            "mobile",
                            "tablet",
                            "desktop"
                        ]
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,style.tw)((0,style/* css */.iv)({
                            scrollSnapAlign: "start"
                        })),
                        children: getComponentForContent(componentData, index, content, "WebCarousel", {})
                    }, index);
                })
            }),
            hasPrev && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                className: "invisible group-hover:visible mobile:hidden tablet:hidden absolute -left-2 top-1/2 transform -translate-y-1/2",
                direction: "left",
                onClick: prev,
                invert: true
            }),
            hasNext && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronButton/* default */.Z, {
                className: "invisible group-hover:visible mobile:hidden tablet:hidden absolute -right-2 top-1/2 transform -translate-y-1/2",
                direction: "right",
                onClick: next,
                invert: true
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/content/Missing.tsx
var Missing = __webpack_require__(64236);
;// CONCATENATED MODULE: ./utils/getComponentForContent.tsx



































var FallbackPlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "min-h-[50vh]"
    });
};
var components = [
    {
        name: "AdditionalContentSection",
        component: AdditionalContentSection,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "AutomatedProductComparison",
        component: AutomatedProductComparison,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "BodyContent",
        component: BodyContent,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "BodyHeader",
        component: BodyHeader,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "FeatureHero",
        component: FeatureHero,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "FeaturesGrid",
        component: FeaturesGrid,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "FullBleedHero",
        component: FullBleedHero,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "Iframe",
        component: Iframe,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "InfoBanner",
        component: InfoBanner/* InfoBanner */.X
    },
    {
        name: "PixleeSimpleWidget",
        component: PixleeSimpleWidget,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "ProductCarousel",
        component: ProductCarousel/* ProductCarousel */.GM,
        clsPlaceholder: ProductCarouselSkeleton
    },
    {
        name: "ProductComparison",
        component: ProductComparison,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "ProductGroupFeatures",
        component: ProductGroupFeatures,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "ProductRecommender",
        component: ProductRecommender/* ProductRecommender */.S,
        // load component as fallback to ensure this conditionally displayed and very
        // slow loading component achieves desired state before user scrolls. CLS
        // from this component after scrolling is high and a terrible UX. We need to
        // get it rendered asap.
        clsPlaceholder: ProductRecommender/* ProductRecommender */.S
    },
    {
        name: "LaunchCalendar",
        component: LaunchCalendar,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "QuoteCallout",
        component: QuoteCallout,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "Quilt",
        component: Quilt,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "SideBySide",
        component: SideBySide,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "SignUpForm",
        component: SignUpHeroBanner,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "SplitHero",
        component: SplitHero,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "StyliticsCarousel",
        component: StyliticsCarousel,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "HowToWearIt",
        component: HowToWearIt,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "TrendingInline",
        component: TrendingInline
    },
    {
        name: "VideoHero",
        component: VideoHero,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "YouTubeVideoCarousel",
        component: YouTubeVideoCarousel,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "FaqModule",
        component: FaqModule/* FaqModule */.S,
        clsPlaceholder: FallbackPlaceholder
    },
    {
        name: "WebCarousel",
        component: WebCarousel,
        clsPlaceholder: FallbackPlaceholder
    }, 
];
var ref;
var getComponent = function(typename) {
    return (ref = components.find(function(param) {
        var name = param.name;
        return name === typename;
    })) !== null && ref !== void 0 ? ref : {
        name: "Missing",
        component: Missing/* Missing */.J,
        clsPlaceholder: FallbackPlaceholder
    };
};
var InView = function(param) {
    var i = param.i, data = param.data, slotId = param.slotId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useInView/* useInView */.Y)(), 2), ref1 = ref[0], inView = ref[1];
    var isPriority = i <= 1 && (slotId === "slots" || slotId === "topContent");
    var ref2 = getComponent(data.__typename || data._type), Component = ref2.component, ClsPlaceholder = ref2.clsPlaceholder;
    var renderImmediately = i <= 4; // Immediately load first 5 slots' content to avoid CLS issues.
    var renderMainComponent = renderImmediately || inView || !ClsPlaceholder;
    // if the component is "high on the page" OR has come into view due to user
    // interaction OR there is no skeleton provided for the component, then
    // render the main component
    if (renderMainComponent) {
        // Note that the component may still render a skeleton if it performs data fetching
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
            priority: isPriority,
            deferred: !renderImmediately
        }, data));
    }
    // Otherwise render the provided skeleton, which should be CLS performant
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClsPlaceholder, (0,_object_spread/* default */.Z)({}, data))
    });
};
var MemoizedInView = /*#__PURE__*/ (0,react.memo)(InView, function(oldProps, newProps) {
    return oldProps.i === newProps.i || oldProps.data.id === newProps.data.id;
});
var getComponentForContent = function(data, i, items, slotId, headersObject) {
    var ref, ref1, ref2;
    if (!(data === null || data === void 0 ? void 0 : data.component)) return null;
    var component = data.component;
    var campaign = (ref = items[i]) === null || ref === void 0 ? void 0 : ref.campaign;
    if (campaign) {
        var ref3, ref4;
        component.campaignId = ((ref3 = campaign[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.puid) === null || ref4 === void 0 ? void 0 : ref4.current) || "";
    }
    var responsiveClasses = (ref1 = data.targetDevices) === null || ref1 === void 0 ? void 0 : ref1.map(function(device) {
        var classes = "".concat(device, ":block");
        return classes;
    });
    var id = component.id || component._id;
    var type = component.__typename || component._type;
    component._type === "FeaturesGrid" ? component.featureRows.forEach(function(featureRow) {
        return featureRow["headingTag"] = headersObject[featureRow["_key"]];
    }) : component.headingTag = headersObject[(ref2 = items[i]) === null || ref2 === void 0 ? void 0 : ref2.id];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: slotId && "".concat(slotId, "-").concat(i),
        "data-id": id,
        "data-type": type,
        className: (0,twind.tw)("hidden empty:hidden", responsiveClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedInView, {
            i: i,
            data: component,
            slotId: slotId
        })
    }, "".concat(id, "_").concat(i));
};

;// CONCATENATED MODULE: ./utils/mapSanityHeadingsToObject.ts
var headerKeys = [
    "h1Heading",
    "h2Headings",
    "h3Headings",
    "h4", 
];
var PRIMARY_HEADINGS = "h1, h2, h3";
var WHITELIST_COMPONENTS = [
    "FeaturesGrid",
    "FeaturesGridRow",
    "FullBleedHero",
    "BodyContent",
    "FeatureHero",
    "Header",
    "SplitHero",
    "SignupForm",
    "VideoHero",
    "ProductCarousel",
    "QuoteCallout", 
];
/**
 * Returns an object such as { "componentKey": "headingTag" } to simplify the handling of component headings.
 * @param {HeadersContent | undefined} headers - Object containing headings configured from Sanity.
 * @param {any} items - Components rendered in current page.
 * @returns {Record<GqlComponentWithFilters['id'], ManageHeadingTag>} An object mapping headings (h1, h2, h3, h4) to component keys.
 */ var mapSanityHeadingsToObject = function(headers, items) {
    var headerObj = {};
    var addHeading = function(heading, componentKey, componentRowKey) {
        return headerObj[componentRowKey || componentKey] = heading;
    };
    // only allow to add one if don't found in headers object from sanity
    var alreadySetOnce = {
        h1: false,
        h2: false,
        h3: false
    };
    headerKeys.forEach(function(objectKey) {
        var objectKeyHTag = objectKey.replace("Heading", "").replace("s", "");
        var currentHeader = headers === null || headers === void 0 ? void 0 : headers[objectKey];
        var currentHeaderIsArray = Array.isArray(currentHeader);
        if (!currentHeaderIsArray && currentHeader || currentHeaderIsArray && currentHeader.length) {
            if (!currentHeaderIsArray) {
                var ref = headers === null || headers === void 0 ? void 0 : headers[objectKey], componentKey = ref.componentKey, componentRowKey = ref.componentRowKey, header = ref.header;
                if (header) {
                    addHeading(objectKeyHTag, componentKey, componentRowKey);
                }
            } else {
                currentHeader.forEach(function(param) {
                    var componentKey = param.componentKey, componentRowKey = param.componentRowKey, header = param.header;
                    if (header) {
                        addHeading(objectKeyHTag, componentKey, componentRowKey);
                    }
                });
            }
        } else {
            items.forEach(function(param) {
                var component = param.component, id = param.id;
                //TODO: check why component is coming null
                if (!alreadySetOnce[objectKeyHTag] && WHITELIST_COMPONENTS.some(function(type) {
                    return type === (component === null || component === void 0 ? void 0 : component._type);
                })) {
                    var componentKey = (component === null || component === void 0 ? void 0 : component._type) === "FeaturesGrid" ? component.featureRows[0]._key : id;
                    if (!headerObj[componentKey] && (component === null || component === void 0 ? void 0 : component.header)) {
                        addHeading(objectKeyHTag, componentKey);
                        if (PRIMARY_HEADINGS.includes(objectKeyHTag)) {
                            alreadySetOnce[objectKeyHTag] = true;
                        }
                    }
                }
            });
        }
    });
    return headerObj;
};

;// CONCATENATED MODULE: ./ui/components/SanityContentSlot.tsx


function SanityContentSlot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            & > *:first-child {\n              [data-bleed='true'] {\n                @apply mobile:-mt-6 tablet:-mt-8 desktop:-mt-10;\n              }\n            }\n            & > *:last-child {\n              [data-bleed='true'] {\n                @apply mobile:-mb-6 tablet:-mb-8 desktop:-mb-10;\n              }\n            }\n          "
    ]);
    SanityContentSlot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SanityContentSlot_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          & > [data-type='FullBleedHero'] + [data-type='FullBleedHero'] {\n            @apply mobile:-mt-6 tablet:-mt-8 desktop:-mt-10;\n          }\n        "
    ]);
    SanityContentSlot_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var SanityContentSlot = function(props) {
    if (!props.items || props.items.length === 0) return null;
    var headersObject = mapSanityHeadingsToObject(props.headersContent, props.items);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-test-id": "sanity-content-slot",
        className: (0,css.tw)("flex flex-col gap-6 md:gap-8 lg:gap-10", props.fullscreen && (0,css/* css */.iv)(SanityContentSlot_templateObject()), (0,css/* css */.iv)(SanityContentSlot_templateObject1()), props.className),
        "data-document": props.documentId,
        children: props.items.map(function() {
            for(var _len = arguments.length, item = new Array(_len), _key = 0; _key < _len; _key++){
                item[_key] = arguments[_key];
            }
            return getComponentForContent.apply(void 0, (0,_to_consumable_array/* default */.Z)(item).concat([
                props.slotId,
                headersObject
            ]));
        })
    });
};


/***/ }),

/***/ 12450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StockMessageSFCC; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79200);
/* harmony import */ var ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66224);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);








var StockMessageSFCC = function(param) {
    var quantity = param.quantity, selectedSize = param.selectedSize, addToCartReturnCode = param.addToCartReturnCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        outOfStock: false,
        lowStock: false
    }), initialInventoryMessage = ref[0], setInitialInventoryMessage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), cartReturnCode = ref1[0], setCartReturnCode = ref1[1];
    var ref2 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)(), pdpLowInventoryThreshold = ref2.pdpLowInventoryThreshold, useStockInfoRedesign = ref2.staticFeatures.useStockInfoRedesign;
    var lowThresholdValue = pdpLowInventoryThreshold ? pdpLowInventoryThreshold : 10;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!useStockInfoRedesign) {
            setCartReturnCode(undefined);
            var message;
            switch(addToCartReturnCode){
                case "IN_STOCK":
                    message = t("cartStockMessageInStock");
                    break;
                case "LIMITED_STOCK":
                    message = t("cartStockMessageLimitedStock");
                    break;
                case "NOT_AVAILABLE":
                    message = t("cartStockMessageOutOfStock");
                    break;
                default:
                    message = addToCartReturnCode ? t("cartStockMessageNotDefined") : t("cartStockMessageInStock");
            }
            setCartReturnCode(message !== null && message !== void 0 ? message : "");
        }
    }, [
        addToCartReturnCode
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInitialInventoryMessage({
            outOfStock: false,
            lowStock: false
        });
        if (selectedSize && quantity) {
            setInitialInventoryMessage({
                outOfStock: quantity <= 0,
                lowStock: quantity <= lowThresholdValue
            });
        }
    }, [
        quantity,
        selectedSize,
        lowThresholdValue
    ]);
    var alertMessageProps = useStockInfoRedesign ? {
        icon: "clock-outline",
        type: "plaininfo"
    } : {
        icon: "exclamation-outline",
        type: "warning"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !useStockInfoRedesign && cartReturnCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    t("stockStatus"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)(addToCartReturnCode === "LIMITED_STOCK" ? "text-puma-red" : ""),
                        children: cartReturnCode
                    })
                ]
            }),
            initialInventoryMessage.lowStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__/* .AlertMessage */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, alertMessageProps), {
                children: t("lowStock")
            })),
            initialInventoryMessage.outOfStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__/* .AlertMessage */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, alertMessageProps), {
                children: [
                    t("stockStatus"),
                    " ",
                    t("outOfStock")
                ]
            }))
        ]
    });
};


/***/ }),

/***/ 38913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$7": function() { return /* reexport */ SizeGuide; },
  "u8": function() { return /* reexport */ Sizes; },
  "ik": function() { return /* reexport */ TileSizes; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/components/Skeleton.tsx
var Skeleton = __webpack_require__(98463);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./ui/components/Sizes/StockMessageSFCC.tsx
var StockMessageSFCC = __webpack_require__(12450);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./ui/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(91622);
// EXTERNAL MODULE: ./ui/elements/SafeHtml.tsx
var SafeHtml = __webpack_require__(99671);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
;// CONCATENATED MODULE: ./ui/components/Sizes/shared.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1 {\n    @apply pt-2 lg:pt-6;\n  }\n  h2 {\n    @apply my-6;\n  }\n  table {\n    @apply text-center w-full;\n  }\n  thead {\n    @apply text-lg border-b;\n  }\n  thead th {\n    @apply p-3 border;\n  }\n  thead th:first-child {\n    @apply pl-3;\n  }\n  tbody td {\n    @apply p-3 border font-normal;\n  }\n  tbody td:first-child {\n    @apply font-bold pl-3;\n  }\n  tbody td:last-child,\n  thead th:last-child {\n    @apply pr-3;\n  }\n  .measurements {\n    @apply text-left;\n  }\n  .measurements__image {\n    @apply sm:w-1/3;\n  }\n  .measurements__image > img {\n    @apply w-full mx-auto;\n  }\n  .measurements__text {\n    @apply sm:w-1/2;\n  }\n  .left {\n    @apply text-left;\n  }\n  .center {\n    @apply text-center;\n  }\n  hr,\n  p {\n    @apply my-0!;\n  }\n  details summary strong {\n    @apply cursor-pointer;\n  }\n  details {\n    @apply overflow-x-auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var sizeGuideStyles = (0,style/* css */.iv)(_templateObject());
var TileSizes;
(function(TileSizes) {
    TileSizes["SMALL"] = "SMALL";
    TileSizes["MEDIUM"] = "MEDIUM";
    TileSizes["LARGE"] = "LARGE";
})(TileSizes || (TileSizes = {}));

;// CONCATENATED MODULE: ./ui/components/Sizes/SizeTable.tsx




var getMeasurementMessages = function(messages, id, className) {
    return messages.map(function(message) {
        return message.id === id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
            html: message.body,
            className: (0,style.tw)("".concat(className))
        }, message.id) : null;
    });
};
var SizeTable = function(param) {
    var title = param.title, description = param.description, data = param.data, _hidden = param.hidden, hidden = _hidden === void 0 ? false : _hidden, children = param.children, measurementMessages = param.measurementMessages, showMetricAsDefault = param.showMetricAsDefault;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.tw)([
            sizeGuideStyles,
            hidden && "hidden"
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.tw)([
                    "flex items-center",
                    showMetricAsDefault && "pb-4 pt-4"
                ]),
                children: [
                    !showMetricAsDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: title
                    }),
                    children
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-x-auto",
                children: [
                    measurementMessages && getMeasurementMessages(measurementMessages, "body-measurement-message-top", "text-left mb-6"),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: data[0].map(function(header) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: header
                                        }, header);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: data.slice(1).map(function(values, index) {
                                    return(// This array won't be changing so using index as the key is safe!
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: values.map(function(value, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: value
                                            }, index);
                                        })
                                    }, index));
                                })
                            })
                        ]
                    }),
                    measurementMessages && getMeasurementMessages(measurementMessages, "body-measurement-message-bottom", "text-left mt-6")
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/ProductMeasurementsTable.tsx





var ProductMeasurementsTable = function(param) {
    var productMeasurements = param.productMeasurements, measurementMessages = param.measurementMessages, productDivision = param.productDivision;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showMetricAsDefault = (0,useFeature/* useFeature */.S)("SHOW_METRIC_AS_DEFAULT");
    var hideWeightInProductMeasurements = (0,useFeature/* useFeature */.S)("HIDE_WEIGHT_IN_PRODUCT_MEASUREMENTS");
    var ref = (0,react.useState)(showMetricAsDefault !== null && showMetricAsDefault !== void 0 ? showMetricAsDefault : false), metric = ref[0], setMetric = ref[1];
    var measurementMessagesAsDefault = showMetricAsDefault && measurementMessages;
    var unitSwitcher = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "uppercase text-xs font-bold cursor-pointer ml-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "pr-4 ".concat(metric ? "text-puma-black-400" : ""),
                onClick: function() {
                    return setMetric(false);
                },
                children: t("inches")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(!metric ? "text-puma-black-400" : ""),
                onClick: function() {
                    return setMetric(true);
                },
                children: t("cm")
            })
        ]
    });
    var metricMeasurements = productMeasurements === null || productMeasurements === void 0 ? void 0 : productMeasurements.metric;
    var imperialMeasurements = productMeasurements === null || productMeasurements === void 0 ? void 0 : productMeasurements.imperial;
    //Hide Weight column for India on Footwear
    if (hideWeightInProductMeasurements && productDivision === "Footwear") {
        metricMeasurements = metricMeasurements === null || metricMeasurements === void 0 ? void 0 : metricMeasurements.map(function(subArray) {
            return subArray.filter(function(_, index) {
                var ref;
                return (productMeasurements === null || productMeasurements === void 0 ? void 0 : (ref = productMeasurements.metric) === null || ref === void 0 ? void 0 : ref[0][index]) !== "Weight";
            });
        });
        imperialMeasurements = imperialMeasurements === null || imperialMeasurements === void 0 ? void 0 : imperialMeasurements.map(function(subArray) {
            return subArray.filter(function(_, index) {
                var ref;
                return (productMeasurements === null || productMeasurements === void 0 ? void 0 : (ref = productMeasurements.imperial) === null || ref === void 0 ? void 0 : ref[0][index]) !== "Weight";
            });
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeTable, {
                title: t("productMeasurements"),
                data: metricMeasurements,
                hidden: !metric,
                measurementMessages: measurementMessagesAsDefault || [],
                showMetricAsDefault: showMetricAsDefault,
                children: unitSwitcher
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeTable, {
                title: t("productMeasurements"),
                data: imperialMeasurements,
                hidden: metric,
                measurementMessages: measurementMessagesAsDefault || [],
                showMetricAsDefault: showMetricAsDefault,
                children: unitSwitcher
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/SizeGuide.tsx














var SizeGuide = function(param) {
    var sizeChartId = param.sizeChartId, categoryId = param.categoryId, productMeasurements = param.productMeasurements, onClickOutside = param.onClickOutside, productDivision = param.productDivision;
    var ref, ref1;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), _staticFeatures = ref2.staticFeatures, useProductSizeChart = _staticFeatures.useProductSizeChart, useDefaultJapanChart = _staticFeatures.useDefaultJapanChart;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCategorySizeChartQuery */.gCD)({
        variables: {
            id: categoryId
        },
        pause: !categoryId
    }), 1), categorySizeChartQuery = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useProductSizeChartQuery */.Xue)({
        variables: {
            id: sizeChartId
        },
        pause: !sizeChartId
    }), 1), productSizeChartQuery = ref4[0];
    var sizeCharts = useProductSizeChart && sizeChartId ? (ref = productSizeChartQuery.data) === null || ref === void 0 ? void 0 : ref.sizeCharts : (ref1 = categorySizeChartQuery.data) === null || ref1 === void 0 ? void 0 : ref1.categoryById.sizeCharts;
    var bodyMeasurementIds = [
        "body-measurement-message-top",
        "body-measurement-message-bottom", 
    ];
    var japanChartExclusions = [
        "size-chart-global-template-copied", 
    ].concat((0,_to_consumable_array/* default */.Z)(bodyMeasurementIds));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        variant: "dark",
        className: "w-full max-w-5xl p-0 lg:p-4",
        onClickOutside: onClickOutside,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-test-id": "size-guide-modal",
            className: "p-6",
            children: categorySizeChartQuery.fetching || productSizeChartQuery.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* LoadingSpinner */.T, {
                className: "w-40 h-40 my-40 mx-auto"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "prose-sm md:(prose max-w-full) lg:prose-lg overflow-x-scroll hide-scrollbar",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center border-b pb-3 justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "uppercase text-sm font-bold tracking-wider text-puma-black",
                                children: t("sizeGuide")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                size: "sm",
                                "data-test-id": "close-btn",
                                onClick: onClickOutside
                            })
                        ]
                    }),
                    sizeCharts === null || sizeCharts === void 0 ? void 0 : sizeCharts.map(function(sizeChart) {
                        var exclusions = useDefaultJapanChart ? japanChartExclusions : bodyMeasurementIds;
                        if (!exclusions.includes(sizeChart.id)) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
                                html: sizeChart.body,
                                className: (0,style.tw)(sizeGuideStyles)
                            }, sizeChart.id);
                        }
                    }),
                    productMeasurements && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMeasurementsTable, {
                        measurementMessages: sizeCharts || [],
                        productMeasurements: productMeasurements,
                        productDivision: productDivision
                    }),
                    !sizeCharts && !productMeasurements && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-test-id": "size-guide-no-sizing-data-found",
                        className: "font-bold text-xl",
                        children: "No sizing data found"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/SizeOption.tsx



var SizeOption = function(props) {
    var size = props.size, selected = props.selected, onChange = props.onChange;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        "data-disabled": !size.orderable,
        "data-size": size.id,
        className: (0,style.tw)("relative border flex items-center justify-center flex-none rounded-sm cursor-pointer", selected && "bg-puma-black text-white border-puma-black", !size.orderable && "bg-puma-black-700 text-puma-black-300 border-puma-black-500"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "radio",
                name: "size",
                "data-test-id": "size",
                checked: selected,
                disabled: !size.orderable,
                className: "absolute block appearance-none w-full h-full inset-0 cursor-pointer",
                tabIndex: size.orderable ? 0 : -1,
                onChange: function() {
                    return onChange && onChange(size.id);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                "aria-hidden": "true",
                viewBox: "0 0 1 1",
                className: "w-full opacity-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "absolute inset-0 flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: t("size")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "data-content": "size-value",
                        className: "text-sm",
                        children: size.label
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/SizeOptions.tsx



var SizeOptions = function(param) {
    var sizes = param.sizes, layoutStyle = param.layoutStyle, desiredSize = param.desiredSize, showOnlyOrderableSizes = param.showOnlyOrderableSizes, onChange = param.onChange;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var visibleSizes = showOnlyOrderableSizes ? sizes.filter(function(size) {
        return size.orderable;
    }) : sizes;
    // sort sizes by ID to determine display order;
    // OCAPI returns the array in non-sized order in some cases
    var sortedSizes = visibleSizes.sort(function(a, b) {
        return parseInt(a.id) - parseInt(b.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "size-picker",
        "data-test-id": "size-picker",
        role: "radiogroup",
        "aria-label": t("selectSize"),
        className: "grid gap-1",
        style: layoutStyle,
        children: sortedSizes.map(function(size) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeOption, {
                size: size,
                selected: size.id === desiredSize && size.orderable,
                onChange: onChange
            }, size.id);
        })
    });
};

// EXTERNAL MODULE: ./hooks/usePdp.tsx + 1 modules
var usePdp = __webpack_require__(41316);
// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
;// CONCATENATED MODULE: ./ui/components/Sizes/SizeGroupOptions.tsx



var SizeGroupOptions = function(param) {
    var names = param.names, selectedName = param.selectedName, onChange = param.onChange;
    var t = (0,useTranslations/* useTranslate */.qM)();
    // it isn't important what the ID is, just that it can be used to uniquely identify
    // the aria-describedby element for the group
    var id = "size-group-".concat(Date.now());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "group",
        "aria-describedby": id,
        "data-test-id": "size-group-options",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                id: id,
                className: "sr-only",
                children: t("selectSizeGroup")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "radiogroup",
                className: "flex flex-row gap-1",
                children: names.map(function(name) {
                    if (!name) return;
                    var idSafeName = name.replace(/\s/g, "-").toLowerCase();
                    var isSelected = name === selectedName;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        "data-size-group": idSafeName,
                        className: (0,twind.tw)("relative border flex items-center justify-center flex-none rounded-sm cursor-pointer", isSelected && "bg-puma-black text-white border-puma-black"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                name: "size-group",
                                "data-test-id": "size-group",
                                checked: isSelected,
                                className: "absolute block appearance-none inset-0 cursor-pointer",
                                onChange: function() {
                                    return onChange(name);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inset-0 flex items-center justify-center h-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "data-content": "size-group-name",
                                    className: "text-sm px-4 text-uppercase font-bold",
                                    children: name
                                })
                            })
                        ]
                    }, name);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/SizeGroups.tsx










var SizeGroups = function(param) {
    var sizeGroups = param.sizeGroups, layoutStyle = param.layoutStyle, desiredSize = param.desiredSize, showOnlyOrderableSizes = param.showOnlyOrderableSizes, onChange = param.onChange;
    var ref;
    var referrerCategoryId = ((0,usePdp/* usePdp */.Y)() || {}).referrerCategoryId;
    var variableId = referrerCategoryId || "";
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCategoryByIdQuery */.Z$c)({
        variables: {
            id: variableId
        },
        pause: !variableId || isServer
    }), 1), categoryByIdQuery = ref1[0];
    var categoryById = (ref = categoryByIdQuery.data) === null || ref === void 0 ? void 0 : ref.categoryById;
    var path = (0,constructCategoryPath/* constructCategoryPath */.h)(categoryById);
    var groupContainingDesiredSize = (0,react.useMemo)(function() {
        var ref;
        return path && path.length > 0 && path[0].label === "Women" ? sizeGroups[1] : (ref = sizeGroups.find(function(group) {
            return group.sizes.some(function(size) {
                return size.value === desiredSize;
            });
        })) !== null && ref !== void 0 ? ref : sizeGroups[0];
    }, [
        sizeGroups,
        desiredSize,
        path
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setSelectedGroupName((ref = groupContainingDesiredSize === null || groupContainingDesiredSize === void 0 ? void 0 : groupContainingDesiredSize.label) !== null && ref !== void 0 ? ref : "");
    }, [
        groupContainingDesiredSize
    ]);
    var ref2;
    var ref3 = (0,react.useState)((ref2 = groupContainingDesiredSize === null || groupContainingDesiredSize === void 0 ? void 0 : groupContainingDesiredSize.label) !== null && ref2 !== void 0 ? ref2 : ""), selectedGroupName = ref3[0], setSelectedGroupName = ref3[1];
    var ref4;
    var selectedGroup = (ref4 = sizeGroups.find(function(x) {
        return x.label === selectedGroupName;
    })) !== null && ref4 !== void 0 ? ref4 : sizeGroups[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeGroupOptions, {
                        names: sizeGroups.map(function(x) {
                            return x.label;
                        }),
                        selectedName: selectedGroupName,
                        onChange: setSelectedGroupName
                    }),
                    selectedGroup.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                        size: "sm",
                        color: "muted",
                        className: "block pt-3",
                        children: selectedGroup.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeOptions, {
                sizes: selectedGroup.sizes,
                layoutStyle: layoutStyle,
                desiredSize: desiredSize,
                showOnlyOrderableSizes: showOnlyOrderableSizes,
                onChange: onChange
            }, selectedGroup.label)
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/Sizes.tsx





















var _obj;
var columnSizes = (_obj = {}, (0,_define_property/* default */.Z)(_obj, TileSizes.SMALL, "3rem"), (0,_define_property/* default */.Z)(_obj, TileSizes.MEDIUM, "3.6rem"), (0,_define_property/* default */.Z)(_obj, TileSizes.LARGE, "4.6rem"), _obj);
var Sizes = function(param) {
    var addToCartReturnCode = param.addToCartReturnCode, categoryId = param.categoryId, desiredSize = param.desiredSize, inventory = param.inventory, onChange = param.onChange, productMeasurements = param.productMeasurements, sizeGroups = param.sizeGroups, stale = param.stale, _isModalSizeOpen = param.isModalSizeOpen, isModalSizeOpen = _isModalSizeOpen === void 0 ? false : _isModalSizeOpen, sizeChartId = param.sizeChartId, _tileSize = param.tileSize, tileSize = _tileSize === void 0 ? TileSizes.MEDIUM : _tileSize, productInformation = param.productInformation, productDivision = param.productDivision;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,react.useState)(false), showSizeGuide = ref[0], setShowSizeGuide = ref[1];
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), useStockInfoRedesign = ref1.staticFeatures.useStockInfoRedesign;
    var showOnlyOrderableSizes = (0,useFeature/* useFeature */.S)("SHOW_ONLY_ORDERABLE_SIZES");
    var showStockMessageBySFCCLogic = (0,useFeature/* useFeature */.S)("PDP_SHOW_DETAILED_STOCK_MESSAGES");
    var enableStockMessage = (0,useFeature/* useFeature */.S)("PDP_ENABLE_STOCK_MESSAGE");
    var sizes = (0,products/* getSizesFromSizeGroups */.hJ)(sizeGroups);
    var selectedSize = desiredSize ? sizes === null || sizes === void 0 ? void 0 : sizes.find(function(x) {
        return x.id === desiredSize;
    }) : undefined;
    var sizePickerStyle = {
        gridTemplateColumns: "repeat(auto-fill, minmax(".concat(columnSizes[tileSize], ", 1fr))")
    };
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var triggerEvent = function() {
        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.GA4EC_Sizechart */._q.GA4EC_Sizechart,
            event_params: {
                item_id_ep: productInformation === null || productInformation === void 0 ? void 0 : productInformation.id,
                item_name_ep: productInformation === null || productInformation === void 0 ? void 0 : productInformation.name
            }
        });
    };
    // Show loading skeleton if we don't have sizes yet
    if (!sizeGroups || !(sizes === null || sizes === void 0 ? void 0 : sizes.length) && stale) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Loading product sizes"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid gap-1",
                    style: sizePickerStyle,
                    children: (0,_to_consumable_array/* default */.Z)(Array(15)).map(function(_, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            className: (0,css.tw)("w-full aspect-1-1"),
                            delay: "".concat(!sizeGroups ? 999999 : (i + 1) * 100, "ms")
                        }, i);
                    })
                })
            ]
        });
    }
    if (!sizes) return null;
    // Only show size group options if we have some size groups with labels.
    // In cases where there are no size grouping, we still get a nominal size
    // group with no label, and we don't want to display a button in that case
    var displaySizeGroupOptions = (sizeGroups === null || sizeGroups === void 0 ? void 0 : sizeGroups.filter(function(x) {
        return !!x.label;
    }).length) > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4 relative",
        children: [
            displaySizeGroupOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeGroups, {
                sizeGroups: sizeGroups,
                layoutStyle: sizePickerStyle,
                showOnlyOrderableSizes: showOnlyOrderableSizes,
                desiredSize: desiredSize,
                onChange: onChange
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeOptions, {
                sizes: sizes,
                layoutStyle: sizePickerStyle,
                showOnlyOrderableSizes: showOnlyOrderableSizes,
                desiredSize: desiredSize,
                onChange: onChange
            }),
            categoryId && !isModalSizeOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,css.tw)([
                            "flex",
                            (0,css/* css */.iv)({
                                ">.fitanalytics__button.primary": {
                                    marginLeft: "unset !important",
                                    marginRight: "0.75 rem"
                                }
                            }), 
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonUnderline */.xnB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* FITANALYTICS_FIT_FINDER_PLACEMENT */.YC), {
                            label: t("sizeGuide"),
                            icon: "ruler",
                            size: "sm",
                            transform: "uppercase",
                            iconEnd: true,
                            onClick: function() {
                                pageviewEventHasFired && triggerEvent();
                                setShowSizeGuide(true);
                            },
                            className: "min-h-6"
                        }))
                    }),
                    showSizeGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeGuide, {
                        sizeChartId: sizeChartId,
                        categoryId: categoryId,
                        productMeasurements: productMeasurements,
                        onClickOutside: function() {
                            return setShowSizeGuide(false);
                        },
                        productDivision: productDivision
                    })
                ]
            }),
            !useStockInfoRedesign && showStockMessageBySFCCLogic && enableStockMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StockMessageSFCC/* StockMessageSFCC */.O, {
                selectedSize: selectedSize,
                quantity: inventory,
                addToCartReturnCode: addToCartReturnCode
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/index.ts





/***/ }),

/***/ 4692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ VideoOrImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86468);
/* harmony import */ var _SanityVideo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68020);




var VideoOrImage = function(props) {
    var header = props.header, video = props.video, mobileImage = props.mobileImage, image = props.image;
    if (video === null || video === void 0 ? void 0 : video.source) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SanityVideo__WEBPACK_IMPORTED_MODULE_3__/* .SanityVideo */ .m, {
            className: "absolute inset-0 h-full w-full object-cover object-center",
            video: video
        });
    }
    if (image || mobileImage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* .SanityImage */ .d, {
            source: image,
            mobileSource: mobileImage,
            defaultAlt: header
        });
    }
    return null;
};


/***/ }),

/***/ 48204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GM": function() { return /* binding */ ProductCarousel; },
/* harmony export */   "md": function() { return /* binding */ DEFAULT_PRODUCT_GRID_SIZE; }
/* harmony export */ });
/* unused harmony export DEFAULT_MOBILE_PRODUCT_GRID_SIZE */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79200);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var react_scrollbars_custom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23727);
/* harmony import */ var hooks_useHorizontalScroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42833);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37678);
/* harmony import */ var ui_components_RecommendationTile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43477);
/* harmony import */ var ui_content_CallToActions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85814);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39772);
/* harmony import */ var hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32736);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53625);
/* harmony import */ var ui_components_ChevronButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24393);
/* harmony import */ var hooks_useIsCrawler__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32239);
/* harmony import */ var hooks_usePdp__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41316);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83168);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20368);
/* harmony import */ var hooks_useProductClickHandling__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7362);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43308);
/* harmony import */ var ui_components_Skeleton__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98463);
/* harmony import */ var hooks_useIsServer__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(64724);
/* harmony import */ var _ContentHeading__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(83057);


























var isSanityProduct = function(product) {
    return product._type === "product";
};
var transformSanityProduct = function(product) {
    return {
        id: product.masterId + "_" + product.color,
        masterId: product.masterId,
        variantId: product.productId,
        name: product.productName
    };
};
var DEFAULT_MOBILE_PRODUCT_GRID_SIZE = "repeat(@{itemCount}, calc(50% - 1rem))";
var DEFAULT_PRODUCT_GRID_SIZE = "repeat(@{itemCount}, calc(50% - 3rem))";
var DEFAULT_SKELETONS = 5;
/**
 * Transforms a given grid template into `gridTemplateColumn` Tailwind classes for desktop, tablet, and mobile.
 * Instances of the `'@{itemCount}'` placeholder are replaced with the actual number of items in the carousel.
 * The provided templates should be in the following format: `'repeat(@{itemCount}, calc(50% - 3rem))'`.
 * `'calc(50% - 3rem)'` indicates that 2 items are to be displayed with a 3rem peek of the subsequent item.
 * @param template - The grid template to transform.
 * @param itemCount - The number of items in the carousel.
 */ var transformGridColumnTemplate = function(template, itemCount) {
    var replaceItemCount = function() {
        var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_PRODUCT_GRID_SIZE;
        return str.replaceAll("@{itemCount}", itemCount.toString());
    };
    var gridTemplateColumns = {
        desktop: {
            gridTemplateColumns: replaceItemCount(template.desktop)
        },
        tablet: {
            gridTemplateColumns: replaceItemCount(template.tablet)
        },
        mobile: {
            gridTemplateColumns: replaceItemCount(template.mobile)
        }
    };
    return {
        desktop: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(gridTemplateColumns.desktop),
        tablet: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(gridTemplateColumns.tablet),
        mobile: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(gridTemplateColumns.mobile)
    };
};
var ProductCarousel = function(_param) {
    var cta = _param.cta, gridTemplateColumnConfig = _param.gridTemplateColumnConfig, header = _param.header, inSideBySide = _param.inSideBySide, products = _param.products, recommendationsKOP = _param.recommendationsKOP, fromRecommender = _param.fromRecommender, stackProductInfo = _param.stackProductInfo, isMiniCart = _param.isMiniCart, headingTag = _param.headingTag, skeletonOnly = _param.skeletonOnly, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_param, [
        "cta",
        "gridTemplateColumnConfig",
        "header",
        "inSideBySide",
        "products",
        "recommendationsKOP",
        "fromRecommender",
        "stackProductInfo",
        "isMiniCart",
        "headingTag",
        "skeletonOnly"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    // it's possible that the data from sanity contains duplicate products, and so
    // we need to ensure we de-duplicate these
    var isServer = (0,hooks_useIsServer__WEBPACK_IMPORTED_MODULE_20__/* .useIsServer */ .w)();
    var styleNumbers = [];
    var uniqueProducts = [];
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_18__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var isCrawler = (0,hooks_useIsCrawler__WEBPACK_IMPORTED_MODULE_13__/* .useIsCrawler */ .i)();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var product = _step.value;
            var colorValue = isSanityProduct(product) ? product.color : product.colorValue || /* istanbul ignore next */ product.color;
            var styleNumber = "".concat(product.masterId, "_").concat(colorValue);
            // already seen this style number; ignore this product
            if (styleNumbers.includes(styleNumber)) continue;
            styleNumbers.push(styleNumber);
            uniqueProducts.push(product);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useVariantsQuery */ .kii)({
        variables: {
            input: {
                styleNumberIds: styleNumbers
            }
        },
        pause: products.length === 0 || isServer && !isCrawler || skeletonOnly
    }), 1), variantsResult = ref6[0];
    var ref7 = (0,hooks_useHorizontalScroll__WEBPACK_IMPORTED_MODULE_5__/* .useHorizontalScroll */ .m)({
        infinite: false
    }), ref8 = ref7.ref, hasPrev = ref7.hasPrev, hasNext = ref7.hasNext, next = ref7.next, prev = ref7.prev;
    var ref9;
    // whilst the variants are loading, we'll use the products from Sanity to
    // display a skeleton loader for each item
    var items = (ref9 = (ref = variantsResult.data) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref9 !== void 0 ? ref9 : uniqueProducts.map(function(product) {
        return isSanityProduct(product) ? transformSanityProduct(product) : product;
    });
    var isDesktop = (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .getIsDesktop */ .w)();
    var isMobile = (0,utils_media__WEBPACK_IMPORTED_MODULE_9__/* .getIsMobile */ .W)();
    var showAllPrices = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_11__/* .useFeature */ .S)("SHOW_ALL_PRICES_AT_ONCE");
    var isSpecificPriceLayout = stackProductInfo || showAllPrices;
    var ctaLinkProps = {
        variant: _generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .LinkVariant.White */ .rxY.White
    };
    var gridClasses = function(length) {
        return (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)([
            "grid gap-2 desktop:gap-4 pb-8 mb-4 md:overflow-x-auto",
            gridTemplateColumnConfig ? transformGridColumnTemplate(gridTemplateColumnConfig, length) : transformGridColumnTemplate({
                mobile: DEFAULT_MOBILE_PRODUCT_GRID_SIZE,
                tablet: DEFAULT_PRODUCT_GRID_SIZE,
                desktop: "repeat(@{itemCount}, calc(25% - 2rem))"
            }, length), 
        ]);
    };
    var productInfoConfig = {
        containerClassName: "mobile:flex-col tablet:flex-col desktop:".concat(isSpecificPriceLayout ? "flex-col" : "flex-row"),
        priceContainerClassName: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)("mobile:items-start tablet:items-start desktop:".concat(isSpecificPriceLayout ? "items-start" : "items-end"), stackProductInfo && "text-sm"),
        productTitleContainerClassName: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)([
            stackProductInfo && "text-sm",
            showAllPrices && "mb-4", 
        ])
    };
    var currency = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_16__/* .useSiteConfig */ .N)().currency;
    var pdp = (0,hooks_usePdp__WEBPACK_IMPORTED_MODULE_14__/* .usePdp */ .Y)();
    var itemListId = props._id || (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderId) || "";
    var itemListName = props._type || (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName) || "";
    var listItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref1;
        if (!((ref = variantsResult.data) === null || ref === void 0 ? void 0 : ref.variants) || variantsResult.fetching) return [];
        return (ref1 = variantsResult.data) === null || ref1 === void 0 ? void 0 : ref1.variants.map(function(product, index) {
            return (0,utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .transformListProductToAnalyticsItem */ .pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: undefined
                },
                itemListId: itemListId,
                itemListName: itemListName,
                index: index
            });
        });
    }, [
        variantsResult.fetching,
        (ref1 = variantsResult.data) === null || ref1 === void 0 ? void 0 : ref1.variants,
        currency.code,
        itemListId,
        itemListName, 
    ]);
    var gaTrackData = {
        id: ((ref2 = props.puid) === null || ref2 === void 0 ? void 0 : ref2.current) || (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName) || "",
        name: header || "",
        creative: "product-carousel",
        campaign: props.campaignId || "",
        position: ""
    };
    var promotionTrackerPosition = (0,hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_10__/* .usePromotionView */ .Y)(ref8, gaTrackData, false, true).promotionTrackerPosition;
    // To differentiate in which carousel the click occurred.
    var setIsProductClicked = (0,hooks_useProductClickHandling__WEBPACK_IMPORTED_MODULE_17__/* .useProductClickHandling */ .g)();
    if (promotionTrackerPosition) {
        gaTrackData.position = promotionTrackerPosition;
    }
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), indexItems = ref10[0], setIndexItems = ref10[1];
    var scrollerTriggerEvent = function(entry) {
        if (entry === "left") {
            if (indexItems > 0) setIndexItems(indexItems - 1);
            prev();
            if (pageviewEventHasFired) (0,utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.THUMBNAIL_ARROW */ ._q.THUMBNAIL_ARROW,
                event_params: {
                    user_action: "left click",
                    item_id_ep: recommendationsKOP === null || recommendationsKOP === void 0 ? void 0 : recommendationsKOP.id,
                    item_name_ep: recommendationsKOP === null || recommendationsKOP === void 0 ? void 0 : recommendationsKOP.name
                }
            });
        } else if (entry === "right") {
            if (indexItems < items.length) setIndexItems(indexItems + 1);
            next();
            if (pageviewEventHasFired) (0,utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.THUMBNAIL_ARROW */ ._q.THUMBNAIL_ARROW,
                event_params: {
                    user_action: "right click",
                    item_id_ep: recommendationsKOP === null || recommendationsKOP === void 0 ? void 0 : recommendationsKOP.id,
                    item_name_ep: recommendationsKOP === null || recommendationsKOP === void 0 ? void 0 : recommendationsKOP.name
                }
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        if ((ref = variantsResult.data) === null || ref === void 0 ? void 0 : ref.variants) ref8 === null || ref8 === void 0 ? void 0 : (ref1 = ref8.current) === null || ref1 === void 0 ? void 0 : ref1.dispatchEvent(new Event("scroll"));
    }, [
        (ref3 = variantsResult.data) === null || ref3 === void 0 ? void 0 : ref3.variants,
        ref8
    ]);
    var intersectedProductsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    var intersectAllProductsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    var countProductsTriggeredRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var screenSizeCarousel = isDesktop ? 4 : 2;
    var itemEpId = (pdp === null || pdp === void 0 ? void 0 : (ref4 = pdp.masterProduct) === null || ref4 === void 0 ? void 0 : ref4.id) || "";
    var itemEpName = (pdp === null || pdp === void 0 ? void 0 : (ref5 = pdp.masterProduct) === null || ref5 === void 0 ? void 0 : ref5.name) || "";
    var handleIntersection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(productId) {
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .handleIntersectionCarousel */ .eW)({
            productId: productId,
            intersectedProductsRef: intersectedProductsRef,
            intersectAllProductsRef: intersectAllProductsRef,
            pageviewEventHasFired: pageviewEventHasFired,
            itemEpId: itemEpId,
            itemEpName: itemEpName,
            itemListId: itemListId,
            itemListName: itemListName,
            screenSizeCarousel: screenSizeCarousel,
            listProducts: listItems,
            countProductsTriggeredRef: countProductsTriggeredRef
        });
    }, [
        itemEpId,
        itemEpName,
        itemListId,
        itemListName,
        listItems,
        pageviewEventHasFired,
        screenSizeCarousel, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!ref8.current) return;
        var options = {
            root: null,
            rootMargin: "1px",
            threshold: 0.5
        };
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var productId = entry.target.getAttribute("data-product-id");
                    if (productId) handleIntersection(productId);
                }
            });
        }, options);
        var itemsToObserve = ref8.current.querySelectorAll('[data-test-id="recommended-product-item"]');
        itemsToObserve.forEach(function(item) {
            observer.observe(item);
        });
        return function() {
            itemsToObserve.forEach(function(item) {
                observer.unobserve(item);
            });
            observer.disconnect();
        };
    }, [
        handleIntersection,
        ref8
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "group relative w-full",
        "aria-label": header || undefined,
        "data-test-id": "recommendations",
        onClick: function() {
            return isMiniCart && (0,utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_15__/* .AnalyticsEvents.MINICART */ ._q.MINICART,
                event_params: {
                    user_action: "recommended product"
                }
            });
        },
        children: [
            (!variantsResult.fetching && items.length > 0 || variantsResult.fetching) && header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentHeading__WEBPACK_IMPORTED_MODULE_21__/* .ContentHeading */ .H, {
                header: header,
                className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)("font-bold pb-4 text-uppercase flex justify-between", "text-lg sm:text-2xl", inSideBySide && "leading-5 items-center"),
                headingTag: headingTag,
                dataTestId: "recommend-header-text",
                children: cta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_content_CallToActions__WEBPACK_IMPORTED_MODULE_8__/* .CallToActions */ .l, {
                    className: "whitespace-nowrap font-normal pr-0 text-".concat(isMobile ? "xs" : "sm"),
                    ctas: cta,
                    linkProps: ctaLinkProps,
                    gaBannerData: gaTrackData
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        width: "1em",
                        height: "37px"
                    }
                })
            }),
            items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scrollbars_custom__WEBPACK_IMPORTED_MODULE_4__/* .Scrollbar */ .LW, {
                        translateContentSizeYToHolder: true,
                        removeTracksWhenNotUsed: true,
                        disableTracksWidthCompensation: true,
                        disableTrackYMousewheelScrolling: true,
                        trackXProps: {
                            renderer: function(props) {
                                var elementRef = props.elementRef, style = props.style, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(props, [
                                    "elementRef",
                                    "style"
                                ]);
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, restProps), {
                                    ref: elementRef,
                                    className: "TrackX",
                                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, style), {
                                        height: 6,
                                        left: 0,
                                        width: "100%"
                                    })
                                }));
                            }
                        },
                        scrollerProps: {
                            renderer: function(props) {
                                var elementRef = props.elementRef, style = props.style, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(props, [
                                    "elementRef",
                                    "style"
                                ]);
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, restProps), {
                                    ref: elementRef,
                                    className: "MyAwesomeScrollbarsScroller" // Default library className
                                    ,
                                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, style), {
                                        scrollSnapType: "x mandatory",
                                        scrollBehavior: "smooth"
                                    })
                                }));
                            }
                        },
                        contentProps: {
                            renderer: function(props) {
                                var elementRef = props.elementRef, style = props.style, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(props, [
                                    "elementRef",
                                    "style"
                                ]);
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, restProps), {
                                    ref: elementRef,
                                    className: "Content pb-4",
                                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, style), {
                                        display: "block"
                                    })
                                }));
                            }
                        },
                        thumbXProps: {
                            renderer: function(props) {
                                var elementRef = props.elementRef, style = props.style, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(props, [
                                    "elementRef",
                                    "style"
                                ]);
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, restProps), {
                                    ref: elementRef,
                                    className: "ThUmBX",
                                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, style), {
                                        background: "rgba(0, 0, 0, 0.65)"
                                    })
                                }));
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: ref8,
                            "data-test-id": "recommendation-product-carousel",
                            className: gridClasses(items.length),
                            onClick: function() {
                                return setIsProductClicked(true);
                            },
                            children: items.map(function(item, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_RecommendationTile__WEBPACK_IMPORTED_MODULE_7__/* .RecommendationTile */ .I, {
                                    containerClassName: "flex-shrink-0 w-full",
                                    dataTestId: "recommended-product-item",
                                    linkClassName: "flex w-full relative",
                                    fromRecommender: fromRecommender,
                                    product: item,
                                    productInfoConfig: productInfoConfig,
                                    gaBannerData: gaTrackData,
                                    fetching: variantsResult.fetching,
                                    isFromMiniCart: isMiniCart,
                                    itemListId: props._id,
                                    itemListName: props._type,
                                    position: idx
                                }, item.id);
                            })
                        })
                    }),
                    hasPrev && isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ChevronButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: "invisible group-hover:visible mobile:hidden tablet:hidden absolute -left-2 top-1/2 transform -translate-y-1/2",
                        direction: "left",
                        onClick: function() {
                            return scrollerTriggerEvent("left");
                        },
                        invert: true
                    }),
                    hasNext && isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ChevronButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: "invisible group-hover:visible mobile:hidden tablet:hidden absolute -right-2 top-1/2 transform -translate-y-1/2",
                        direction: "right",
                        onClick: function() {
                            return scrollerTriggerEvent("right");
                        },
                        invert: true
                    })
                ]
            }) : variantsResult.fetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kqy, {
                className: gridClasses(DEFAULT_SKELETONS),
                children: Array.from({
                    length: DEFAULT_SKELETONS
                }, function(_, i) {
                    return i + 1;
                }).map(function(_, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Skeleton__WEBPACK_IMPORTED_MODULE_19__/* .Skeleton */ .O, {
                        className: "w-full aspect-1-1"
                    }, "skeleton-".concat(idx));
                })
            })
        ]
    });
};


/***/ }),

/***/ 30664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ ProductRecommender; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./utils/extractProductVariants.ts
var extractProductVariants = __webpack_require__(71926);
// EXTERNAL MODULE: ./ui/content/ProductCarousel.tsx
var ProductCarousel = __webpack_require__(48204);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./ui/components/RecommendationTile.tsx
var RecommendationTile = __webpack_require__(43477);
// EXTERNAL MODULE: ./hooks/usePdp.tsx + 1 modules
var usePdp = __webpack_require__(41316);
// EXTERNAL MODULE: ./hooks/useItemListViewEvent.ts
var useItemListViewEvent = __webpack_require__(35538);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
;// CONCATENATED MODULE: ./ui/components/ProductGrid.tsx









var ProductGrid = function(param) {
    var header = param.header, products = param.products, fromRecommender = param.fromRecommender;
    var ref, ref1;
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var pdp = (0,usePdp/* usePdp */.Y)();
    var listItems = (0,react.useMemo)(function() {
        if (!products) return [];
        return products.map(function(product, index) {
            return (0,analytics/* transformListProductToAnalyticsItem */.pD)({
                product: product,
                currency: currency.code,
                quantity: 1,
                categories: {
                    item_category: product.primaryCategoryId
                },
                itemListId: fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderId,
                itemListName: fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName,
                index: index
            });
        });
    }, [
        products,
        currency.code,
        fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderId,
        fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName, 
    ]);
    var itemListId = (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderId) || "";
    var itemListName = (fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName) || "";
    (0,useItemListViewEvent/* useItemListViewEvent */.t)({
        itemListId: itemListId,
        itemListName: itemListName,
        itemIdEp: pdp === null || pdp === void 0 ? void 0 : (ref = pdp.masterProduct) === null || ref === void 0 ? void 0 : ref.id,
        itemNameEp: pdp === null || pdp === void 0 ? void 0 : (ref1 = pdp.masterProduct) === null || ref1 === void 0 ? void 0 : ref1.name,
        items: listItems
    });
    var ref2 = (0,useGA4Events/* useGA4Events */.tL)(), product = ref2.product, fireSelectItemEvent = ref2.fireSelectItemEvent;
    (0,react.useEffect)(function() {
        if (product) {
            fireSelectItemEvent();
        }
    }, [
        product,
        fireSelectItemEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-t hidden empty:hidden mobile:block tablet:block desktop:block",
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-bold text-xl sm:text-2xl pb-4 text-uppercase my-4",
                "data-test-id": "recommend-grid-header-text",
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-test-id": "recommendation-product-list",
                className: (0,css.tw)("grid gap-x-4 gap-y-8 transition-opacity duration-700", "grid-cols-2", "sm:grid-cols-3", "lg:grid-cols-4"),
                children: products === null || products === void 0 ? void 0 : products.map(function(product, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTile/* RecommendationTile */.I, {
                        containerClassName: "h-full justify-between",
                        dataTestId: "recommended-product-item",
                        linkClassName: "text-center text-xs",
                        product: product,
                        fromRecommender: fromRecommender,
                        position: idx
                    }, product.id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useGetRecommenderLocation.tsx
var useGetRecommenderLocation = __webpack_require__(16666);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/content/ProductRecommender.tsx















var ProductRecommender = function(param) {
    var cta = param.cta, gridTemplateColumnConfig = param.gridTemplateColumnConfig, header = param.header, ids = param.ids, inSideBySide = param.inSideBySide, showAsGrid = param.showAsGrid, stackProductInfo = param.stackProductInfo, type = param.type, _isMiniCart = param.isMiniCart, isMiniCart = _isMiniCart === void 0 ? false : _isMiniCart;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var cart = (0,useCart/* useCart */.j)().cart;
    var useMasterIdsInCartRecommenders = (0,useFeature/* useFeature */.S)("USE_MASTER_IDS_IN_CART_RECOMMENDERS");
    var ref6 = (0,react.useState)(ids), recommenderIds = ref6[0], setRecommenderIds = ref6[1];
    var category = router.query.category;
    var categoryId = Array.isArray(category) ? category.join("-") : category;
    var productId = router.query.id;
    var recommenderLocation = (0,useGetRecommenderLocation/* useGetRecommenderLocation */.g)();
    (0,react.useEffect)(function() {
        if (!useMasterIdsInCartRecommenders || recommenderLocation() !== "/cart" || recommenderIds) return;
        var cartProducts = (cart === null || cart === void 0 ? void 0 : cart.products) || [];
        var masterProductIds = cartProducts.filter(function(x) {
            return x.__typename === "ProductCartItem";
        }).map(function(x) {
            return x.product.masterId;
        });
        setRecommenderIds(masterProductIds);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.products,
        recommenderLocation,
        useMasterIdsInCartRecommenders,
        recommenderIds, 
    ]);
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRecommendationsWithDetailsQuery */.MA5)({
        variables: {
            pageType: type,
            ids: recommenderIds !== null && recommenderIds !== void 0 ? recommenderIds : [
                categoryId,
                productId
            ].filter(Boolean)
        },
        pause: isServer && !isCrawler
    }), 1), result = ref7[0];
    var recommendations = (ref = result.data) === null || ref === void 0 ? void 0 : ref.recommendationsWithDetails.recommendations;
    var recommendationsKOP = {
        id: (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.recommendationsWithDetails.recommenderId,
        name: (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.recommendationsWithDetails.recommenderName
    };
    // If displaying the recommendations on a PDP - exclude the product shown on a PDP
    var recommendationsWithoutCurrentProduct = recommendations === null || recommendations === void 0 ? void 0 : recommendations.filter(function(rec) {
        return (rec === null || rec === void 0 ? void 0 : rec.masterId) !== productId;
    });
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = result.data) === null || ref === void 0 ? void 0 : ref.recommendationsWithDetails.recommenderName) && !showAsGrid) {
            var ref1;
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PRODUCT_RECOMMENDER_VIEWED */._q.PRODUCT_RECOMMENDER_VIEWED, {
                ecommerce: {
                    productRecommenderLocation: recommenderLocation(),
                    recommenderName: (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.recommendationsWithDetails.recommenderName
                }
            });
        }
    }, [
        recommenderLocation,
        (ref3 = result.data) === null || ref3 === void 0 ? void 0 : ref3.recommendationsWithDetails.recommenderName,
        showAsGrid, 
    ]);
    if ((recommendationsWithoutCurrentProduct === null || recommendationsWithoutCurrentProduct === void 0 ? void 0 : recommendationsWithoutCurrentProduct.length) === 0) return null;
    if (showAsGrid && ((ref4 = result.data) === null || ref4 === void 0 ? void 0 : ref4.recommendationsWithDetails)) {
        var ref8;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid, {
            id: "product-recommendation-grid",
            _id: "product-recommendation-grid",
            header: header || t("youMayAlsoLike"),
            products: (0,extractProductVariants/* extractProductVariants */.b)(recommendationsWithoutCurrentProduct),
            fromRecommender: (ref8 = result.data) === null || ref8 === void 0 ? void 0 : ref8.recommendationsWithDetails
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel/* ProductCarousel */.GM, {
        cta: cta,
        gridTemplateColumnConfig: gridTemplateColumnConfig,
        header: header || t("recommendedForYou"),
        id: "ProductRecommender-".concat(type),
        _id: "ProductRecommender-".concat(type),
        inSideBySide: inSideBySide,
        products: (0,extractProductVariants/* extractProductVariants */.b)(recommendationsWithoutCurrentProduct),
        recommendationsKOP: recommendationsKOP,
        fromRecommender: (ref5 = result.data) === null || ref5 === void 0 ? void 0 : ref5.recommendationsWithDetails,
        isMiniCart: isMiniCart,
        stackProductInfo: stackProductInfo
    });
};


/***/ }),

/***/ 99671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SafeHtml; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);



var SafeHtml = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "div" : _as, html = _param.html, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "as",
        "html"
    ]);
    var Tag = "".concat(as);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            dangerouslySetInnerHTML: {
                __html: html
            }
        }, props))
    });
};


/***/ }),

/***/ 97729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ constructCategoryPath; }
/* harmony export */ });
var constructCategoryPath = function(category) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (category) {
        if (category.parentCategory) {
            constructCategoryPath(category.parentCategory, path);
        }
        path.push({
            label: category.name,
            url: category.url
        });
    }
    return path;
};


/***/ }),

/***/ 48604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ areDeepEqual; }
/* harmony export */ });
var areDeepEqual = function(firstElement, secondElement) {
    return JSON.stringify(firstElement) === JSON.stringify(secondElement);
};


/***/ }),

/***/ 14106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getPreviewInput; }
/* harmony export */ });
var getPreviewInput = function(routerQuery) {
    var ref;
    return {
        viewAt: routerQuery.viewAt,
        customerGroups: (ref = routerQuery.customerGroups) === null || ref === void 0 ? void 0 : ref.split(","),
        global: routerQuery.global === "true"
    };
};


/***/ }),

/***/ 22649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isAppExclusiveValidRange; }
/* harmony export */ });
var isAppExclusiveValidRange = function(isAppOnly, appOnlyDateTimeFrom, appOnlyDateTimeTo) {
    if (!isAppOnly) return false;
    var currentDate = Date.now();
    var fromDateValid = appOnlyDateTimeFrom ? new Date(appOnlyDateTimeFrom).getTime() < currentDate : true;
    var toDateValid = appOnlyDateTimeTo ? new Date(appOnlyDateTimeTo).getTime() > currentDate : true;
    return fromDateValid && toDateValid;
};


/***/ }),

/***/ 74067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JD": function() { return /* binding */ removeReferrerTypeAndCategory; },
/* harmony export */   "Sl": function() { return /* binding */ setReferrerType; },
/* harmony export */   "ns": function() { return /* binding */ setReferrerCategory; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

var setReferrerType = function(type) {
    localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_TYPE */ .cj, type);
    localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_CATEGORY */ .qh);
};
var setReferrerCategory = function(category) {
    localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_CATEGORY */ .qh, category);
    localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_TYPE */ .cj);
};
var removeReferrerTypeAndCategory = function() {
    localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_TYPE */ .cj);
    localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REFERRER_CATEGORY */ .qh);
};


/***/ }),

/***/ 47802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ removeHyphens; }
/* harmony export */ });
var removeHyphens = function(text) {
    return text.replace(/-/g, " ").replace(/([0-9])\s([0-9])/, "$1-$2");
};


/***/ })

}]);